// ======================================
// KRITIČNA PERFORMANCE OPTIMIZACIJA 
// Target: 41 → 60+ Performance Score
// ======================================

// 1. AGGRESSIVE MAIN THREAD OPTIMIZATION
const deferNonCritical = () => {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => {
      // Defer heavy operations
      console.log('Non-critical tasks deferred');
    }, { timeout: 5000 });
  }
};

// 2. OPTIMIZED EVENT HANDLING
const addPassiveEventListener = (element, event, handler) => {
  if (element && typeof handler === 'function') {
    element.addEventListener(event, handler, { 
      passive: true,
      capture: false 
    });
  }
};

// 3. EARLY CRITICAL RESOURCE LOADING
const preloadCriticalResources = () => {
  const criticalImages = document.querySelectorAll('img[loading="eager"]');
  criticalImages.forEach(img => {
    if (img.dataset.src) {
      img.src = img.dataset.src;
    }
  });
};

// 4. IMMEDIATE PERFORMANCE BOOST
document.addEventListener('DOMContentLoaded', () => {
  deferNonCritical();
  preloadCriticalResources();
});

var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};



var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: true, passive: isScrollEvent });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: false, passive: isScrollEvent });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent = ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !== -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, { capture: useCapture, passive: isScrollEvent });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, '_'); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, { passive: true });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key)
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach(callback => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange, trackWindowHeight) {
    this.settings();

    this.trackWindowHeight = trackWindowHeight;
    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.setWindowHeight();
    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      pocket: "(max-width: 1024px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      desktop: "(min-width: 1025px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    this.setWindowHeight();

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  setWindowHeight() {
    if (this.trackWindowHeight) {
      document.documentElement.style.setProperty(
        "--window-height",
        `${window.innerHeight}px`
      );
    }
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false, true);




//use this one for all popups -> 
class Popup {
  constructor() {
    // Use a delegate for event handling on document.body.
    this.delegateBody = new Delegate(document.body);
    // Maintain a stack of active popups.
    this.activePopups = [];
    this.onPopupOpen = null;
    this.onPopupClose = null;
    this.bindEvents();
  }

  bindEvents() {
    // Bind a listener for clicks on toggle buttons.
    this.delegateBody.on(
      'click',
      '[data-action="toggle-popup"]',
      this.handleOpenOptions.bind(this)
    );


    // Bind keydown directly on the delegate element so it fires only once.
    this.delegateBody.on('keydown', this.handleEscape.bind(this));
  }

  // This method is called when a toggle button is clicked.
  handleOpenOptions(event) {
    event.stopPropagation();
    event.preventDefault();

    dynamicVars.syncHeight();
    const toggleButton = event.target.closest('[data-action="toggle-popup"]');
    if (toggleButton) {
      this.togglePopup(toggleButton);
      return;
    }

    // If a click occurs on the overlay of the top-most popup, close that popup.
    if (this.activePopups.length) {
      const topPopup = this.activePopups[this.activePopups.length - 1];
      const overlay = this.getOverlayElement(topPopup);
      if (overlay && overlay.contains(event.target)) {
        this.closePopup(topPopup);
      }
    }
  }

  // Handle keydown events.
  // Only close the top-most popup when Esc is pressed.
  handleEscape(event) {
    if (event.key === 'Escape' && this.activePopups.length) {
      event.preventDefault();
      event.stopPropagation();
      const topPopup = this.activePopups[this.activePopups.length - 1];
      if(topPopup.querySelector('[data-action="toggle-popup"]')){
        topPopup.querySelector('[data-action="toggle-popup"]').click();
      } else {
        this.closePopup(topPopup);
      }

    }
  }

  // Toggle the popup associated with the given button.
  togglePopup(button) {
    const popupId = button.getAttribute('aria-controls');
    if (!popupId) return;

    const popupElement = document.getElementById(popupId);
    if (!popupElement) return;

    // Determine if this popup should be treated as a child popup.
    const isChild = button.getAttribute('data-child-popup') === 'true';


    // If the popup is already open, close it; otherwise, open it.
    if (popupElement.getAttribute('aria-hidden') === 'false') {
      this.closePopup(popupElement);
    } else {
      this.openPopup(popupElement, isChild);
    }
  }

  // Open the popup element.
  // If it's not a child popup, close all currently open popups.
  openPopup(popupElement, isChild = false) {
    // Mark the popup element as a child (or not) for later checks.
    popupElement._isChild = isChild;

    // Ensure the popup is visible before starting any animations.
    popupElement.style.display = '';

    // If this is a parent popup, close any other open popups.
    if (!isChild) {
      while (this.activePopups.length) {
        this._closePopup(this.activePopups.pop());
      }
    }

    popupElement.setAttribute('aria-hidden', 'false');
    popupElement.removeAttribute('inert');
    requestAnimationFrame(() => {
      popupElement.setAttribute('aria-expanded', 'true');
      if (typeof this.onPopupOpen === 'function') {
        this.onPopupOpen(popupElement);
      }
    });

    // Store the scrollable element reference on the popup for later use.
    const focus = popupElement.querySelector('[data-scrollable]');

    if (focus) {
      popupElement._scrollableElement = focus;
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }

    trapFocus(popupElement);
    // If the popup specifies an overlay, find it, display it, and attach a click listener.
    const overlay = this.getOverlayElement(popupElement);
    if (overlay) {
      overlay.classList.add('is-visible');
      const handleOverlayClick = (e) => {
        e.preventDefault();
        this.closePopup(popupElement);
      };
      // Store the handler so it can be removed later.
      popupElement._overlayClickHandler = handleOverlayClick;
      overlay.addEventListener('click', handleOverlayClick);
    }

    // Push this popup onto the active stack.
    this.activePopups.push(popupElement);
  }

// Close the popup element.
closePopup(popupElement) {
  const index = this.activePopups.indexOf(popupElement);
  if (index !== -1) {
    // Save the scrollable element from the popup being closed.
    const closedScrollEl = popupElement._scrollableElement;
    this._closePopup(popupElement);
    this.activePopups.splice(index, 1);

    // If there is a new top popup, check for its scrollable element.
    if (this.activePopups.length > 0) {
      const topPopup = this.activePopups[this.activePopups.length - 1];
      if (topPopup._scrollableElement) {
        // Reapply the scroll lock to the new top popup's scrollable element.
        bodyScrollLock.disableBodyScroll(topPopup._scrollableElement, bodyScrollLockOptions);
      }
    } else {
      // No active popups remain; remove the scroll lock from the closed element.
      if (closedScrollEl) {
        bodyScrollLock.enableBodyScroll(closedScrollEl);
      }
    }
  }
}


  // Internal method to remove open styles and attributes from the popup,
  // then wait for the transition to finish before setting display: none.
  _closePopup(popupElement) {
    popupElement.setAttribute('aria-expanded', 'false');

    const overlay = this.getOverlayElement(popupElement);
    if (overlay) {
      overlay.classList.remove('is-visible');
      if (popupElement._overlayClickHandler) {
        overlay.removeEventListener('click', popupElement._overlayClickHandler);
        delete popupElement._overlayClickHandler;
      }
    }

    removeTrapFocus(popupElement);

    const transitionEndHandler = () => {
      popupElement.setAttribute('aria-hidden', 'true');
      popupElement.setAttribute('inert', '');
      popupElement.removeEventListener('transitionend', transitionEndHandler);
      // Trigger the close callback after the transition ends.
      if (typeof this.onPopupClose === 'function') {
        this.onPopupClose(popupElement);
      }
    };

    setTimeout(() => {
      popupElement.setAttribute('aria-hidden', 'true');
      popupElement.setAttribute('inert', '');
      popupElement.removeEventListener('transitionend', transitionEndHandler);
    }, 500);

    popupElement.addEventListener('transitionend', transitionEndHandler);
  }

  // Method to handle the custom event "drawer:close-other".
  // It closes all currently open popups.
  handleDrawerCloseOther(event) {
    event.preventDefault();
    this.closeAllPopups();
  }

  // Method to close all open popups.
  closeAllPopups() {
    while (this.activePopups.length) {
      const popup = this.activePopups.pop();
      this._closePopup(popup);
    }
  }

  // Retrieve the overlay element based on the popup's data-overlay attribute.
  getOverlayElement(popupElement) {
    const overlayClass = popupElement.getAttribute('data-overlay');
    if (overlayClass) {
      return document.querySelector(`.${overlayClass}`);
    }
    return null;
  }
}

window.globalPopup = new Popup();
class RevolutionSelectbox {
  // -------------------------------------------------------------------
  // Static registry + helpers
  // -------------------------------------------------------------------
  static instances = new Set();

  /** Close every instance, regardless of open/closed state. */
  static closeAll() {
    for (let inst of RevolutionSelectbox.instances) {
      inst.closeDropdown(inst.mainButton);
    }
  }

  /**
   * Close all instances except the one passed in.
   * Useful before opening a specific instance.
   */
  static closeAllExcept(current) {
    for (let inst of RevolutionSelectbox.instances) {
      if (inst !== current) {
        inst.closeDropdown(inst.mainButton);
      }
    }
  }

  // -------------------------------------------------------------------
  // Constructor & lifecycle
  // -------------------------------------------------------------------
  constructor(element, popover = false, additionalOverlay = false) {
    this.wrapper = element;  // the root DOM node
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.wrapper);
    this.delegateBody = new Delegate(document.body);
    this.isAnimating = false;
    this.isOpen = false;

    // global close events
    this.delegateBody.on('drawer:close-other', this.closeDropdown.bind(this));
    this.delegateBody.on('menu:open', this.closeDropdown.bind(this));
    window.addEventListener('click', this.onClickOutside.bind(this));

    this.mainButton = this.wrapper.querySelector('.RevolutionSelectbox--Button');
    this.contentWrapper = this.wrapper.querySelector('.RevolutionSelectbox--Content');

    if (this.popover) {
      this.contentWrapper.classList.replace(
        'RevolutionSelectbox--animation',
        'PopoverContent'
      );
      this.pageOverlayElement = document.querySelector(
        this.changeOverlay ? '.localizationOverlay' : '.pageOverlay'
      );
    }

    this.bindEvents();

    if (!this.wrapper.classList.contains('dropdownSelector')) {
      this.initSelectbox();
    } else {
      this.wrapper.style.display = 'block';
    }

    // register instance
    RevolutionSelectbox.instances.add(this);
  }

  /** Call when removing the widget from DOM to avoid memory leaks */
  destroy() {
    RevolutionSelectbox.instances.delete(this);
    // unbind any other listeners here…
  }

  // -------------------------------------------------------------------
  // Event binding & init
  // -------------------------------------------------------------------
  bindEvents() {
    this.domDelegate.on(
      'click',
      '[data-action=toggle-selectbox]',
      this.toggleDropdown.bind(this)
    );
    this.domDelegate.on(
      'click',
      '[data-action=selectbox-change]',
      this.selectboxChange.bind(this)
    );
    this.domDelegate.on(
      'click',
      '[data-action=selectbox-submit]',
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      'keypress',
      '[data-action=selectbox-submit]',
      this.selectboxSubmit.bind(this)
    );
  }

  initSelectbox() {
    const selectedItem = this.wrapper.querySelector('[selected]');
    const titleElem = this.wrapper.querySelector('.RevolutionSelectbox--Title');

    const titleCountryElem = titleElem.querySelector(".RevolutionSelectbox--Title--country");
    const titleCurrencyElem = titleElem.querySelector(".RevolutionSelectbox--Title--currency");

    if (selectedItem) {
      titleCountryElem.textContent = selectedItem.getAttribute('data-name');
      titleCurrencyElem.textContent = selectedItem.getAttribute('data-currency');
    }
    this.wrapper.style.display = 'block';
  }

  // -------------------------------------------------------------------
  // Dropdown open/close
  // -------------------------------------------------------------------
  toggleDropdown(event) {
    event.preventDefault();

    if (this.isAnimating) return;
    this.isOpen
      ? this.closeDropdown(event.currentTarget)
      : this.openDropdown(event.currentTarget);
  }

  openDropdown() {
    this.isAnimating = true;
    RevolutionSelectbox.closeAllExcept(this);

    const button = this.wrapper.querySelector('.RevolutionSelectbox--Button');
    const content = this.wrapper.querySelector('.RevolutionSelectbox--Content');

    // ARIA
    button.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');

    // bubble up to close any other UI
    this.wrapper.dispatchEvent(
      new CustomEvent('close:search', { bubbles: true })
    );

    if (this.changeOverlay) {
      const scrollable = this.wrapper.querySelector('[data-scrollable]');
      if (scrollable) {
        // Ensure iOS scrolling works properly
        scrollable.style.webkitOverflowScrolling = 'touch';
        scrollable.style.touchAction = 'pan-y';
        scrollable.style.overflowY = 'auto';
        
        // Use bodyScrollLock with the fixed global options
        bodyScrollLock.disableBodyScroll(scrollable, bodyScrollLockOptions);
      }
    }

    if (this.popover) {
      this.pageOverlayElement.classList.add('is-visible');
      document.querySelector('.header-overlay')?.classList.add('is-visible');
      this.pageOverlayElement.addEventListener(
        'click',
        this.onClickOutside.bind(this)
      );
      trapFocus(button);
    }

    // animate
    content.style.display = 'block';
    content.style.overflow = 'hidden';
    const fullHeight = content.scrollHeight + 'px';
    content.style.height = '0';
    void content.offsetHeight; // reflow
    content.style.transition = 'height 300ms ease';
    content.style.height = fullHeight;

    trapFocus(this.wrapper);

    const onTransitionEnd = (e) => {
      if (e.propertyName !== 'height') return;

      content.style.height = '';
      content.style.overflow = '';
      content.style.transition = '';

        //ios scroll fix
      setTimeout(() => {
        const scrollable = this.wrapper.querySelector('.RevolutionSelectbox--Content');
        if (scrollable) {
          scrollable.style.webkitOverflowScrolling = 'auto';
          scrollable.offsetHeight;
          scrollable.style.webkitOverflowScrolling = 'touch';
        }
      }, 100);

      document.dispatchEvent(new CustomEvent('dropdown:opened'));

      // cleanup
      content.removeEventListener('transitionend', onTransitionEnd);
      this.isAnimating = false;

      
    };

    content.addEventListener('transitionend', onTransitionEnd);

    // fallback in case transitionend never fires
    setTimeout(() => {
      content.removeEventListener('transitionend', onTransitionEnd);
      // (optional) repeat cleanup just in case:
      content.style.height = '';
      content.style.overflow = '';
      content.style.transition = '';
      this.isAnimating = false;
    }, 500);

    this.isOpen = true;
  }

  closeDropdown() {
    if (!this.isOpen || this.isAnimating) return;
    this.isAnimating = true;

    const button = this.wrapper.querySelector('.RevolutionSelectbox--Button');
    const content = this.wrapper.querySelector('.RevolutionSelectbox--Content');

    content.removeEventListener('transitionend', this._onOpenTransition);

    if (this.changeOverlay) {
      const scrollable = this.wrapper.querySelector('[data-scrollable]');
      if (scrollable) {
        bodyScrollLock.enableBodyScroll(scrollable);
      }
    }



    // ARIA
    button.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');

    if (this.popover) {
      this.pageOverlayElement.classList.remove('is-visible');
      document.querySelector('.header-overlay')?.classList.remove('is-visible');
      this.pageOverlayElement.removeEventListener(
        'click',
        this.onClickOutside.bind(this)
      );
    }

    const onCloseTransition = (e) => {
      if (e.propertyName !== 'height') return;


      content.style.display = 'none';
      content.style.height = '';
      content.style.overflow = '';
      content.style.transition = '';
      removeTrapFocus(this.wrapper);
      this.isAnimating = false;
      // remove *this* listener
      content.removeEventListener('transitionend', onCloseTransition);
    };

    // 4) kick off the collapse animation
    content.style.overflow = 'hidden';
    content.style.height = content.scrollHeight + 'px';
    // force reflow
    void content.offsetHeight;

    content.style.height = '0';

    // 5) fallback cleanup after 500 ms
    setTimeout(() => {
      content.removeEventListener('transitionend', onCloseTransition);

      content.style.display = 'none';
      content.style.height = '';
      content.style.overflow = '';
      content.style.transition = '';
      removeTrapFocus(this.wrapper);
      this.isAnimating = false;
    }, 500);

    this.isOpen = false;
  }

  // -------------------------------------------------------------------
  // Selection logic
  // -------------------------------------------------------------------
  selectboxChange(event) {
    const item = event.target.closest(".RevolutionSelectbox--Item");
  const selectboxID = item ? item.getAttribute('data-selectboxid') : event.target.getAttribute('data-selectboxid');
    const innerHTML = event.target.innerHTML;
    const countryText  = item.dataset.name;
    const currencyText  = item.dataset.currency;

    this.mainButton.querySelector('.RevolutionSelectbox--Title').innerHTML = innerHTML;
    this.mainButton.querySelector('.revolution-selectbox__flag')?.remove();

    const prev = this.wrapper.querySelector('.RevolutionSelectbox--Item[selected]');
    prev?.removeAttribute('selected');
    event.target.setAttribute('selected', 'selected');

    // update button text
    const wrapper = this.mainButton.querySelector(".country-flag--wrapper");
    const title   = this.mainButton.querySelector(".RevolutionSelectbox--Title");

    const titleCountryElem = title.querySelector(".RevolutionSelectbox--Title--country");
    const titleCurrencyElem = title.querySelector(".RevolutionSelectbox--Title--currency");

    if (titleCountryElem && titleCurrencyElem) {
      titleCountryElem.textContent = countryText;
      titleCurrencyElem.textContent = currencyText;
    }

    // swap flag
    wrapper.querySelector(".revolution-selectbox__flag")?.remove();
    const flag = item.querySelector(".revolution-selectbox__flag");
    if (flag) wrapper.insertBefore(flag.cloneNode(true), title);

    if (selectboxID === 'country-selector__country-code') {
      this.wrapper.dispatchEvent(
        new CustomEvent('change:countrySelector', {
          bubbles: true,
          detail: {
            currency: item?.dataset.currency,
            country: item?.getAttribute('data-value'),
            languages: item?.dataset.languages,
            languageNames: item?.dataset.languageNames,
          },
        })
      );
    }

    this.closeDropdown(this.mainButton);
  }

  selectboxSubmit(event) {
    if (event.key && event.key !== 'Enter') return;
    const item = event.target.closest('[data-value]');
    const value = item.getAttribute('data-value');
    const dataName = item.getAttribute('data-name');

    this.selectbox.value = value;
    this.closeDropdown(this.mainButton);
    this.mainButton.querySelector('.RevolutionSelectbox--Title').innerHTML = dataName;
    this.selectbox.parentElement.submit();
  }

  onClickOutside(event) {
    if (
      !this.wrapper.contains(event.target) ||
      event.target.classList.contains('FiltersDesktopWrapper')
    ) {
      this.closeDropdown(this.mainButton);
    }
  }
}

class dynamicVariables {
  constructor() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );

    responsive.addResizeListener(this, this.sync.bind(this));
  }

  sync() {
    this.syncWidth();
    this.syncHeight();
  }

  syncWidth() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  }
}

const dynamicVars = new dynamicVariables();

class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );

  }

  addToCart() {
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target.closest('[data-action="add-to-cart"]');
    var formElement = event.target.closest("form");
    var sourceInput = formElement.querySelector('input[name="source"]');
    if (addToCartButton?.dataset?.atcSource && sourceInput) {
      sourceInput.value = addToCartButton.dataset.atcSource;
    }

    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);

    serialized.properties = { ...serialized.properties };

    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (window.theme.cartMode === 'page') {
          location.href = window.routes.cart_page_url;
        }
        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.insertAdjacentElement(
              "afterend",
              errorMessageElement
            );
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });

  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class InfiniteScroll {

  constructor(container, paginationElement, restoreState) {
    if (
      !document.querySelector(container) ||
      !document.querySelector(paginationElement)
    )
      return;

    this.containerSelector = container;
    this.paginationElementSelector = paginationElement;
    this.restoreState = restoreState;
    this.treshold = 650;
    this.domDelegate = new Delegate(document.body);
    this.mainContainer = document.querySelector(this.containerSelector);
    this.loadType = this.mainContainer.dataset.load;
    this.running = false;
    this.bindEvents();

    const pageAccessedByReload = window.performance
      .getEntriesByType("navigation")
      .some((entry) => entry.type === "reload");

    if (
      this.restoreState &&
      sessionStorage.getItem("pageState") > 1 &&
      window.location.href === sessionStorage.getItem("pageStateURL") &&
      !pageAccessedByReload
    ) {
      const promises = this.generateFetchPromises(false);
      this.renderData(promises, true);
    } else {
      this.initObserver();
    }
  }

  initObserver() {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };

    this.observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      observerOptions
    );
    this.observer.observe(this.mainContainer);
  }

  bindEvents() {
    this.handleClickBinder = this.handleClick.bind(this);
    this.handleScrollBinder = this.handleScroll.bind(this);

    if (this.restoreState) {
      window.addEventListener(
        "beforeunload",
        this.rememberCurrentState.bind(this)
      );
    }
  }

  rememberCurrentState() {
    const scrollPositionY = window.scrollY;
    const currentUrl = window.location.href;
    const currentPage = document.querySelector(this.paginationElementSelector)
      .dataset.page;

    sessionStorage.setItem("pageState", currentPage);
    sessionStorage.setItem("pageStateURL", currentUrl);
    sessionStorage.setItem("pageStateScroll", scrollPositionY);
  }

  initialize() {
    if (this.loadType === "scroll") {
      this.scrollListener = scrollListener.addScrollListener(
        this,
        this.handleScrollBinder
      );
    } else {
      this.domDelegate.on(
        "click",
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  destroy() {
    if (this.loadType === "scroll") {
      this.scrollListener?.removeScrollListener();
    } else {
      this.domDelegate.off(
        "click",
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (this.running === false) {
          this.initialize();
          this.running = true;
        }
      } else {
        this.running = false;
        this.destroy();
      }
    });
  }

  handleScroll() {
    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (!this.paginationElement) return;

    const top =
      this.paginationElement.getBoundingClientRect().top - this.treshold;
    const bottom =
      this.paginationElement.getBoundingClientRect().bottom + this.treshold;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector("a");

      if (this.nextPageLinkElement) {
        this.destroy();
        const nextPageUrl = this.nextPageLinkElement.href;
        const promises = this.generateFetchPromises(nextPageUrl);
        this.renderData(promises);
      }
    }
  }

  handleClick(e) {
    e.preventDefault();
    const loader = e.target.closest("a")?.querySelector(".itemLoader");
    if (loader) {
      loader.classList.add("is-visible");
    }


    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (!this.paginationElement) return;
    this.nextPageLinkElement = this.paginationElement.querySelector("a");

    if (this.nextPageLinkElement) {
      this.destroy();
      const nextPageUrl = this.nextPageLinkElement.href;
      const promises = this.generateFetchPromises(nextPageUrl);
      this.renderData(promises);
    }
  }

  generateFetchPromises(nextPageUrl) {
    const promises = [];

    if (nextPageUrl == false) {
      const hasSearchParameters = window.location.search.length > 0;
      const limit = parseInt(sessionStorage.getItem("pageState"));
      for (let i = 2; i <= limit; i++) {
        let url;

        // Build the URL based on the condition
        if (hasSearchParameters) {
          url = `${window.location.href}&page=${i}`;
        } else {
          url = `${window.location.href}?page=${i}`;
        }

        promises.push(
          fetch(url, {
            credentials: "same-origin",
            method: "GET",
          })
        );
      }
    } else {
      const url = `${nextPageUrl}`;

      promises.push(
        fetch(url, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    }

    return promises;
  }

  async renderData(promises, restoreContent) {
    try {
      const responses = await Promise.all(promises);
      const contents = await Promise.all(
        responses.map((response) => response.text())
      );
      let isLastPromise = false;
      contents.forEach((content, index) => {
        isLastPromise = index === contents.length - 1;
        this.appendContent(content, isLastPromise, restoreContent);
      });
    } catch (error) {
      console.error("Error fetching or parsing data:", error);
    }
  }

  appendContent(content, lastPromise, restoreContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    const contentToAdd = doc.querySelector(this.containerSelector);
  
    this.mainContainer = document.querySelector(this.containerSelector);
    this.paginationElement = document.querySelector(this.paginationElementSelector);
  
    if (this.paginationElement) {
      this.paginationElement.remove();
    }
  
    this.mainContainer.insertAdjacentHTML("beforeend", contentToAdd.innerHTML);
  
    if (lastPromise) {
      this.initialize(); 
      this.initObserver(); 
    }
  
    if (lastPromise && restoreContent) {
      this.restoreScroll();
    }
  
    document.dispatchEvent(
      new CustomEvent("pagination:finished", { bubbles: true })
    );
  
    document.dispatchEvent(new CustomEvent('update-favorites'));
  
    new RevolutionAnimation(this.mainContainer);
  }

  restoreScroll() {
    const scrollPosition = parseInt(sessionStorage.getItem("pageStateScroll"));

    if (scrollPosition) {
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  }
}




class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.lock = false;
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;
    switch (this.breakpoint) {
      case "desktop":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  updateAllDropdowns() {
    this.allDropdowns = document.querySelectorAll(".Dropdown");
  }

  openDropdown(elem, target) {
    if (this.lock) return;
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    const isFilterDropdown = elem.classList.contains("filter__dropdown");

    this.allDropdowns.forEach((dropdown) => {
      if (
        dropdown !== target.closest(".Dropdown") &&
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
         if (isFilterDropdown) return;
        this.closeDropdown(dropdown, true);
      }
    });

    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    DropdownButton.setAttribute("aria-expanded", "true");
    new RevolutionAnimation(DropdownContent, "true").slideDown();
  }

  closeAllDropdowns(namespace) {
    namespace.querySelectorAll(".Dropdown").forEach((dropdown) => {
      if (
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown);
      }
    });
  }

  closeDropdown(elem, ignore) {
    if (this.lock && !ignore) return;
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");
    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        if (DropdownContent.getAttribute("aria-hidden") == "false") {
          DropdownContent.setAttribute("aria-hidden", "true");
        }

        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);

        if(mainDropdown.classList.contains('filter__dropdown')) {
          mainDropdown.dispatchEvent(
            new CustomEvent("close:filters", { bubbles: true })
          );
        }
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);

        if(mainDropdown.classList.contains('filter__dropdown')) {
          mainDropdown.dispatchEvent(
            new CustomEvent("open:filters", { bubbles: true })
          );
        }
      }
    }
  }
}

const allDropdowns = new Dropdown();


class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {

      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });


  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    this.productZoomSlider = document.querySelector('product-zoom');
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    window.addEventListener("resize", this.syncHeight());
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );

    this.onPointerUpBinder = this.onPointerUp.bind(this);
    this.onPointerDownBinder = this.onPointerDown.bind(this);
    responsive.addBreakpointListener("lap_and_up");
    this.delegateRoot.on(
      "breakpoint:lap_and_up",
      this.toggleMoveZoom.bind(this)
    );
    this.toggleMoveZoom();
  }

  toggleMoveZoom(e) {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.delegateRoot.on(
        "pointerdown",
        "[data-move]",
        this.onPointerDownBinder
      );
      this.delegateRoot.on("pointerup", "[data-move]", this.onPointerUpBinder);
    } else {
      this.delegateRoot.off(
        "pointerdown",
        "[data-move]",
        this.onPointerDownBinder
      );
      this.delegateRoot.off("pointerup", "[data-move]", this.onPointerUpBinder);
    }
  }

  onPointerDown(e) {
    this.timeout = setTimeout(() => {
      e.target.closest(".pswp__container")?.classList.add("move");
    }, 150);
  }

  onPointerUp(e) {
    if (this.timeout) {
      clearInterval(this.timeout);
    }
    e.target.closest(".pswp__container")?.classList.remove("move");
  }

  photoswiperClose() {
    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
    this.productZoomSlider.hide();
  }

  initPhotoSwipe() {
    const mobileContainer = document.querySelector(".pswp__mobile-container");
  
    // Clear mobile container if needed
    if (mobileContainer) mobileContainer.innerHTML = "";
  
    let images = [],
        index = 0;
  
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          const img = item.querySelector("img");
          if (img) {
            images.push(img);
  
            // Clone for mobile
            const imgClone = img.cloneNode(true);
            imgClone.style.width = "100%";
            imgClone.style.marginBottom = "1rem";
            if (mobileContainer) mobileContainer.appendChild(imgClone);
          }
        }
      });
  
      // Determine index
      index = this.slideshow.swiperElement.realIndex;
      const currentSlide = this.slideshow.swiperElement.slides[index];
      if (currentSlide) {
        const pos = currentSlide.querySelector(".ProductSlider--Element")?.getAttribute("data-image-position");
        if (pos !== null) index = pos;
      }
    } else {
      const img = document.querySelector(".ProductSlider--Image");
      if (img) {
        images.push(img);
  
        // Clone for mobile
        const imgClone = img.cloneNode(true);
        imgClone.style.width = "100%";
        if (mobileContainer) mobileContainer.appendChild(imgClone);
      }
    }
  
    // Always init PhotoSwipe (will just not be visible on mobile)
    this.productZoomSlider.show(index);
    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index)
    );
  }
  
  

  createPhotoSwipeItemsFromImages(images) {
    return images.map((image) => {
      const fullWidth = parseInt(image.getAttribute("data-max-width"));
      const fullHeight = parseInt(image.getAttribute("data-max-height"));
  
      const targetDisplaySize = 664;
  
      // Compute zoom level so the image displays at 664x664 initially
      const initialZoomLevel = targetDisplaySize / fullWidth;
  
      return {
        msrc: image.currentSrc || image.src,
        w: 664,
        h: 664,
        initialZoomLevel: initialZoomLevel,
        initZoomLevel: initialZoomLevel,
        src: image.dataset.originalSrc,
      };
    });
  }
  


  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            ".mainSwiper .ProductSliderCell--Zoom img"
          ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.delegateRoot.on("slide:change", (e) => {
      this.photoSwipeInstance.goTo(e.detail)
    });

    this.photoSwipeInstance.listen('afterChange', () => {
      this.productZoomSlider.setActiveSlide(this.photoSwipeInstance.getCurrentIndex());
    });

    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );

    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}
class ProductZoom extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.swiperElement = this.element;

    const rev = new RevolutionSwiper(this.swiperElement);
    const swiper = rev.swiperElement;




    this.largestSlideIndex = this.swiperElement.swiper.slides.length - 1;
    this.lastIndex = 0;

    this.bindEvents();
  }


  bindEvents() {
    this.delegateElement.on('click', '[data-action="slide-to"]', this.selectSlide.bind(this));
    this.swiperElement.swiper.on('slideChange', this.onSlideChange.bind(this));
  }

  show(index) {
    this.element.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() =>
      requestAnimationFrame(() => this.element.setAttribute('data-animate', 'true')
      ));

    this.setActiveSlide(index);
  }

  hide() {
    this.element.setAttribute('data-animate', 'false');

    const transitionEndHandler = (e) => {
      if (e.propertyName === "opacity") {
        this.element.setAttribute('aria-hidden', 'true');
        this.element.removeEventListener("transitionend", transitionEndHandler);
      }
    };

    this.element.addEventListener("transitionend", transitionEndHandler);
  }

  setActiveSlide(index) {
    const currentlyActive = this.element.querySelector('.product__zoom-slide--active');
    if (currentlyActive) currentlyActive.classList.remove('product__zoom-slide--active');
    const newActive = this.element.querySelector(`.product__zoom-slide[data-swiper-slide-index="${index}"]`);
    newActive.classList.add("product__zoom-slide--active");

    if (!newActive.classList.contains("swiper-slide-visible") && currentlyActive) {
      this.disable = true;
      this.swiperElement.swiper.slideTo(index);
      setTimeout(() => {
        this.disable = false;
      }, 250);
    }
  }

  selectSlide(e, target) {
    const currentlyActive = this.element.querySelector('.product__zoom-slide--active');
    if (currentlyActive) currentlyActive.classList.remove('product__zoom-slide--active');
    target.classList.add('product__zoom-slide--active')

    const goToIndex = parseInt(target.dataset.index);
    this.element.dispatchEvent(new CustomEvent('slide:change', { bubbles: true, detail: goToIndex }));
  }

  getSwipeDirection(currentIndex, lastIndex) {
    let isNext = false;
    let isPrev = false;

    if (lastIndex === this.largestSlideIndex && currentIndex === 0) {
      isNext = true;
    } else if (lastIndex === 0 && currentIndex === this.largestSlideIndex) {
      isPrev = true;
    } else {
      if (currentIndex > lastIndex) {
        isNext = true;
      } else if (currentIndex < lastIndex) {
        isPrev = true;
      }
    }

    return { isNext, isPrev };
  }

  onSlideChange() {
    if (this.disable) return;

    const currentlyActive = this.element.querySelector('.product__zoom-slide--active');
    const currentlyActiveIndex = parseInt(currentlyActive.dataset.swiperSlideIndex);

    const { isNext, isPrev } = this.getSwipeDirection(this.swiperElement.swiper.realIndex, this.lastIndex);

    if (isPrev) {
      let prevIndex = currentlyActiveIndex - 1;
      if (currentlyActiveIndex == 0) {
        prevIndex = this.largestSlideIndex;
      }

      this.element.querySelector(`.swiper-slide[data-index="${prevIndex}"]`).classList.add('product__zoom-slide--active');
    } else if (isNext) {
      let nextIndex = currentlyActiveIndex + 1;
      if (currentlyActiveIndex == this.largestSlideIndex) {
        nextIndex = 0;
      }

      this.element.querySelector(`.swiper-slide[data-index="${nextIndex}"]`).classList.add('product__zoom-slide--active');
    }

    if (this.swiperElement.swiper.realIndex !== this.lastIndex) {
      currentlyActive.classList.remove('product__zoom-slide--active');
    }

    const goToIndex = parseInt(this.element.querySelector('.product__zoom-slide--active').dataset.index);
    this.element.dispatchEvent(new CustomEvent('slide:change', { bubbles: true, detail: goToIndex }));

    this.lastIndex = this.swiperElement.swiper.realIndex;
  }
}
customElements.define("product-zoom", ProductZoom);


class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.headerEl = document.body.querySelector('#header');
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () { };
    this.onClose = options["onClose"] || function () { };
    this.isOpen = false;

    // Bind transition events for menu optimization
    this._onTransitionStart = this.onTransitionStart.bind(this);
    this._onTransitionEnd = this.onTransitionEnd.bind(this);
    // Generic end handler to ensure aria-hidden is toggled after close animations
    this._onAnyEnd = (e) => {
      // Only react for our drawer element
      if (e && e.target !== this.element) return;
      // Hide only when collapsed
      const isCollapsed = this.element.getAttribute('aria-expanded') === 'false';
      if (isCollapsed) {
        // For menu, also ensure it's fully hidden for layout
        if (this.element.getAttribute('id') === 'menu') {
          this.element.style.display = 'none';
          this.element.classList.add('menu-fully-hidden');
        }
        this.element.setAttribute('aria-hidden', 'true');
      }
    };

    // Static property to track all drawer instances
    if (!Drawer.instances) {
      Drawer.instances = [];
    }
    Drawer.instances.push(this);

    this.bindEvents();

  // Always observe transitions/animations ending on the drawer for proper aria-hidden sync
  this.element.addEventListener('transitionend', this._onAnyEnd);
  this.element.addEventListener('animationend', this._onAnyEnd);
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );

    this.delegateBody.on(
      "keydown",
      this.closeDrawerEsc.bind(this)
    );

    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);

    // Listen for the custom event to close the drawer
    document.body.addEventListener('drawer:close-other', () => {
      if (this.isOpen) {
        this.closeDrawer();
      }
    });
  }

  closeDrawerEsc(e) {
    if (e.key !== "Escape") return;

    if (this.isOpen) {
      this.closeDrawer(e);
    }
  }

  toggleDrawer(event) {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  // New method to close all other open drawers
  closeOtherDrawers() {    
    if (!Drawer.instances || Drawer.instances.length <= 1) return;
    
    for (let i = 0; i < Drawer.instances.length; i++) {
      const drawer = Drawer.instances[i];
      if (drawer !== this && drawer.isOpen) {
        drawer.closeDrawer();
      }
    }
  }

  openDrawer() {
    // Close all other open drawers before opening this one
    this.closeOtherDrawers();

    if (this.element.getAttribute("id") == "cart-drawer") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );
    }

    if (this.isOpen) {
      return;
    }

    dynamicVars.syncHeight();

    if (this.element.getAttribute("id") == "menu") {
      this.hamburger = document.body.querySelector(".header-hamburger");
      this.hamburger.classList.add("is-active");
      this.hamburger.setAttribute("aria-label", "Close main menu");
      document.querySelector(".Drawer--Close").style.display = "block";
      this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:open", {
          bubbles: true,
        })
      );
      
      // Prepare menu for opening animation
      this.prepareMenuForOpening();
      
      // Set aria attributes with slight delay for animation
      requestAnimationFrame(() => {
        this.element.setAttribute("aria-hidden", "false");
        this.element.setAttribute("aria-expanded", "true");
      });
    } else {
      // Prepare any non-menu drawer (e.g., search, cart, favorites) for opening with animation
      // 1) Make it visible but keep collapsed state to get starting transform
      this.element.style.display = 'block';
      // Force reflow so initial state (aria-expanded="false") is applied while visible
      this.element.offsetHeight;
      // 2) Next frame, flip aria to open to animate transform
      requestAnimationFrame(() => {
        this.element.setAttribute("aria-hidden", "false");
        this.element.setAttribute("aria-expanded", "true");
      });
    }



    //Don't show overlay on mobile menu drawer
    if(this.element.getAttribute("id") !== 'menu') {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener("click", this._closeListener);
    }

    if (this.element.getAttribute("id") === 'search-drawer') {
      this.pageOverlayElement.classList.add("is-search-drawer");

      setTimeout(() => {
        const inputEl = document.querySelector(".search-input__wrapper .searchInput");
        inputEl?.focus();
      }, 500);
    }

    if(this.headerEl.classList.contains('Header--Transparent')) {
      this.headerEl.classList.remove('Header--Transparent');
    }

    var focus = this.element.querySelector("[data-scrollable]");
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");

    this.isOpen = true;
    setTimeout(() => {
      trapFocus(this.element);
    }, 400);
    this.onOpen();

    // Prevent background scroll leaks on iOS (17.5.1)
     this._preventScroll = (e) => {
       e.preventDefault();
     };
     
     this.pageOverlayElement.addEventListener('touchmove', this._preventScroll, { passive: false });
     this.element.addEventListener('touchmove', this._preventScroll, { passive: false });

    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }

    if (this.element.getAttribute("id") == "menu") {
      this.hamburger = document.body.querySelector(".header-hamburger");
        this.hamburger.classList.remove("is-active");
        this.hamburger.setAttribute("aria-label", "Open main menu");
        this.element.dispatchEvent(
          new CustomEvent("menu-drawer:closed", { bubbles: true })
        );
        
        // Prepare menu for closing animation
        this.prepareMenuForClosing();
    }
    document.body.classList.remove("scrollLock");

    if (this.element.getAttribute("id") == "cart-drawer") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:closed", { bubbles: true })
      );
    }

    bodyScrollLock.clearAllBodyScrollLocks();
    if (this.element.getAttribute("id") == "cart") {
      var options = JSON.parse(this.element.getAttribute("data-settings"));
      if (options["showRecommendations"]) {
        this.element
          .querySelector(".CartDrawer--Expendable")
          .setAttribute("aria-expanded", false);
        setTimeout(() => {
          this.element.querySelector(".CustomCart__Recommendations").innerHTML =
            "";
        }, 800);
      }
    }
    this.element.setAttribute("aria-expanded", "false");

    // Defer aria-hidden until transition/animation finishes to preserve close animation
    const el = this.element;
    const onDone = () => {
      // Only hide if still collapsed
      if (el.getAttribute('aria-expanded') === 'false') {
        // For menu, also fully hide (display none) for layout correctness
        if (el.getAttribute('id') === 'menu') {
          el.style.display = 'none';
          el.classList.add('menu-fully-hidden');
        }
        // Clear display inline style for other drawers so CSS can control visibility
        if (el.getAttribute('id') !== 'menu') {
          el.style.display = '';
        }
        el.setAttribute('aria-hidden', 'true');
      }
      cleanup();
    };

    const onTransitionEnd = (e) => {
      // React on the primary animated properties
      if (!e || ['transform', 'clip-path', 'opacity', 'height'].includes(e.propertyName)) {
        onDone();
      }
    };

    const onAnimationEnd = () => onDone();

    const cleanup = () => {
      el.removeEventListener('transitionend', onTransitionEnd);
      el.removeEventListener('animationend', onAnimationEnd);
      if (fallbackTimer) {
        clearTimeout(fallbackTimer);
        fallbackTimer = null;
      }
    };

    // Attach listeners
    el.addEventListener('transitionend', onTransitionEnd);
    el.addEventListener('animationend', onAnimationEnd);

    // Fallback in case no events fire (e.g., reduced motion, zero duration)
    const cs = window.getComputedStyle(el);
    const td = (cs.transitionDuration || '0s').split(',').map(s => parseFloat(s) || 0);
    const ad = (cs.animationDuration || '0s').split(',').map(s => parseFloat(s) || 0);
    const maxDur = Math.max(...td, ...ad) || 0;
    let fallbackTimer = null;
    if (maxDur === 0) {
      // No transition; hide on next frame
      requestAnimationFrame(onDone);
    } else {
      fallbackTimer = setTimeout(onDone, (maxDur * 1000) + 50);
    }

    
    const isTransparent = this.headerEl.getAttribute('data-is-transparent');
    if(isTransparent === 'true') {
      this.headerEl.classList.add('Header--Transparent');
    }

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);
    if(this.pageOverlayElement.classList.contains("is-search-drawer")) {
      this.pageOverlayElement.classList.remove("is-search-drawer");
    }

       // cleanup for scroll trap
      this.pageOverlayElement.removeEventListener('touchmove', this._preventScroll);
      this.element.removeEventListener('touchmove', this._preventScroll);

    removeTrapFocus(this.element);
    this.isOpen = false;
    this.onClose();
  }

  // Prepare menu for opening
  prepareMenuForOpening() {
    if (this.element.getAttribute("id") !== "menu") return;
    
    // Remove fully hidden class and set display: block
    this.element.classList.remove('menu-fully-hidden');
    this.element.style.display = 'block';
    
    // Force browser reflow to apply display: block before animation
    this.element.offsetHeight;
    
    // Recalculate heights now that menu is visible
    const mainMenuDropdown = this.element.closest('main-menu-dropdown');
    if (mainMenuDropdown && mainMenuDropdown.updateHeights) {
      mainMenuDropdown.updateHeights();
    }
    
    // Add transition event listeners
    this.element.addEventListener('transitionstart', this._onTransitionStart);
    this.element.addEventListener('transitionend', this._onTransitionEnd);
  }

  // Handle transition start event
  onTransitionStart(event) {
    if (this.element.getAttribute("id") !== "menu") return;
    if (event.propertyName === 'clip-path') {
      // Additional logic can be added here if needed
    }
  }

  // Handle transition end event
  onTransitionEnd(event) {
    if (this.element.getAttribute("id") !== "menu") return;
  if (event.propertyName === 'clip-path' || event.propertyName === 'transform' || event.propertyName === 'opacity') {
      const isExpanded = this.element.getAttribute('aria-expanded') === 'true';
      
      if (!isExpanded) {
        // Menu is closed - hide it completely
        this.hideMenuCompletely();
      }
      
      // Remove event listeners
      this.element.removeEventListener('transitionstart', this._onTransitionStart);
      this.element.removeEventListener('transitionend', this._onTransitionEnd);
    }
  }

  // Completely hide menu
  hideMenuCompletely() {
    if (this.element.getAttribute("id") !== "menu") return;
    
    // Set display: none and add class
    this.element.style.display = 'none';
    this.element.classList.add('menu-fully-hidden');
    
    // Set aria-hidden to true
    this.element.setAttribute("aria-hidden", "true");
  }

  // Prepare menu for closing
  prepareMenuForClosing() {
    if (this.element.getAttribute("id") !== "menu") return;
    
    // Add transition event listeners for closing
    this.element.addEventListener('transitionstart', this._onTransitionStart);
    this.element.addEventListener('transitionend', this._onTransitionEnd);
  }
}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate = node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  elementScaleOut(elements) {
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;
    elements.forEach((element, index) => {
      if (element.hasAttribute("data-loaded")) {
        return;
      }
      element.setAttribute("data-loaded", true);
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];
      setTimeout(() => {
        element.animate(keyframes, {
          duration: animationDuration,
          fill: "forwards",
        });
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration * 2,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  // Simple fade-in animation without scaling
  elementFadeIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.hasAttribute("data-loaded")) {
        return;
      }
      item.setAttribute("data-loaded", true);
      setTimeout(() => {
        item.animate([
          { opacity: "0" },
          { opacity: "1" }
        ], {
          duration: window.theme.animationDuration,
          fill: "forwards"
        });
      }, window.theme.animationBetweenElements * i);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const elements = [];
        results.forEach((result) => {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            elements.push(result.target);
            this.intersectionObserver[index].unobserve(result.target);
          }
        });
        if (elements.length === 0) {
          return;
        }
        const animations = {
          elementFromTop: 'elementFromTop',
          elementFromBottom: 'elementFromBottom',
          elementFromRight: 'elementFromRight',
          elementFromLeft: 'elementFromLeft',
          elementFromLeftBig: 'elementFromLeftBig',
          elementFromRightBig: 'elementFromRightBig',
          elementScaleIn: 'elementScaleIn',
          elementScaleOut: 'elementScaleOut',
          elementFadeIn: 'elementFadeIn'
        };
        const method = animations[options.type];
        if (method) {
          this[method](elements);
        }
      },
      { threshold: 0.15 }
    );

    if (animatedItem.classList.contains('animatedContent')) {
      this.intersectionObserver[index].observe(animatedItem);
    }
    animatedItem.querySelectorAll('.animatedContent').forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}

class ProductCache {
  constructor() {
    if (!ProductCache.instance) {
      this.cache = new Map();
      ProductCache.instance = this;
    }
    return ProductCache.instance;
  }

  addProducts(html) {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    const allProducts = tempElement.querySelectorAll(".recent__item");

    allProducts.forEach((product) => {

      product.classList.remove("recent__item");
      product.classList.add('favorites-item');
      product.classList.remove('swiper-slide');
      product.querySelector('.toggle-favorites').setAttribute('state', 'active');
      const id = product.getAttribute("data-id");
      if (id && !this.cache.has(id)) {
        this.cache.set(id, product.cloneNode(true));
      }
    });

    // Notify listeners when products are added

    this.dispatchCacheUpdated();
  }

  removeProduct(productId) {
    this.cache.delete(productId);
    this.dispatchCacheUpdated();
  }

  getProducts() {
    return Array.from(this.cache.values());
  }

  clear() {
    this.cache.clear();
    this.dispatchCacheUpdated();
  }

  async loadFromStorage() {
    const favoriteIds = JSON.parse(localStorage.getItem("productFavorites") || "[]");

    if (favoriteIds.length === 0) {

      this.dispatchCacheUpdated();
      return;
    }

    const chunkSize = 10;
    const idChunks = [];

    // Split favoriteIds into chunks of 10
    for (let i = 0; i < favoriteIds.length; i += chunkSize) {
      idChunks.push(favoriteIds.slice(i, i + chunkSize));
    }

    try {
      // Make multiple requests using Promise.all
      const responses = await Promise.all(
        idChunks.map(async (chunk) => {
          const queryString = chunk.map((id) => `id:${id}`).join(" OR ");
          const response = await fetch(
            `${window.routes.localeRootUrl}/search?view=recently&type=product&q=${queryString}`
          );
          return response.text();
        })
      );

      // Combine all responses and add to cache
      responses.forEach((html) => this.addProducts(html));

      // Dispatch event after cache is fully loaded


    } catch (error) {
      console.error("Error re-caching products:", error);
    }
  }

  dispatchCacheUpdated() {
    document.dispatchEvent(new CustomEvent("cache:updated", { detail: { cacheSize: this.cache.size } }));
  }
}

// Initialize cache globally
const favoritesCache = new ProductCache();


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.delegateElement.on("click", "button", this.onButtonClick.bind(this));
    this.delegateElement.on("input", "input", this.onInput.bind(this));
  }

  onInput() {
    this.input.dispatchEvent(this.changeEvent);
    this.toggleAddButton();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    if (this.input.value > 1) {
      this.element.classList.add('active')
    } else {
      this.element.classList.remove('active')
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    this.toggleAddButton();
  }


  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelectorAll(".pm__atc-button--main"),
      addButtonInner = document.querySelectorAll(".pm__atc-button--main .ButtonText"),
      quantityEl = document.querySelector(".pm__quantity-input"),
      altButtons = document.querySelectorAll(".pm__alt-atc-button");

    if (quantityEl) {
      quantity = quantityEl.value;
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    if (selectedVariant.available == false) {
      addButton.forEach(button => button.setAttribute("disabled", "disabled"));
      addButtonInner.forEach((btn) => {
        btn.innerHTML = window.variantStrings.soldOut;
      });
      altButtons.forEach(button => button.setAttribute("disabled", ""));
    } else {
      altButtons.forEach(button => button.removeAttribute("disabled"));
      addButton.forEach(button => button.removeAttribute("disabled"));
    }
  }
}

customElements.define("quantity-input", QuantityInput);

class ConnectedProducts extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
  }

  connectedCallback() {
    this.selectedConnectedProduct = this.element.querySelector(".product-module__selectbox-reload.SelectboxImage-Selected");
    this.connectedProductColorDisplay = this.element.querySelector(".pm__items__connected-product-color");
    this.connectedLowInStockDisplay = this.element.querySelector(".connected-products__low-in-stock");
    this.connectedOutOffStockDisplay = this.element.querySelector(".connected-products__out-of-stock");
    this.connectedPreorderDisplay = this.element.querySelector(".connected-products__preorder");
    
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("mouseover", ".product-module__selectbox-reload", (e, target) => {
      this.handleIndicatorOnMouseIn(target);
    });
    
    this.delegateElement.on("mouseout", ".product-module__selectbox-reload", (e, target) => {
      this.handleIndicatorOnMouseOut();
    });
    
  }

  handleIndicatorOnMouseIn(target) {
    const colorName = target.getAttribute("data-value");
    const lowInStock = target.getAttribute("data-low-in-stock") === "true";
    const outOfStock = target.getAttribute("data-out-of-stock") === "true";
    const preorderProduct = target.getAttribute("data-preorder") === "continue";
  
    if (this.connectedProductColorDisplay && colorName) {
      this.connectedProductColorDisplay.textContent = colorName;
    }
  
    if (this.connectedLowInStockDisplay) {
      this.connectedLowInStockDisplay.style.display = lowInStock ? "flex" : "none";
    }
  
    if (this.connectedOutOffStockDisplay) {
      this.connectedOutOffStockDisplay.style.display = outOfStock ? "flex" : "none";
    }

    if (this.connectedPreorderDisplay) {
      this.connectedPreorderDisplay.style.display = preorderProduct ? "flex" : "none";
    }
  }

  handleIndicatorOnMouseOut() {
    if (this.connectedProductColorDisplay && this.selectedConnectedProduct) {
      const colorName = this.selectedConnectedProduct.getAttribute("data-value");
      this.connectedProductColorDisplay.textContent = colorName;
    }
  
    if (this.selectedConnectedProduct) {
      const selectedLowInStock = this.selectedConnectedProduct.getAttribute("data-low-in-stock") === "true";
      const selectedOutOfStock = this.selectedConnectedProduct.getAttribute("data-out-of-stock") === "true";
      const preorderProduct = this.selectedConnectedProduct.getAttribute("data-preorder") === "continue";

      if (this.connectedLowInStockDisplay) {
        this.connectedLowInStockDisplay.style.display = selectedLowInStock ? "flex" : "none";
      }
  
      if (this.connectedOutOffStockDisplay) {
        this.connectedOutOffStockDisplay.style.display = selectedOutOfStock ? "flex" : "none";
      }

      if (this.connectedPreorderDisplay) {
        this.connectedPreorderDisplay.style.display = preorderProduct ? "flex" : "none";
      }
    }
  }
  
}

customElements.define("connected-products", ConnectedProducts);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector('.component-countDownWrapper');

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options['countdownString'];
    counterString = counterString.replace('{countdown}', '<span class="u-pb6 component-countDown">00:00:00</span>');
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;


    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options['countdownType'] == 'to_date') {
      countDate = new Date(this.options.countdownDate);
    }



    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;


    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);


    const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
    if (targetHours < currentHours || (targetHours === currentHours && targetMinutes <= currentMinutes) && this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference - 1;
    } else if (this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference;
    }


    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);

var stateWasEmpty = true;
class cartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.focusElement = false;
    this.drawer = new Drawer(this.element, {
      onClose: () => {
        this.isOpen = false;
        this.recommendationsOpen = false;
        this.alreadyEntered = false;
        this.onClose();
      },
      onOpen: () => {
        this.isOpen = true;

        if (this.alreadyEntered == false) {
          this.onOpen();
        }
        this.alreadyEntered = true;
      },
    });
    this.loader = this.element.querySelector(".itemLoader");

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.emptyCartCollection = this.element.querySelector('#empty-cart__coll');
    this.emptyCartContainer = this.element.querySelector('.cart-drawer__empty-coll');
    if(this.emptyCartContainer) {
      const clone = this.emptyCartCollection.content.cloneNode(true);
      this.emptyCartContainer.appendChild(clone);
    }
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.cartIds = false;
    this.isOpen = false;
    this.recommendationsOpen = false;
    this.recommendationLoading = false;
    this.breakpoint = responsive.getCurrentBreakpoint();

    this.alreadyEntered = false;
    new AddToCart(this.element);
    this.loadRecommendations();

    this.bindEvents();
  }

  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("cart-drawer:open", this.onOpen.bind(this));

      document.addEventListener("product:added", this.onProductAddedListener);
      
      // Listen for add to cart clicks in upsell to show loader immediately
      this.delegateElement.on(
        "click",
        '.swiperUpsell [data-action="add-to-cart"]',
        this.onUpsellAddToCart.bind(this)
      );
      
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".cart-item__quantity",
        this.updateItemQuantity.bind(this)
      );


      window.theme.listener = "true";
    }
  }

  onOpen() {

    const allDrawers = document.querySelectorAll('.Drawer--wrapper[aria-expanded="true"]');
    allDrawers.forEach(drawer => {
      if (drawer !== this.element) {
        drawer.setAttribute('aria-expanded', 'false');
  // aria-hidden will be set by their own transitionend/animationend
      }
    });

    if (this.element.getAttribute("aria-expanded") == "false") {
      setTimeout(() => {
        if (this.element.hasAttribute('data-open-drawer')) {
          bodyScrollLock.clearAllBodyScrollLocks();
          this.focusElement = this.element.querySelector("[data-scrollable]");
          bodyScrollLock.disableBodyScroll(this.focusElement, bodyScrollLockOptions);
        }

      }, 500);

      if (this.options["showRecommendations"] && this.alreadyEntered == false) {
        requestAnimationFrame(() => {
          this.loadRecommendations();
        })
      }
    }
    const header = this.element.querySelector(".cart-drawer__header");
    const headerHeight = header.offsetHeight;
  
    document.documentElement.style.setProperty(
      "--cart-drawer__header-height",
      headerHeight + "px"
    );

  if (this.element.querySelector(".cart-drawer__footer")) {
    document.documentElement.style.setProperty(
      "--cart-drawer__footer-height",
      this.element.querySelector(".cart-drawer__footer").offsetHeight + "px"
    );
  }
  }

  onClose() {
    if (this.breakpoint == 'desktop' && this.recommendationContainer) {
      this.recommendationContainer.setAttribute("aria-expanded", "false");
      this.recommendationContainer = null;
    }
  }



  handleTransitionEnd(target) {
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    this.recommendationContainer.removeEventListener(
      "transitionend",
      this.transitionEndHandler
    );
  }

  async updateItemQuantity(event, target) {
    event.preventDefault();
    const cartItem = target.closest(".cart-item");
    const itemLoader = cartItem.querySelector(".itemLoader");
    itemLoader.classList.add("is-visible");

    let quantity;
    if (target.tagName === "INPUT") {
      quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"), 10);
    }

    const payload = {
      id: target.getAttribute("data-line-id"),
      quantity: quantity,
    };

    if (quantity === 0) {
      cartItem.classList.add("removing");
      const id = cartItem.dataset.id;
      if (this.cartIds) {
        this.cartIds = this.cartIds.filter((item) => item !== id);
      }

      const nextItem = cartItem.nextElementSibling;
      const height = cartItem.offsetHeight;
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      setTimeout(() => {
        cartItem.remove();
        if (!nextItem) {
          return;
        }
        nextItem.classList.add("repo--top");
        setTimeout(() => {
          nextItem.classList.remove("repo--top");
        }, 350);
      }, 350);
    }

    try {
      const response = await fetch(
        `${window.routes.localeRootUrl}/cart/change.js`,
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      if (data.item_count == 0) {
        this.loader.classList.add("is-visible");
        this.renderCart(false, false);
      }
      if (quantity == 0 && data.item_count > 0) {
        stateWasEmpty = true;
        if (this.options.showRecommendations) {
          this.options["productId"] = data.items[0].product_id;
          this.lineNumber == true;
          this.quantityChange == true;
          this.productAddEvent == true;
          this.updateCount == true;
          this.renderCart(this.lineNumber, this.quantityChange, this.productAddEvent, this.updateCount);
          return;
        }
      }
      if (data.item_count > 0 && quantity > 0) {
        this.renderCart(target.getAttribute("data-id"), true);
      }

    } catch (error) {
      console.error("Failed to update item quantity:", error);
      // Optionally, show an error message to the user
    }
  }

  onProductAdded() {
    let details = false;
    if (event.detail) {
      details = event.detail;
    }

    if (window.theme.cartCount == 0 && this.isOpen == true) {
      this.loader.classList.add("is-visible");
    }


    this.renderCart(false, false, true, details).then(() => {
      if (this.element.hasAttribute('data-open-drawer')) {
        if (this.isOpen == false) {

          this.isOpen = true;
          this.onOpen();
          this.alreadyEntered = true;
          this.drawer.openDrawer();

        }
      }
    });
  }

  onUpsellAddToCart(event) {
    // Show loader immediately when add to cart is clicked in upsell
    if (this.isOpen) {
      this.loader.classList.add("is-visible");
    }
  }

  renderCart(lineNumber, quantityChange, productAdd, productAddEvent, updateCount) {
    this.pageLoader.style.width = 90 + "%";
    var _this = this;
    return fetch(
      window.routes.localeRootUrl + "/?section_id=main-cart_drawer",
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(
          html,
          lineNumber,
          quantityChange,
          productAdd,
          productAddEvent,
          updateCount
        );

      });
    });
  }

  replaceContent(
    html,
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount
  ) {


    // Prepare the page loader animation
    this.pageLoader.style.width = "100%";
    setTimeout(() => {
      this.pageLoader.style.left = "unset";
      this.pageLoader.style.right = "0px";
      this.pageLoader.style.width = "0%";

      setTimeout(() => {
        this.pageLoader.style.left = "0px";
        this.pageLoader.style.right = "unset";
      }, 550);

    }, 100)


    // Create a temporary element to parse the new HTML content
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

     // Re-insert collection template content for empty cart if the container exists
      const clone = this.emptyCartCollection.content.cloneNode(true);
      const container = tempElement.querySelector('.cart-drawer__empty-coll');
      container?.appendChild(clone);

    // Extract options and update cart count
    const newOptions = JSON.parse(
      tempElement.querySelector("#cart-drawer").getAttribute("data-settings")
    );
    this.options = newOptions;
    // console.log(this.options)

    if (tempElement.querySelector("[data-ids]")) {
      this.cartIds = tempElement
        .querySelector("[data-ids]")
        .dataset.ids.split(",")
        .filter((item) => item !== "");
      if (updateCount) {
        this.cartIds = this.cartIds.filter((item) => item !== this.removeId);
        this.removeid = null;
        this.loadRecommendations();
      }
    }

    
    
    const itemCount = newOptions.itemCount;
    window.theme.cartCount = parseInt(itemCount);
    const countEl = document.querySelector('.header__cart-count');
    const favoritesEl = document.querySelector('.header__favorites-count');
    
    // Add null checks to prevent errors
    if (countEl) {
      countEl.innerHTML = itemCount;
    }
  
    //Change cart and favorites count color

    const el = document.body.querySelector('.product-module__connected-items');
  
    //Change cart and favorites count color
    if (countEl) {
      window.theme.cartCount === 0 ? countEl.classList.remove('visible') : countEl.classList.add('visible');
      if (window.theme.cartCount > 2) {
        countEl.classList.remove('colored');
        countEl.style.backgroundColor = '';
        countEl.style.color = '';
        countEl.style.setProperty('--hover-color', '');
        const closestLi = countEl.closest('li');
        if (closestLi) closestLi.classList.remove('changed');
      } else {
        countEl.classList.add('colored');
        if(el) {
          const selected = el.querySelector('.SelectboxImage-Selected');
          this.updateHeaderColors(selected, countEl);
        }
      }
    }

    if (favoritesEl) {
      if (window.theme.cartCount > 2) {
        favoritesEl.classList.remove('colored');
        favoritesEl.style.backgroundColor = '';
        favoritesEl.style.color = '';
        favoritesEl.style.setProperty('--hover-color', '');
        const closestLi = favoritesEl.closest('li');
        if (closestLi) closestLi.classList.remove('changed');
      } else {
        favoritesEl.classList.add('colored');
        if(el) {
          const selected = el.querySelector('.SelectboxImage-Selected');
          this.updateHeaderColors(selected, favoritesEl);
        }
      }
    }

    if (updateCount) {
      this.updateCartFooter(tempElement);
      return;
    }
    if (lineNumber && tempElement.querySelector(`#${lineNumber}`)) {
      this.updateCartItem(lineNumber, tempElement);
    } else if (productAdd && stateWasEmpty == false && lineNumber) {
      this.addContent(tempElement, productAddEvent);
    } else {
      this.replaceCartContent(tempElement);
    }

    this.updateCartFooter(tempElement);

    this.element.dispatchEvent(
      new CustomEvent("cart:render", { bubbles: true })
    );



    if (itemCount == 0) {
      stateWasEmpty = true;
    } else {
      stateWasEmpty = false;
    }

    // Additional actions after a brief delay

    setTimeout(() => {
      if (
        this.options.showRecommendations &&
        !quantityChange &&
        this.isOpen == true
      ) {
        this.loadRecommendations();
      }

      if (this.element.hasAttribute('data-open-drawer')) {
        bodyScrollLock.clearAllBodyScrollLocks();
        this.focusElement = this.element.querySelector("[data-scrollable]");
        bodyScrollLock.disableBodyScroll(this.focusElement, bodyScrollLockOptions);
      }

    }, 200);
  }

  updateHeaderColors(element, headerEl) {
    const defColor = element.dataset.defColor;
    const hoverColor = element.dataset.hoverColor;
    const textColor = element.dataset.textColor;
  
  if (headerEl.classList.contains("colored")) {
    headerEl.style.backgroundColor = defColor;
    headerEl.style.color = textColor;

    headerEl.style.setProperty('--hover-color', hoverColor);
    headerEl.closest('li').classList.add('changed');
  }
  }

  updateCartItem(lineNumber, tempElement) {
    const cartItemParent = this.element.querySelector(`#${lineNumber}`);
    const newCartItemInfo = tempElement.querySelector(
      `#${lineNumber} .cart-item__info `
    );
    const oldCartItemInfo = cartItemParent.querySelector(`#${lineNumber} .cart-item__info`);


    if (!cartItemParent) {
      this.element
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    } else {
      cartItemParent
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    }

    if (newCartItemInfo) {
      cartItemParent.querySelector('.cart-item__inner').replaceChild(
        newCartItemInfo,
        oldCartItemInfo
      );
    } else if (cartItemParent) {
      this.removeCartItem(cartItemParent);
    }
  }

  addContent(tempElement, productAddEvent) {
    if (this.isOpen) {
      this.element.querySelector(".cart-drawer__wrapper").scrollTop = 0;
    }
    const itemToAdd = tempElement.querySelector(
      `#cart-item__${productAddEvent.variant}`
    );
    const cartWrapper = this.element.querySelector(".cart-drawer__items");
    const firstItem = cartWrapper.firstElementChild;
    if (cartWrapper.querySelector(`#cart-item__${productAddEvent.variant}`)) {
      this.updateCartItem(`cart-item__${productAddEvent.variant}`, tempElement);
    } else {
      const height = this.calculateDetachedElement(itemToAdd);
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      firstItem.classList.add("repo--bottom");
      this.loader.classList.remove("is-visible");
      setTimeout(() => {
        cartWrapper.prepend(itemToAdd);
        itemToAdd.classList.add("repo--adding");
        firstItem.classList.remove("repo--bottom");

        setTimeout(() => {
          itemToAdd.classList.remove("repo--adding");
        }, 350);
      }, 350);
    }
  }

  calculateDetachedElement(element) {
    // 1. Create a detached container
    const detachedContainer = document.createElement("div");
    detachedContainer.style.position = "absolute";
    detachedContainer.style.visibility = "hidden";
    detachedContainer.style.height = "auto";
    detachedContainer.style.width = "auto";
    detachedContainer.style.top = "-9999px"; // Off-screen positioning

    // 2. Append the new item to the detached container
    detachedContainer.appendChild(element);

    // 3. Append the detached container to the body (but off-screen)
    this.element.appendChild(detachedContainer);

    // 4. Get the offset height of the new item
    const newItemHeight = element.offsetHeight + 16;

    // 5. Remove the detached container from the DOM
    this.element.removeChild(detachedContainer);

    // Now you have the height of the new item without it ever being visible
    return newItemHeight;
  }

  updateCartFooter(tempElement) {
    const itemCount = this.options.itemCount;
    if (itemCount > 0) {

      const footerParent = document.querySelector(".cart-drawer__footer");

      const newFooterTotals = tempElement.querySelector(
        ".cart_drawer__footer-totals"
      );
      const oldFooterTotals = document.querySelector(".cart_drawer__footer-totals");

      if (!footerParent || !newFooterTotals) return;
      if (oldFooterTotals) {

        footerParent.replaceChild(
          newFooterTotals,
          oldFooterTotals
        );
      } else {
        footerParent.prepend(newFooterTotals);
      }

      const newShippingBar = tempElement.querySelector(
        ".cart-drawer__shipping-progress-bar"
      );
      if (newShippingBar) {
        const currentShippingBar = document.querySelector(
          ".cart-drawer__shipping-progress-bar"
        );
        if (currentShippingBar) {
          let percent = newShippingBar.dataset.percent;
          if (percent > 100) {
            percent = 100;
          }
          currentShippingBar.dataset.percent = percent;
          currentShippingBar.style.width = `${percent}%`;
          if (percent == 100) {
            currentShippingBar.classList.add("done");
            currentShippingBar.classList.remove("active");
          } else {
            currentShippingBar.classList.remove("done");
            currentShippingBar.classList.add("active");
          }
          this.element.querySelector(".cart-drawer__shipping-text").innerHTML =
            tempElement.querySelector(".cart-drawer__shipping-text").innerHTML;
        } else {
          const headerParent = this.element.querySelector(
            ".cart-drawer__header"
          );
          headerParent.appendChild(
            tempElement.querySelector(".cart-drawer__shipping")
          );
        }
      }

    } else {
      this.clearCartFooter(tempElement);
      stateWasEmpty = true;
    }

    if (this.element.querySelector(".cart-drawer__footer")) {
      document.documentElement.style.setProperty(
        "--cart-drawer__footer-height",
        this.element.querySelector(".cart-drawer__footer").offsetHeight + "px"
      );

    }

  }

  clearCartFooter(tempElement) {

    if (!tempElement.querySelector(".cart-drawer__wrapper")) return;
    if (document.querySelector(".cart-drawer__footer")) {
      document
        .querySelector(".cart-drawer__footer")
        .classList.add("removing");
    }

    const wrapperParent = this.element.querySelector(".cart-drawer__wrapper");
    if (wrapperParent) {
      wrapperParent.innerHTML = tempElement.querySelector(
        ".cart-drawer__wrapper"
      ).innerHTML;
    }
  }

  replaceCartContent(tempElement) {

    const cartWrapperParent = this.element.querySelector(
      ".cart-drawer__wrapper"
    ).parentNode;
    const currentScrollPosition = this.element.querySelector(
      ".cart-drawer__wrapper"
    ).scrollTop;

    cartWrapperParent.replaceChild(
      tempElement.querySelector(".cart-drawer__wrapper"),
      this.element.querySelector(".cart-drawer__wrapper")
    );
    setTimeout(() => {
      this.loader.classList.remove("is-visible");
    }, 200);
    this.element.querySelector(".cart-drawer__wrapper").scrollTop =
      currentScrollPosition;

    setTimeout(() => {
      const header = this.element.querySelector(".cart-drawer__header");
      const headerHeight = header.offsetHeight;
      
      document.documentElement.style.setProperty(
        "--cart-drawer__header-height",
        headerHeight + "px"
      );
      if (cartWrapperParent.querySelector(".cart-drawer__footer")) {
        document.documentElement.style.setProperty(
          "--cart-drawer__footer-height",
          cartWrapperParent.querySelector(".cart-drawer__footer").offsetHeight + "px"
        );
      }
    }, 100);
  }

  loadRecommendations() {
    this.recommendationLoading = true;
    let recommendationsContainer = this.element.querySelector(
      ".cart-drawer__recommendations"
    );

    if (!recommendationsContainer) return;
    const productId = this.options["productId"];

    const baseUrl = window.routes.localeRootUrl;
    let url;

    if (!productId) {
      url = "?section_id=helper-recommendations";
    } else {
      let limit = this.element.getAttribute("product-limit");
      url = `${baseUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&limit=${limit}&intent=${this.options["intent"]}`;
    }  

    recommendationsContainer.classList.remove("transition--done");
    if (this.recommendationsOpen == true) {
      recommendationsContainer.classList.add("transition");
    }

    return fetch(url)
      .then((response) => response.text())
      .then((content) => {
        this.recommendationLoading = false;
        const container = document.createElement("div");
        container.innerHTML = content;
        let recommendedIds = null;
        if (container.querySelector(".cart-drawer__rec-item")) {
          recommendedIds = [
            ...container.querySelectorAll(".cart-drawer__rec-item"),
          ].map((item) => item.dataset.id);
        }

        if (!recommendedIds) {
          recommendationsContainer.style.display = 'none';
        } else {
          recommendationsContainer.style.display = 'block';
        }

        if (!this.cartIds) {
          if (recommendationsContainer.dataset.ids) {
            this.cartIds = recommendationsContainer.dataset.ids
              .split(",")
              .filter((item) => item !== "");
          }
        }

        if (this.cartIds && recommendedIds) {
          const hasCommonItem = this.cartIds.some((item) =>
            recommendedIds.includes(item)
          );
          if (hasCommonItem) {
            return;
          }
        }

        let recommendationsHTML = container.querySelector(
          ".cart-drawer__upsell"
        )?.innerHTML;

        if (recommendationsHTML) {
          recommendationsContainer.innerHTML = recommendationsHTML;
          document.dispatchEvent(new CustomEvent('update-favorites'));
          this.initializeSwiper();
          new AddToCart(this.element);
          // this f will hide product in recommendations if product is same as cart item
          this.hideDuplicate();
        }
      })
      .catch((error) => {
        console.error("Failed to load recommendations:", error);
      });
  }

  hideDuplicate(){
    this.cartItems = this.element.querySelectorAll('.cart-item');
    this.recommendedItems = this.element.querySelectorAll('.product-card');

    const cartIds = Array.from(this.cartItems).map(item =>
      item.getAttribute('data-id')
    );

    this.recommendedItems.forEach(item => {
      const recommendedId = item.getAttribute('data-productid');

      if(cartIds.includes(recommendedId)) {
        item.closest('.cart-drawer__rec-item').style.display = 'none';
      }
    });
    
  }

  handleTransitionRec(target, container) {
    if (event.propertyName !== "transform") return;
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    container.classList.remove("transition");
    this.recommendationsOpen = false;
    this.el.removeEventListener("transitionend", this.transitionRecEnd);
  }

  initializeSwiper() {
    if(window.location.pathname === '/cart') {
      this.slides = 1.2;
      this.slidesDesk = 4;
    } else {
      this.slides = 2.154;
      this.slidesDesk = 2.0745;
    }
    new Swiper(".swiperUpsell", {

      slidesPerView: this.slides,
      spaceBetween: 8,
      touchStartPreventDefault: false,
      touchStartForcePreventDefault: false,
      pagination: {
        el: "#cart-drawer__swiper-pagination",
        type: "bullets",
        clickable: true,
        spaceBetween: 16,
        bulletClass: "swiper-pagination-bullet",
        bulletActiveClass: "swiper-pagination-bullet-active"
      },
      mousewheel: {
        forceToAxis: true,
      },
      pagination: {
        el: "#cart-drawer__swiper-pagination",
        type: "bullets",
        clickable: true,
        spaceBetween: 16,
        bulletClass: "swiper-pagination-bullet",
        bulletActiveClass: "swiper-pagination-bullet-active"
      },
      breakpoints: {
        1025: {
          slidesPerView: this.slidesDesk,
          spaceBetween: 16,
          touchStartPreventDefault: true,
          touchStartForcePreventDefault: true,
          navigation: {
                nextEl: ".swiperButtonNext",
                prevEl: ".swiperButtonPrevious"
            }
        },
      },
    });
  }

}
customElements.define("cart-drawer", cartDrawer);

class CustomUpsell extends HTMLElement {
  constructor(){
    super();
    this.element = this;
  }

  connectedCallback() {
    const carouselElement = this.element.querySelector(".swiperUpsell");
    new RevolutionSwiper(carouselElement);
  }
}
customElements.define("custom-upsell", CustomUpsell);

class cartReminder extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.cartMode = this.element.dataset.cartMode;
    this.reminderDelay = parseInt(this.element.dataset.delay);

    this.timer = null;

    // Detect cart page leave if cart page is enabled
    if(this.cartMode === 'page') {
      this.checkPage();
    }

    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener("cart-drawer:closed", this.cartClosed.bind(this));
    document.addEventListener("cart-drawer:open", () => {
      if (this.element.getAttribute("aria-hidden") === "false") {
        this.closePopup(); // only close if already shown
      }
    });

    this.delegateElement.on(
      "click",
      "[data-action='close-reminder']",
      this.closePopup.bind(this),
      true
    );
  }

  checkPage() {
    if (window.location.pathname === '/cart') {
      sessionStorage.setItem('onCartPage', 'true');
    } else {
      if (sessionStorage.getItem('onCartPage') === 'true') {
        sessionStorage.removeItem('onCartPage');
        this.cartClosed(); // treat like cart closed
      }
    }
  }

  cartClosed() {
    if (sessionStorage.getItem("cartReminderDisabler")) return;

    clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      this.showReminder();
    }, this.reminderDelay);
  }

  showReminder() {
    // Check for cart items
    if (window.theme.cartCount > 0) {
      this.element.setAttribute("aria-hidden", "false");
    }
  }

  closePopup() {
      this.element.setAttribute("aria-hidden", "true");
      sessionStorage.setItem("cartReminderDisabler", "true");
      clearTimeout(this.timer);
  }
}

customElements.define("cart-reminder", cartReminder);


class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection.bind(this),
      { rootMargin: '-250px 0px 200px 0px' }
    );
  }

  connectedCallback() {
    this.intersectionObserver.observe(this);

    this.carouselElement = this.element.querySelector(".pc__carousels .swiper");
    this.carouselElementThumbs = this.element.querySelector(".pc__collections");

    if (this.carouselElement) new RevolutionSwiper(this.carouselElement);
    if (!this.dataset.recommendations && this.carouselElementThumbs) {
      new RevolutionSwiper(this.carouselElementThumbs);
    }

    new AddToCart(this.element);
  }

  async handleIntersection(entries, observer) {
    const entry = entries?.[0];
    if (!entry?.isIntersecting) return;

    observer.unobserve(this);

    const url = this.dataset?.url;
    if (!url) {
      console.warn("ProductCarousel: Missing data-url attribute.");
      return;
    }

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch content: ${response.status} ${response.statusText}`);
      }

      const text = await response.text();
      const html = document.createElement('div');
      html.innerHTML = text;

      const recommendations = html.querySelector('.product-recommendation');
      if (!recommendations || !recommendations.innerHTML.trim()) {
        console.warn("ProductCarousel: No valid .product-recommendation content.");
        return;
      }

      this.innerHTML = recommendations.innerHTML;

      const swiperEl = this.querySelector('.swiper');
      if (swiperEl) new RevolutionSwiper(swiperEl);

        new RevolutionAnimation(this.element);


      requestAnimationFrame(() => {
        this.element.querySelectorAll('.ProductCard--instantATC').forEach(el => {
          el.style.visibility = 'visible';
        });
      });
    } catch (error) {
      console.error("ProductCarousel: Error loading carousel content.", error);
    }
  }
}

customElements.define("product-carousel", ProductCarousel);

class FavoritesDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.cache = favoritesCache; // Use the shared cache instance
  }

  async connectedCallback() {

    const favorites = this.getFavorites();

    this.favPopulated = document.querySelectorAll(".header__favorites--populated");
    if (favorites.length > 0) {


      this.updateFavoritesAcrossSite();
      // Load cached products on page load
      await this.cache.loadFromStorage();
    }
    this.favoritesDrawer = new Drawer(this.element, {
      onClose: () => {
        this.open = false;
        this.previousLocalStorageValue = localStorage.getItem("productFavorites");
      },
      onOpen: () => {
        if (this.previousLocalStorageValue !== localStorage.getItem("productFavorites") && favorites.length > 0) {
          this.renderProducts();
        }
        this.open = true;
      },
    });

    this.delegateBody = new Delegate(document.body);
    new AddToCart(this.element);
    this.options = JSON.parse(this.element.getAttribute("data-settings"));


    this.contentElement = document.querySelector(".favorites__content");
    this.loader = this.element.querySelector(".spinningLoader");

    this.previousLocalStorageValue = localStorage.getItem("productFavorites");

    this.bindEvents();
    if (favorites.length > 0) {
      this.renderProducts();
    }
    this.initCarousel();
  }

  bindEvents() {
    this.updateFavoritesListener = this.updateFavoritesAcrossSite.bind(this);
    document.addEventListener("update-favorites", this.updateFavoritesListener);

    this.delegateBody.on("click", '[data-action="toggle-favorites"]', this.toggleFavorite.bind(this));
    this.delegateBody.on("keydown", '[data-action="toggle-favorites"]', this.toggleFavorite.bind(this));
  }

  async toggleFavorite(e) {
    if (e.key && e.key !== "Enter") return;
    e.preventDefault();


    const productId = e.target.parentElement.getAttribute("data-id") || e.target.getAttribute("data-id");
    if (!productId) return;

    const favorites = this.getFavorites();
    const isFavorite = favorites.includes(productId);

    const isInsideDrawer = this.element.contains(e.target);

    if (isFavorite) {
      if (isInsideDrawer) {
        //Animate product that is removed from favorites drawer
        const productElement = e.target.closest('.favorites-item');
  
        if (productElement) {
          productElement.classList.add('fade-out-right');
  
          productElement.addEventListener('animationend', () => {
            this.removeProduct(productId);
          }, { once: true });
        } else {
          // Fallback if not found
          this.removeProduct(productId);
        }
      } else {
        this.removeProduct(productId); //No animation outside drawer
      }
    } else {
      await this.addProduct(productId);
    }
  }

  async addProduct(productId) {
    let favorites = this.getFavorites();

    if (!favorites.includes(productId)) {
      favorites.unshift(productId);
      this.saveFavorites(favorites);

      // Fetch and add product to cache
      const productHtml = await this.fetchProductHtml(productId);
      if (productHtml) {
        this.cache.addProducts(productHtml);
        this.renderProducts(); // Refresh UI
      }
    }
  }

  async fetchProductHtml(productId) {
    try {
      const response = await fetch(`${window.routes.localeRootUrl}/search?view=recently&type=product&q=id:${productId}`);
      return await response.text();
    } catch (error) {
      console.error("Error fetching product:", error);
      return null;
    }
  }

  removeProduct(productId) {
    let favorites = this.getFavorites();
    favorites = favorites.filter((id) => id !== productId);

    this.saveFavorites(favorites);
    this.cache.removeProduct(productId); // Remove from cache

    this.renderProducts(); // Refresh UI
  }

  renderProducts() {
    const cachedProducts = this.cache.getProducts();

    this.contentElement.innerHTML = ""; // Clear existing content
    this.contentElement.classList.add('favorites-grid');
    if (cachedProducts.length > 0) {
      cachedProducts.forEach((product) => {
        this.contentElement.appendChild(product.cloneNode(true));
      });
    } else {
      this.fetchAndRenderFavorites(); // Fetch if cache is empty
    }
  }

  async fetchAndRenderFavorites() {
    try {
      const response = await fetch("/?section_id=favorites");
      const html = await response.text();
      const tempElement = document.createElement('div');
      tempElement.innerHTML = html;
      this.contentElement.innerHTML = tempElement.querySelector('.favorites__content').innerHTML;
      this.contentElement.classList.remove('favorites-grid');

      this.initCarousel();
    } catch (error) {
      console.error("Error fetching main favorites section:", error);
    }
  }

  saveFavorites(items) {
    localStorage.setItem("productFavorites", JSON.stringify(items.slice(0, 50)));
    this.updateFavoritesAcrossSite();
  }

  getFavorites() {
    return JSON.parse(localStorage.getItem("productFavorites") || "[]").filter((id) => id !== null);
  }

  updateFavoritesAcrossSite() {
    const items = this.getFavorites();
    const favoritesButtons = [...document.querySelectorAll('[data-action="toggle-favorites"]')];

    this.favPopulated.forEach((item) => {
      item.style.opacity = items.length > 0 ? "1" : "0";
    });

    favoritesButtons.forEach((item) => {
      const myID = item.getAttribute("data-id");
      const exists = items.includes(myID);
      item.setAttribute("state", exists ? "active" : "not-active");
    });

    //Update favorites count in header
    const favorites = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    const favoritesCount = favorites.length;
    
    const favoritesCountEl = document.querySelector('.header__favorites-count');
    
    if (favoritesCount > 0) {
      favoritesCountEl.classList.add('visible');
      favoritesCountEl.innerHTML = favoritesCount;
    } else {
      favoritesCountEl.classList.remove('visible');
      favoritesCountEl.innerHTML = '';
    }
  }

  initCarousel() {

    const slidesPerViewD = 2.4977;
    const slidesPerViewM = 2.1937;



    new Swiper('.favorites__recommendations-swiper', {
      slidesPerView: slidesPerViewM,
      spaceBetween: 8,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },   
      breakpoints: {
        1025: {
          slidesPerView: slidesPerViewD,
          spaceBetween: 16,
          slidesOffsetBefore: 48,
          slidesOffsetAfter: 48,
          pagination: {
            el: "#favorites-drawer__swiper-pagination",
            type: "bullets",
            clickable: true,
            spaceBetween: 16,
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active"
          },
          navigation: {
                nextEl: ".swiperButtonNext",
                prevEl: ".swiperButtonPrevious"
            }
        }
      }
    });

  }
}

customElements.define("favorites-drawer", FavoritesDrawer);

class CollectionShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.responsive = new Responsive();
    this.delegateElement = new Delegate(this.element);

    this.carouselElement = this.element.querySelector(".collection-showcase__wrapper");
    this.textElement = this.element.querySelector(".collection-showcase__text ");

    if (this.carouselElement) {
      if ((responsive.matchesBreakpoint("pocket") && this.options.slideshowMobile)) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
        this.carousel.swiperElement.on('transitionEnd', this.handleSlideChange.bind(this));
        const activeSlide = this.carouselElement.querySelector('.swiper-slide-active');
        if (activeSlide) {
          const textEl = activeSlide.querySelector('.collection-showcase__text');
          if (textEl) {
            textEl.classList.add('is-visible');
          }
        }
      } else if (responsive.matchesBreakpoint("pocket") && !this.options.slideshowMobile) {
        const textElements = this.element.querySelectorAll('.collection-showcase__text');
        textElements.forEach(textEl => {
          textEl.classList.add("is-visible");
          textEl.setAttribute('aria-hidden', 'false');
        });
      }
    }

    this.bindEvents()

  }

  bindEvents() {
    if ((responsive.matchesBreakpoint("lap_and_up"))) {
      this.delegateElement.on(
        "mouseover",
        '[data-action="toggle-text"]',
        this.handleToggle.bind(this),
        true
      );

      this.delegateElement.on(
        "mouseleave",
        '[data-action="toggle-text"]',
        this.handleMouseLeave.bind(this),
        true
      );
     }
 
  }

  handleToggle(e) {
     const textEl = e.target.querySelector('.collection-showcase__text');
     if (!textEl || textEl.classList.contains('is-visible')) return;
     textEl.style.display = 'block';
     const fullHeight = textEl.scrollHeight + 'px';

     requestAnimationFrame(() => {
       textEl.style.height = fullHeight;
       textEl.classList.add('is-visible');
     });
  }

  handleSlideChange() {
    const slides = this.carouselElement.querySelectorAll('.swiper-slide');

    slides.forEach(slide => {
      const textEl = slide.querySelector('.collection-showcase__text');
      if (textEl) {
        // Hide and reset all text blocks
        textEl.classList.remove('is-visible');
        textEl.style.height = '0px';
      }
    });

    const activeSlide = this.carouselElement.querySelector('.swiper-slide-active');
    if (!activeSlide) return;
  
    const textEl = activeSlide.querySelector('.collection-showcase__text');
    if (!textEl || textEl.classList.contains('is-visible')) return;
  
    textEl.style.display = 'block';
    const fullHeight = textEl.scrollHeight + 'px';
  
    requestAnimationFrame(() => {
      textEl.style.height = fullHeight;
      textEl.classList.add('is-visible');
    });
  }


  handleMouseLeave(e) {
    const textEl = e.target.querySelector('.collection-showcase__text');
    if (!textEl || !textEl.classList.contains('is-visible')) return;

    const currentHeight = textEl.scrollHeight + 'px';
    textEl.style.height = currentHeight;
    textEl.offsetHeight; // force reflow
    textEl.style.height = '0px';
    textEl.classList.remove('is-visible');

    textEl.addEventListener('transitionend', function handler(event) {
      if (event.propertyName === 'height') {
        textEl.style.display = 'none';
        textEl.style.height = '';
        textEl.removeEventListener('transitionend', handler);
      }
    });
  }


}

customElements.define("collection-showcase", CollectionShowcase);


class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);


  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);

      if (this.carousel.swiperElement) {
        this.carousel.swiperElement.on("reachBeginning", () => {
          if (this.carousel.swiperElement.params.rewind && this.carousel.swiperElement.params.autoplay) {
            this.carousel.swiperElement.autoplay.stop();
          }
        })
      }

      this.createObserver();
    } else {
      this.createObserver();
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {

    
    // Get the current breakpoint.
    const breakpoint = responsive.getCurrentBreakpoint();

    // Check if this is the first slide and should be prioritized
    const isFirstSlide = !this.carousel || this.carousel.swiperElement.activeIndex === 0;
    const shouldPrioritize = this.options["prioritize_first_slide"] || (singleItem && isFirstSlide);

    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = 
      Array.from(this.element.querySelectorAll(".image__element")).slice(0, 2);
       
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];
 
      imageContainers = Array.from(
        cellElement.querySelectorAll(".image__element")).slice(0, 2);
      

  
    }



    // If no image containers are found, return.
    if (imageContainers.length === 0) {
      return;
    }

    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal;
    if (
      breakpoint === "pocket" ||
      breakpoint === "phone" ||
      breakpoint === "tablet"
    ) {
      imageToReveal = imageContainers[0];
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1];
      } else {
        imageToReveal = imageContainers[0];
      }
    }
 

    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === "true") {
      return;
    }
   
    
  
    if (imageToReveal.dataset.src) {
      // Replace the image URL with a higher quality version.
      const replaceUrl = imageToReveal.dataset.src.replace(
        "{width}x",
        "width=2600"
      );
      
      // Set loading attribute based on priority
      if (shouldPrioritize) {
        imageToReveal.loading = "eager";
      }
      
      // Add error handling
      imageToReveal.onerror = () => {
        console.warn('Failed to load high-quality image, keeping original');
      };
      
      imageToReveal.src = replaceUrl;
      imageToReveal.dataset.loadedImage = "true";
    }
  }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.favorites = this.element.querySelector('.fav-icons__wrapper');
    this.scrollableElement = this.element.querySelector("[data-scrollable]");
    this.headerTransparent = false;
    this.lastScrollPosition = 0;

    this.bindEvents();

    if (this.options.sticky) {
      this.toggleSticky();
    }

    if (this.favorites) {
      const favorites = JSON.parse(localStorage.getItem("productFavorites") || "[]");
      const favoritesCount = favorites.length;

      const favoritesCountEl = this.favorites.querySelector('.header__favorites-count');

      if (favoritesCount > 0) {
        favoritesCountEl.classList.add('visible');
        favoritesCountEl.innerHTML = favoritesCount;
      }
    }

    document.documentElement.style.setProperty(
      "--header-height-fixed",
      document.querySelector("#header").offsetHeight + "px"
    );

    // Initialize all swipers
    this.desktopMenuSwipers = Array.from(this.querySelectorAll(".main-menu__swiper")).map((el) => ({
      el,
      instance: new RevolutionSwiper(el),
    }));

    // Initialize all vertical swipers
    this.desktopMenuVerticalSwipers = Array.from(this.querySelectorAll(".main-menu__swiper.vertical")).map((el) => ({
      el,
      instance: new RevolutionSwiper(el),
    }));

    this.updateVisibleHeight();
  }

  bindEvents() {
    if (this.options.transparent && this.options.sticky) {
      this.toggleColorListener = this.toggleColor.bind(this);
      window.addEventListener("scroll", this.toggleColorListener);
    }

    this.closeMenuListener = this.closeMenu.bind(this);
    this.openMenuListener = this.openMenu.bind(this);
    this.openSubmenu = this.handleSubmenu.bind(this);
    this.hideSubmenu = this.hideSubmenus.bind(this);
    this.isOpen = false;

    // Desktop menu optimization - bind transition events
    this._onDesktopMenuTransitionStart = this.onDesktopMenuTransitionStart.bind(this);
    this._onDesktopMenuTransitionEnd = this.onDesktopMenuTransitionEnd.bind(this);

    if (!this.options.sticky) {
      window.addEventListener("scroll", this.toggleColorListener);
    }

    this.delegateElement.on("mouseenter", ".desktop_menu_links_list", this.openSubmenu, true);

    this.delegateElement.on(
      "mouseenter",
      '[data-action="toggle-image-hover"]',
      this.handleImageHover.bind(this),
      true
    );

    this.delegateElement.on("mouseenter", "[aria-hasMenu='true']", this.openMenuListener, true);

    this.delegateElement.on("mouseleave", ".drawer-wrapper-desktop", this.closeMenuListener, true);

    this.delegateElement.on("click", ".header-link_list", this.closeMenuListener, true);

    this.delegateElement.on("focusin", "[aria-hasMenu='true']", this.openMenuListener, true);

    this.delegateElement.on("mouseover", ["aria-singlemenu", ".header-links"], this.closeMenuListener, true);

    this.delegateElement.on("focusin", "[aria-singleMenu], .header-links", this.closeMenuListener, true);

    this.delegateBody.on("menu:close", this.closeMenuListener);

    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));
  }

  updateVisibleHeight() {
    setTimeout(() => {
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      // Calculate the visible height
      let visibleHeight =
        Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

      // Ensure the visibleHeight is never negative
      visibleHeight = Math.max(visibleHeight, 0);
      // Update the height of header with the visible height
      document.documentElement.style.setProperty(
        "--header-dynamic-height",
        `${visibleHeight}px`
      );

      document.documentElement.style.setProperty(
        "--header-height-fixed",
        document.querySelector("#header").offsetHeight + "px"
      );

      const drawer = document.querySelector(".drawer-wrapper-desktop");
      const drawerHeader = document.querySelector(".desktop-menu_link-holder");

      // Save original inline styles to restore later
      const originalDisplay = drawer.style.display;

      // Temporarily make it visible but not affecting layout
      drawer.style.display = "flex";
      
      let height = 0;
      if(drawerHeader) {
        height = drawerHeader.offsetHeight;
      }
      
      // Restore original styles
      drawer.style.display = originalDisplay;
      
      // Set CSS variable
      document.documentElement.style.setProperty("--header-menu-header-height", height + "px");
    }, 250);
  }

  toggleSticky() {
    document.querySelector('#header').parentElement.classList.add("header--Sticky");
  }

  openMenu(event, target) {
    // Dispatch a custom event to indicate that the menu is being opened
    this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));

    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === "mouseenter" && target !== event.target) {
      return;
    }

    if (this.element.classList.contains("Header--Transparent")) {
      this.element.classList.remove("Header--Transparent");
      this.headerTransparent = true;
    }

    // Close any siblings of the target element first.
    const siblings = Array.from(target.parentElement.children).filter(
      (child) =>
        child !== target && child.getAttribute("aria-expanded") === "true"
    );
    siblings.forEach((item) => item.setAttribute("aria-expanded", "false"));

    // Desktop menu optimization: prepare for opening BEFORE setting aria-expanded
    this.prepareDesktopMenuForOpening(target);

    // Set aria-expanded with small delay to allow display: block to take effect first
    setTimeout(() => {
      target.setAttribute("aria-expanded", "true");
    }, 10);

    // Disable body scroll on the scrollable element inside the menu.
    bodyScrollLock.disableBodyScroll(
      this.scrollableElement,
      bodyScrollLockOptions
    );
  }

  hideSubmenus() {
    const allSubmenus = document.querySelectorAll('.main-menu_multiple_content');
    allSubmenus.forEach((submenu) => {
      submenu.setAttribute("aria-expanded", "false");
    });
  }

  handleDesktopMenu(event, options) {
    const { tabSelector, slideSelector, swiperArray } = options;
    const target = event.target;
    if (!target) return;

    const desktopDropdown = this.element.querySelector('.header-links[aria-expanded="true"] .desktop-menu_dropdown');
    if (!desktopDropdown) return;

      // 1. Remove "active" class from all submenu elements
    const allTabs = desktopDropdown.querySelectorAll(tabSelector);
    allTabs.forEach((tab) => tab.classList.remove("active"));

    // 2. Use currentTarget instead of target to avoid child element events
    if (event.currentTarget.classList.contains("desktop_menu_links_list")) {
      event.currentTarget.classList.add("active");
    }

    // Alternative: If you're using event delegation, find the correct parent
    const menuItem = event.target.closest('.desktop_menu_links_list');
    if (menuItem) {
      menuItem.classList.add("active");
    }

       // 3. Get the slide ID
    const slideId = target.dataset.toggleSlideId;
    if (!slideId) return;
  
    // 4. Find the corresponding slide index
    const slides = desktopDropdown.querySelectorAll(slideSelector);
    const targetIndex = Array.from(slides).findIndex(
      (slide) => slide.dataset.slideId === slideId
    );
  
    // 5. Slide to that index
    const matchingSwiper = swiperArray.find(({ el }) =>
      desktopDropdown.contains(el)
    );

    if (targetIndex !== -1 && matchingSwiper) {
      matchingSwiper.instance.swiperElement.slideTo(targetIndex);
    }
  }

  handleSubmenu(event) {
    this.handleDesktopMenu(event, {
      tabSelector: '.desktop_menu_links_list',
      slideSelector: '.main-menu_multiple_content.swiper-slide',
      swiperArray: this.desktopMenuSwipers,
    });
  }

  handleImageHover(event) {
    this.handleDesktopMenu(event, {
      tabSelector: '.main-menu__sublink-wrapper.vertical .desktop_menu_links_list',
      slideSelector: '.main-menu__sublink-image-wrapper .swiper-slide',
      swiperArray: this.desktopMenuVerticalSwipers,
    });
  }

  closeMenu(event, target) {
    if (event.type === 'mouseleave' && !event.target.classList.contains('drawer-wrapper-desktop')) {
      return;
    }
    if (event.type !== "mouseleave" && target && target.closest('.header-links')?.getAttribute('aria-expanded') === 'true') {
      return;
    }

    if (event.type === "mouseleave" && !this.element.contains(event.toElement) && !this.element.contains(event.target)) {
      return;
    }

    const openElement = this.element.querySelector('.header-links[aria-expanded="true"]');
    if (!openElement) return;

    // Desktop menu optimization: prepare for closing
    this.prepareDesktopMenuForClosing(openElement);

    openElement.setAttribute("aria-expanded", "false");

    if (this.options.transparent) {
      this.toggleColor();
    }

    bodyScrollLock.enableBodyScroll(this.scrollableElement);
  }

    toggleColor() {
    const currentScroll = window.pageYOffset;
    const scrollingDown = currentScroll > this.lastScrollPosition;
    const scrollingUp = currentScroll < this.lastScrollPosition;
  
    // SCROLL DOWN — Add scrolled, remove transparent
    if (currentScroll > 45 && scrollingDown) {
      this.element.parentElement.classList.add("Header--Scrolled");
      this.element.classList.remove("Header--Transparent");
    }
  
    // SCROLL UP — Remove scrolled, keep opaque
    if (scrollingUp && currentScroll > 0) {
      this.element.parentElement.classList.remove("Header--Scrolled");
      this.element.classList.remove("Header--Transparent"); // stay solid
    }
  
    // AT THE VERY TOP — restore transparency
    if (currentScroll <= 0) {
      this.element.parentElement.classList.remove("Header--Scrolled");
  
      if (this.options.transparent) {
        this.element.classList.add("Header--Transparent");
      }
    }
  
    this.lastScrollPosition = currentScroll;
  }

  // Desktop menu optimization methods
  prepareDesktopMenuForOpening(target) {
    const drawerElement = target.querySelector('.drawer-wrapper-desktop');
    if (!drawerElement) return;

    // Step 1: Set display: block first
    drawerElement.style.display = 'block';
    drawerElement.classList.add('menu-preparing');
    
    // Step 2: Force browser reflow to apply display: block
    drawerElement.offsetHeight;
    
    // Step 3: Add transition event listeners
    drawerElement.addEventListener('transitionstart', this._onDesktopMenuTransitionStart);
    drawerElement.addEventListener('transitionend', this._onDesktopMenuTransitionEnd);
  }

  prepareDesktopMenuForClosing(openElement) {
    const drawerElement = openElement.querySelector('.drawer-wrapper-desktop');
    if (!drawerElement) return;
    
    // Add transition event listeners for closing
    drawerElement.addEventListener('transitionstart', this._onDesktopMenuTransitionStart);
    drawerElement.addEventListener('transitionend', this._onDesktopMenuTransitionEnd);
  }

  onDesktopMenuTransitionStart(event) {
    // Additional logic can be added here if needed during transition start
  }

  onDesktopMenuTransitionEnd(event) {
    const drawerElement = event.target;
    if (!drawerElement.classList.contains('drawer-wrapper-desktop')) return;
    
    const headerLink = drawerElement.closest('.header-links');
    const isExpanded = headerLink?.getAttribute('aria-expanded') === 'true';
    
    if (!isExpanded) {
      // Menu is closed - hide it completely for performance
      drawerElement.style.display = 'none';
      drawerElement.classList.remove('menu-preparing');
    }
    
    // Remove event listeners
    drawerElement.removeEventListener('transitionstart', this._onDesktopMenuTransitionStart);
    drawerElement.removeEventListener('transitionend', this._onDesktopMenuTransitionEnd);
  }
}

customElements.define("header-component", Header);


class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    
    // Initialize menu visibility on construction
    this.initializeMenuVisibility();
    
    const allDrawer = this.element.querySelectorAll(".Drawer--wrapper");
    allDrawer.forEach((item) => {
      new Drawer(item);
    });
    this.bindEvents();
  }
  bindEvents() {
    window.addEventListener('DOMContentLoaded', this.updateHeights.bind(this));
    
    // Initialize menu visibility on DOM ready
    window.addEventListener('DOMContentLoaded', this.initializeMenuVisibility.bind(this));
    
    // Backup timer for heights calculation
    window.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        this.updateHeights();
      }, 100);
    });
    
    // Recalculate heights on window resize
    window.addEventListener('resize', this.updateHeights.bind(this));

    if (!responsive.matchesBreakpoint("lap_and_up")) {
      this.delegateElement.on(
        "click",
        '[data-action="toggle-subdrawer"]',
        this.toggleNextElement.bind(this)
      );
    }

    


    this.delegateElement.on(
      "click",
      '[data-action="toggle-mob-acc"]',
      this.handleAccPopup.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="toggle-prev-subdrawer"]',
      this.togglePreviusElement.bind(this)
    );

    document.addEventListener("menu-drawer:closed", this.closeSubdrawers.bind(this));

    // Observe subdrawer open/close to keep heights in sync
    try {
      this._heightObserver = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.type === 'attributes' && m.attributeName === 'aria-expanded') {
            // Recalculate after styles apply
            requestAnimationFrame(() => this.updateHeights());
            break;
          }
        }
      });
      this.element.querySelectorAll('[data-subdrawer]').forEach(el => {
        this._heightObserver.observe(el, { attributes: true, attributeFilter: ['aria-expanded'] });
      });
    } catch(_) {}
  }

handleAccPopup(e) {
  e.preventDefault();

  // 1) Grab the popup element
  const button  = e.target.closest('[data-action="toggle-mob-acc"]');
  const popupId = button && button.getAttribute('aria-controls');
  const popupEl = popupId && document.getElementById(popupId);
  if (!popupEl) return;

  // 2) Find your "menu" drawer instance
  const menuDrawer = Array.isArray(Drawer.instances)
    ? Drawer.instances.find(d => d.element.id === 'menu')
    : null;

  // 3) If it's open, close it and then delay opening the popup
  if (menuDrawer && menuDrawer.isOpen) {
    // start the CSS slide-out
    menuDrawer.closeDrawer();

    // figure out how long the CSS transition actually is
    const style = window.getComputedStyle(menuDrawer.element);
    const durations = style.transitionDuration.split(',').map(s => parseFloat(s) || 0);
    const delays    = style.transitionDelay.split(',').map(s => parseFloat(s) || 0);
    // add each duration+delay, take the max, convert to ms
    const waitMs = Math.max(
      ...durations.map((d, i) => (d + (delays[i] || 0)) * 1000)
    );

    // only after the drawer's animation finishes…
    setTimeout(() => {
      window.globalPopup.openPopup(popupEl);
    }, waitMs);
  } else {
    // already closed, just open it
    window.globalPopup.openPopup(popupEl);
  }
}




  updateHeights() {
    // Prefer measurements from the currently open subdrawer (if any)
    const openWrapper = this.element.querySelector('[data-subdrawer][aria-expanded="true"]')
      || this.element.querySelector('#menu')
      || this.element;

    const headerEl = openWrapper.querySelector('.menu__header') || this.element.querySelector('.menu__header');
    const footerEl = this.element.querySelector('.menu__bottom-content');
    const specialEl = openWrapper.querySelector('.menu__special-menu') || this.element.querySelector('.menu__special-menu');

    const measure = (el) => {
      if (!el) return 0;
      // getBoundingClientRect captures fractional device pixels and transformed elements
      let h = Math.round(el.getBoundingClientRect().height);
      if (!h) h = el.offsetHeight || el.clientHeight || el.scrollHeight || 0;
      if (!h) {
        const cs = window.getComputedStyle(el);
        const parsed = parseFloat(cs.height);
        if (!Number.isNaN(parsed)) h = Math.round(parsed);
      }
      return h || 0;
    };

    const headerHeight = measure(headerEl);
    const footerHeight = measure(footerEl);
    const specialHeight = measure(specialEl);

    document.documentElement.style.setProperty('--mobile-menu-header-height', `${headerHeight}px`);
    document.documentElement.style.setProperty('--mobile-menu-footer-height', `${footerHeight}px`);
    document.documentElement.style.setProperty('--mobile-special-menu-height', `${specialHeight}px`);
  }


  toggleLinks(toggleLinks, target) {
    toggleLinks.forEach(link => {
      if (link !== target) {
        link.setAttribute('aria-expanded', 'false');
      }
    });
  }

  toggleNextElement(event, target) {
    event.preventDefault();
    let nextEl = target.getAttribute("data-toggle-id");
    let subdrawer = document.getElementById(nextEl);
    if (!subdrawer) {
      try {
        // Fallback using CSS.escape if available
        const esc = window.CSS && CSS.escape ? CSS.escape(nextEl) : nextEl.replace(/[^a-zA-Z0-9_\-]/g, "\\$&");
        subdrawer = this.element.querySelector('#' + esc);
      } catch(_) {
        subdrawer = this.element.querySelector('#' + nextEl);
      }
    }
    if (!subdrawer) return;
      const specialMenu = target.closest('.menu__special-menu');
      
     if (specialMenu && subdrawer) {
        subdrawer.style.zIndex = '23';
      }
  

    if (responsive.matchesBreakpoint("lap_and_up")) {
      if (event.target.classList.contains('menu__toggle-link')) {
        event.target.setAttribute("aria-expanded", "false");
      } else {
        event.target.closest('.menu__toggle-link').setAttribute("aria-expanded", "true");
      }

      const otherLinks = event.target.closest('.menu__wrapper').querySelectorAll('.menu__toggle-link[aria-expanded="true"]');
      this.toggleLinks(otherLinks, target);

  // Use rAF instead of a magic timeout; let the DOM paint, then toggle
  requestAnimationFrame(() => {
        if (!target.dataset.third) {
          this.prevSubdrawer = this.element.querySelectorAll("[data-subdrawer]");
          this.prevSubdrawer.forEach((item) => {
            item.setAttribute("aria-expanded", "false");
          });

        } else {

          this.secondLvlDrawer = this.element.querySelectorAll(".menu__third");
          this.secondLvlDrawer.forEach((item) => {
            item.setAttribute("aria-expanded", "false");
          });
        }

        // Step 1: make it visible in the CLOSED state so CSS can animate
        subdrawer.setAttribute("aria-hidden", "false");
        subdrawer.setAttribute("aria-expanded", "false");
        // Force reflow now that it's visible to flush the closed state
        void subdrawer.getBoundingClientRect();
        // Step 2: next frame flip to open -> transition runs
        requestAnimationFrame(() => {
          subdrawer.setAttribute("aria-expanded", "true");
          const focus = subdrawer.querySelector("[data-scrollable]");
          bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
          // Sync trigger button a11y state
          if (target && target.setAttribute) {
            target.setAttribute('aria-expanded', 'true');
          }
        });
  });
    } else {
      // Mobile: proactively close any other open subdrawers to avoid stuck states
      const openSubdrawers = this.element.querySelectorAll('[data-subdrawer][aria-expanded="true"]');
      openSubdrawers.forEach(d => {
        d.setAttribute('aria-expanded', 'false');
        if (d && d.style) d.style.zIndex = '';
        const f = d.querySelector('[data-scrollable]');
        if (f) bodyScrollLock.enableBodyScroll(f);
      });
      // Reset all toggle buttons
      this.element.querySelectorAll('[data-action="toggle-subdrawer"]').forEach(btn => btn.setAttribute('aria-expanded','false'));
      // Use rAF instead of a magic timeout; let the DOM paint, then toggle
      requestAnimationFrame(() => {
        // Step 1: make it visible in CLOSED state so CSS can animate
        subdrawer.setAttribute("aria-hidden", "false");
        subdrawer.setAttribute("aria-expanded", "false");
        // Force reflow now that it's visible to flush the closed state
        void subdrawer.getBoundingClientRect();
        // Step 2: next frame flip to open -> transition runs
        requestAnimationFrame(() => {
          subdrawer.setAttribute("aria-expanded", "true");
          const focus = subdrawer.querySelector("[data-scrollable]");
          bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
          // Sync trigger button a11y state
          if (target && target.setAttribute) {
            target.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }

    // Recalculate heights after subdrawer changes
    setTimeout(() => {
      this.updateHeights();
    }, 20);

  }

  togglePreviusElement(event, target) {
    event.preventDefault();
    this.subdrawer = target.closest(".menu__wrapper");

  this.subdrawer.setAttribute("aria-expanded", "false");

    const focus = this.subdrawer.querySelector("[data-scrollable]");
    bodyScrollLock.enableBodyScroll(focus);
    this.transitionEndedListener = this.translateTransitionEnded.bind(this);
    this.subdrawer.addEventListener(
      "transitionend",
      this.transitionEndedListener
    );
    // Also handle CSS keyframe animations if used
    this.subdrawer.addEventListener(
      "animationend",
      this.transitionEndedListener
    );

    // Keep elevated z-index during closing animation to avoid flicker over special menu

    // Sync trigger button state back to false
    const controllingBtn = this.element.querySelector('[data-action="toggle-subdrawer"][data-toggle-id="' + this.subdrawer.id + '"]');
    if (controllingBtn) {
      controllingBtn.setAttribute('aria-expanded', 'false');
    }

    // Recalculate heights after subdrawer closes
    setTimeout(() => {
      this.updateHeights();
    }, 20);
  }

  closeSubdrawers(event, target) {
    event.preventDefault();

    const subdrawers = this.element.querySelectorAll('.Drawer--wrapper.menu__wrapper');
    subdrawers.forEach(drawer => {
      drawer.setAttribute("aria-expanded", "false");
      drawer.setAttribute("aria-hidden", "true");
      // Reset any inline z-index from special menu
      if (drawer && drawer.style) drawer.style.zIndex = '';
      const f = drawer.querySelector('[data-scrollable]');
      if (f) bodyScrollLock.enableBodyScroll(f);
    });

    // Reset all toggle buttons to collapsed
    this.element.querySelectorAll('[data-action="toggle-subdrawer"]').forEach(btn => btn.setAttribute('aria-expanded','false'));

    // Recalculate heights after closing subdrawers
    setTimeout(() => {
      this.updateHeights();
    }, 20);
  }

  translateTransitionEnded(e) {
    if (!e || (e.type === 'animationend') || (e && (e.propertyName == "transform" || e.propertyName == 'clip-path' || e.propertyName == 'opacity'))) {
      // Hide after the close animation completes to preserve animation
      if (this.subdrawer) {
        this.subdrawer.setAttribute('aria-hidden', 'true');
        // Now it's safe to drop any elevated z-index
        if (this.subdrawer.style) {
          this.subdrawer.style.zIndex = '';
        }
      }
      this.subdrawer.removeEventListener(
        "transitionend",
        this.transitionEndedListener
      );
      this.subdrawer.removeEventListener(
        "animationend",
        this.transitionEndedListener
      );
  // Clear reference to allow clean re-open next time
  this.subdrawer = null;
    }
  }

  // Initialize menu visibility state
  initializeMenuVisibility() {
    const menuWrapper = this.element.querySelector('#menu');
    if (menuWrapper) {
      // Set initial state
      menuWrapper.setAttribute('aria-hidden', 'true');
      menuWrapper.setAttribute('aria-expanded', 'false');
      menuWrapper.classList.add('menu-fully-hidden');
      menuWrapper.style.display = 'none';
    }
  }
}

customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {

      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();


class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.isTextDisabled =  this.element.getAttribute("data-text-disable");
    this.sectionId = this.element.getAttribute("data-section-id");
    this.trueObserver = false;
    this.delegateElement = new Delegate(this.element);

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();

       // Prevent autoplay if viewport is false
      if (this.videoPlayer && !this.options.viewport) {
        this.videoPlayer.pause();
      }
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          } else {
            this.videoPlayer.pause();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          } else {
            this.videoPlayer.pause();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const isMobile = responsive.matchesBreakpoint("pocket");

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: false,
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }

       if (!_this.options.viewport) {
         _this.videoPlayer.pause();
       }

      if (_this.element.querySelector('.section-video__controls')) {
        _this.element.querySelector(".video-js").append(_this.element.querySelector('.section-video__controls'));
      }


      _this.bindCustomControls();
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"]) {

      if (host == "html5") {
        this.videoPlayer.on("touchstart", function () {

          if (event.target.closest(".vjs-control-bar")) {
            return;
          }

          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }

      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }
  }

  bindCustomControls() {
    // Get all the control elements within this specific component.
    this.stateElements = this.element.querySelectorAll("[data-action='toggle-state']");
    this.soundElements = this.element.querySelectorAll("[data-action='toggle-sound']");
    this.fullscreenElements = this.element.querySelectorAll("[data-action='toggle-fullscreen']");
    this.progressElement = this.element.querySelector("[data-action='seek-progress']"); // We still get it, just don't add seeking listeners.

    // Check if any elements exist before proceeding.
    if (!this.stateElements.length && !this.soundElements.length && !this.fullscreenElements.length && !this.progressElement) {
      console.warn("VideoComponent: No custom control elements found to bind.");
      return;
    }

    // --- Bind Click Handlers using Delegation ---

    // Bind play/pause button(s).
    this.delegateElement.on("click", "[data-action='toggle-state']", () => {
      // If player is paused, play it; otherwise, pause it.
      this.videoPlayer.paused() ? this.videoPlayer.play() : this.videoPlayer.pause();
    });

    // Bind mute/unmute button(s).
    this.delegateElement.on("click", "[data-action='toggle-sound']", () => {
      // Toggle the muted state.
      this.videoPlayer.muted(!this.videoPlayer.muted());
    });

    // Bind fullscreen button(s).
    this.delegateElement.on("click", "[data-action='toggle-fullscreen']", () => {
      // If player is not in fullscreen, request it; otherwise, exit.
      if (!this.videoPlayer.isFullscreen()) {
        this.videoPlayer.requestFullscreen();
      } else {
        this.videoPlayer.exitFullscreen();
      }
    });


    this.bindPlayerEventsToControls();
  }

  /**
   * Binds Video.js player events to update the state/appearance
   * of our custom control elements.
   */
  bindPlayerEventsToControls() {
    // Ensure we have a video player instance.
    if (!this.videoPlayer) {
      console.error("VideoComponent: videoPlayer not ready for binding events.");
      return;
    }

    // Update Play/Pause button state.
    this.videoPlayer.on("play", () => {
      // Set ARIA label for accessibility.
      this.stateElements.forEach(el => el.setAttribute("aria-label", "playing"));
      // Add/remove classes for CSS styling.
      this.element.classList.add('video-is-playing');
      this.element.classList.remove('video-is-paused');

        // Hide text if disabled
        if (this.isTextDisabled === "true") {
          const section = this.element.closest('.shopify-section');
          const textEl = section?.querySelector('.hero-banner-txt-content__wrapper');
          if (textEl) {
            textEl.style.transition = 'opacity 0.5s ease';
            textEl.style.opacity = '0';
            setTimeout(() => textEl.style.display = 'none', 500);
          }
        }
    });

    // Update Play/Pause button state.
    this.videoPlayer.on("pause", () => {
      // Set ARIA label.
      this.stateElements.forEach(el => el.setAttribute("aria-label", "paused"));
      // Add/remove classes for CSS styling.
      this.element.classList.remove('video-is-playing');
      this.element.classList.add('video-is-paused');

      // Show text
      if (this.isTextDisabled === "true") {
        const section = this.element.closest('.shopify-section');
        const textEl = section?.querySelector('.hero-banner-txt-content__wrapper');
        if (textEl) {
          textEl.style.display = 'block';
          setTimeout(() => {
            textEl.style.transition = 'opacity 0.5s ease';
            textEl.style.opacity = '1';
          }, 10);
        }
      }
    });

    // Update Mute/Unmute button state.
    this.videoPlayer.on("volumechange", () => {
      // Check if the player is currently muted.
      const isMuted = this.videoPlayer.muted();
      // Set ARIA label.
      this.soundElements.forEach(el => el.setAttribute("aria-label", isMuted ? "muted" : "unmuted"));
      // Add/remove classes for CSS styling.
      if (isMuted) {
        this.element.classList.add('video-is-muted');
        this.element.classList.remove('video-is-unmuted');
      } else {
        this.element.classList.remove('video-is-muted');
        this.element.classList.add('video-is-unmuted');
      }
    });

    // Update Fullscreen button state.
    this.videoPlayer.on("fullscreenchange", () => {
      // Check if the player is currently in fullscreen mode.
      const isFullscreen = this.videoPlayer.isFullscreen();
      // Set ARIA label.
      this.fullscreenElements.forEach(el => el.setAttribute("aria-label", isFullscreen ? "exit-fullscreen" : "enter-fullscreen"));
      // Add/remove classes for CSS styling.
      if (isFullscreen) {
        this.element.classList.add('video-is-fullscreen');
        this.element.classList.remove('video-is-windowed');
      } else {
        this.element.classList.remove('video-is-fullscreen');
        this.element.classList.add('video-is-windowed');
      }
    });

    // Update Progress Bar value.
    this.videoPlayer.on("timeupdate", () => {
      if (this.progressElement) {
        const fillElement = this.progressElement.querySelector('.progress-fill');
        const timeDisplay = this.progressElement.querySelector('.progress-time'); // <- New element to hold time
    
        const currentTime = this.videoPlayer.currentTime();
        const duration = this.videoPlayer.duration();
    
        const percentage = duration > 0 ? (currentTime / duration) * 100 : 0;
    
        if (fillElement) {
          fillElement.style.width = percentage + '%';
        }
    
        if (timeDisplay) {
          const formattedCurrent = this.formatTime(currentTime);
          const formattedTotal = this.formatTime(duration);
          timeDisplay.textContent = `${formattedCurrent} / ${formattedTotal}`;
        }
      }
    });
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          if (this.options["muted"]) {
            this.videoPlayer.muted("true");
          }
          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.clearInput.bind(this)
    );

    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

    // Bind Klaviyo form submit handler
    this.delegateElement.on(
      "submit",
      '#footerForm',
      this.submitFooterNewsletter.bind(this)
    );
  }

  connectedCallback() {
    this.toggleButton();
    this.updateFooterHeight();
    window.addEventListener("load", this.updateFooterHeight);
    responsive.addResizeListener(this, this.updateFooterHeight);
  }

  updateFooterHeight = () => {
    const footerHeight = this.offsetHeight + "px";
    document.documentElement.style.setProperty("--footer-dynamic-height", footerHeight);
    document.documentElement.style.setProperty("--footer-height", footerHeight);
  };

  clearInput() {
    const emailInput = this.querySelector(".input-placeholder");
    const errorSpan = this.querySelector("#footer__newsletter-email--error");
    const submitButton = this.querySelector(".footer__newsletter-submit-button");
    const clearButton = this.querySelector(".footer__newsletter-form--clear");
    const emailWrapper = this.querySelector(".footer__newsletter-form-inputs");

    if (emailInput) emailInput.value = "";
    if (emailInput) emailInput.classList.remove("footer__newsletter-input--error");
    if (errorSpan) errorSpan.style.display = "none";
    if (emailWrapper) emailWrapper.classList.remove("alert");

    if (submitButton) submitButton.style.display = "flex";
    if (clearButton) clearButton.style.display = "none";
  }

  toggleButton() {
    this.buttonState = true;

    var allRequiredFields = this.element.querySelectorAll("[data-state='required']");

    allRequiredFields.forEach((item) => {
      if (item.type === "checkbox" && !item.checked) {
        this.buttonState = false;
      } else if (item.type !== "checkbox" && item.value.trim() === "") {
        this.buttonState = false;
      }
    });

    if (this.buttonState === true) {
      this.element.querySelector(".footer__newsletter-submit-button").removeAttribute("disabled");
    } else {
      this.element.querySelector(".footer__newsletter-submit-button").setAttribute("disabled", true);
    }
  }

  async submitFooterNewsletter(e) {
    // Check if Klaviyo integration is enabled
    if (window.klaviyoPublicKey && window.klaviyoListId) {
      e.preventDefault();
      
      const emailInput = this.element.querySelector('.input-placeholder');
      const emailTxt = emailInput.value.trim();
      const alertErr = this.element.querySelector('#footer__newsletter-email--error');
      const submitButton = this.element.querySelector(".footer__newsletter-submit-button");
      const checkboxField = this.element.querySelector('[data-state="required"]');

      // Email validation
      if (emailTxt === "" || !emailTxt.includes("@")) {
        if (alertErr) {
          alertErr.style.display = "block";
          alertErr.textContent = "Please enter a valid email address.";
          setTimeout(() => {
            alertErr.style.display = "none";
          }, 3000);
        }
        return;
      }

      // Check if checkbox is required and checked
      if (checkboxField && checkboxField.type === 'checkbox' && !checkboxField.checked) {
        if (alertErr) {
          alertErr.style.display = "block";
          alertErr.textContent = "Please accept the privacy policy.";
          setTimeout(() => {
            alertErr.style.display = "none";
          }, 3000);
        }
        return;
      }

      // Disable submit button during request
      if (submitButton) submitButton.setAttribute("disabled", true);

      try {
        await this.handleKlaviyoNewsletterAPI(emailTxt);
        
        // Show success message
        this.showSuccessMessage();
        
      } catch (error) {
        console.error('Klaviyo newsletter signup failed:', error);
        
        // Fall back to Shopify form submission on error
        this.fallbackToShopifyForm();
        
      } finally {
        // Re-enable submit button
        if (submitButton) submitButton.removeAttribute("disabled");
      }
    }
    // If no Klaviyo integration, let the form submit normally to Shopify
  }

  async handleKlaviyoNewsletterAPI(email) {
    // Newsletter subscription data structure (different from back-in-stock)
    const data = {
      type: "subscription",
      attributes: {
        list_id: window.klaviyoListId,
        email: email
      }
    };

    const endpoint = `https://a.klaviyo.com/client/subscriptions/?company_id=${window.klaviyoPublicKey}`;

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json',
        "revision": "2024-06-15"
      },
      body: JSON.stringify({ data }),
    });

    if (!response.ok) {
      throw new Error(`Klaviyo newsletter subscription failed: ${response.statusText}`);
    }

    return response;
  }

  showSuccessMessage() {
    const form = this.element.querySelector('#footerForm');
    const successMessage = document.createElement('p');
    successMessage.className = 'footer__newsletter-form--success u-p2';
    successMessage.textContent = 'Thank you for subscribing!';
    
    // Hide form and show success message
    form.style.display = 'none';
    form.parentNode.insertBefore(successMessage, form.nextSibling);
    
    // Clear the email input
    this.clearInput();
  }

  fallbackToShopifyForm() {
    // On Klaviyo failure, submit form to Shopify's native newsletter system
    const form = this.element.querySelector('#footerForm');
    if (form) {
      // Temporarily remove our event listener to avoid recursion
      this.delegateElement.off("submit", '#footerForm');
      form.submit();
    }
  }
}

customElements.define("footer-component", FooterComponent);

class ProductCarouselUpsell extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    new AddToCart(this.element);
    this.observer = null;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.initCarousels();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("click", "[data-action='toggle-tab']", this.toggleTab.bind(this));
  }

  initCarousels() {
    this.carouselElement = this.element.querySelectorAll(".swiper.pc__carousel");
    this.carouselElementThumbs = this.element.querySelector(".pc__collections");

    const swiperSlides = [];

    if (this.carouselElement) {
      this.carouselElement.forEach((swiperElem, index) => {
        const title = swiperElem.getAttribute('data-title');
        const key = swiperElem.getAttribute('data-key');
        const collectionSlide = swiperElem.querySelector('.main-swiper-slide');

        if (title && key && collectionSlide) {
          // Create the outer slide element
          const slideEl = document.createElement('div');
          slideEl.classList.add('swiper-slide', 'pc__collection');
          slideEl.setAttribute('tabindex', '0');
          slideEl.setAttribute('aria-label', 'Open collection');
          slideEl.setAttribute('data-action', 'toggle-tab');
          slideEl.setAttribute('data-key', key);
          slideEl.setAttribute('data-swiper-slide-index', index);

          if (index === 0) {
            slideEl.classList.add('custom-active');
            slideEl.setAttribute('aria-expanded', 'true');
          }

          // Create a nested div for the title
          const titleDiv = document.createElement('div');
          if (this.element.hasAttribute('data-is-upsell')) {
            titleDiv.classList.add('pc__collection-title', 'u-h4');
          } else {
            titleDiv.classList.add('pc__collection-title', 'u-p2');

          }
          titleDiv.setAttribute('data-hover-text', title);
          titleDiv.textContent = title;
          // Append title inside the slide
          slideEl.appendChild(titleDiv);
          swiperSlides.push(slideEl);
        }

        //Set visibility for swiperElem
        if (index === 0) {
          swiperElem.setAttribute('aria-hidden', 'false');
          swiperElem.classList.remove('is-hidden');
        } else {
          swiperElem.setAttribute('aria-hidden', 'true');
          swiperElem.classList.add('is-hidden');
        }
      });
    }

    //Append slides to thumbs wrapper
    if (this.carouselElementThumbs) {
      const thumbsWrapper = this.carouselElementThumbs.querySelector('.swiper-wrapper');
      swiperSlides.forEach(slide => thumbsWrapper.appendChild(slide));
    }

    //Initialize swipers
    if (this.carouselElement) {
      this.carouselElement.forEach(swiperElem => {
        new RevolutionSwiper(swiperElem, this.carouselElementThumbs);
      });
    }

  }

  openTab(target) {
    const currentlyOpen = this.element.querySelector("[aria-expanded='true']");
    if (currentlyOpen) this.closeTab(currentlyOpen.dataset.key);
    this.removeAllLinks();
    target.setAttribute("aria-expanded", "true");
    target.classList.add("custom-active");

    const key = target.dataset.key;
    const toggleElement = this.element.querySelector(`.swiper.pc__carousel[data-key="${key}"]`);

    if (toggleElement) {
      toggleElement.classList.remove("is-hidden");

      requestAnimationFrame(() => {
        toggleElement.setAttribute("aria-hidden", "false");
      });
    }
  }

  // Method to remove all link highlights
  removeAllLinks() {
    const linkedItems = this.element.querySelectorAll(".custom-active");
    linkedItems.forEach((item) => {
      item.classList.remove("custom-active");
    });
  }

  closeTab(key) {
    const toggleElement = this.element.querySelector(`.swiper.pc__carousel[data-key="${key}"]`);
    if (toggleElement) {
      toggleElement.setAttribute("aria-hidden", "true");
      requestAnimationFrame(() => toggleElement.classList.add("is-hidden"));
    }
    if (window.revolutionAnimation) {
      window.revolutionAnimation.resetElement(toggleElement);
    }

    const button = this.element.querySelector(`[data-key="${key}"]`);
    if (button) {
      button.setAttribute("aria-expanded", "false");
    }
  }

  toggleTab(event) {
    const target = event.target;
    if (!target) return;

    const key = target.dataset.key;
    const toggleElement = this.element.querySelector(`.swiper.pc__carousel[data-key="${key}"]`);

    if (!toggleElement) return;
    if (target.getAttribute("aria-expanded") === "true") return;

    this.openTab(target);
  }
}

customElements.define("product-carousel-upsell", ProductCarouselUpsell);

class DropdownProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.delegateBody = new Delegate(document.body);
  }

  connectedCallback() {
    this.loadRecommendations(this.dataset.url);
  }

  async loadRecommendations(url) {
    try {
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, "text/html");

      // Get the new recommendations element from fetched HTML
      const newRecommendations = html.querySelector("dropdown-product-recommendations");

      if (!newRecommendations) {
        console.warn("No recommendations found in response");
        return;
      }

      // Update only the slides inside the swiper wrapper (this element)
      this.updateSlides(newRecommendations);

      // Initialize AddToCart (or any other components inside this)
      new AddToCart(this);

      this.dispatchEvent(new CustomEvent('recommendations:loaded', {
        bubbles: true,
        detail: { element: this }
      }));

    } catch (error) {
      console.error("Failed to load product recommendations:", error);
    }
  }

  updateSlides(newRecommendations) {
    this.innerHTML = newRecommendations.innerHTML;
  }
}

customElements.define('dropdown-product-recommendations', DropdownProductRecommendations);



var contentCache = {};
sessionStorage.setItem("elementaryLoad", "true");

let activeSlide = null;
class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.changeImageQuality();

    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.carouselElement = this.element.querySelector(".pm__main-swiper");
    this.carouselElementThumbs = this.element.querySelector(".pm__thumb-swiper");

    if (this.element.querySelector(".notify-me__overlay")) {

      this.notifyMeOverlayElement = this.element.querySelector(".notify-me__overlay");
    }

    this.swipers = this.element.querySelectorAll('.pm__information .swiper:not(.pm__connected-swiper)');

    this.productForm = this.element.querySelector('[data-product-form]');
    this.options = JSON.parse(this.carouselElement.getAttribute("data-section-settings"));
    this.stickyAtc = this.element.querySelector('.pm__atc-form--sticky');
    this.fixedAtc = this.element.querySelector('.pm__sticky-atc');
    this.annBar = document.querySelector('.announcement-bar--sticky');
    if (this.fixedAtc) {
      this.fixedInfo = this.fixedAtc.querySelector('.pm__sticy-product-info');
      this.fixedContainer = this.fixedAtc.querySelector('.pm__sticky-atc-container');
    }
    this.header = document.getElementById('header');
    this.footer = document.querySelector('footer-component');

    document.documentElement.style.setProperty(
      "--sticky-atc-height",
      `0px`
    );

    if (this.options.slides_number > 1) {
      if (this.carouselElementThumbs) {
        this.carousel = new RevolutionSwiper(
          this.carouselElement,
          this.carouselElementThumbs
        );

        const swiperInstance = this.carousel.swiperElement;
        
        swiperInstance.on("slideChange", () => {
          this.dispatchSwiperImageChanged(swiperInstance);
        });

        // Define custom bullet render logic
        swiperInstance.params.pagination.renderBullet = function (index, className) {
          const slide = swiperInstance.slides[index];
          const mediaType = slide?.getAttribute('data-media-type');
        
          if (mediaType === 'video' || mediaType === 'external_video') {
            return `<span class="swiper-video-bullet ${className}"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                      <path d="M0.647461 0.508789L7.44238 3.90234L7.45605 3.90918C7.48299 3.92897 7.49993 3.95944 7.5 3.99316C7.5 4.02304 7.4874 4.05146 7.46582 4.07129L7.44141 4.08789L0.655273 7.48633L0.651367 7.48828C0.635202 7.49656 0.617185 7.50068 0.599609 7.5L0.548828 7.48438C0.533388 7.47481 0.521094 7.4616 0.512695 7.44629L0.5 7.39648V0.604492C0.500246 0.586753 0.505237 0.569792 0.513672 0.554688L0.549805 0.516602C0.579249 0.498123 0.615467 0.49546 0.647461 0.508789Z" stroke="#43494B"/>
                    </svg></span>`;
          }
        
          return `<span class="${className}"></span>`;
        };
        
        // Rerender the pagination with the custom video bullet.
        swiperInstance.pagination.destroy();
        swiperInstance.pagination.init();
        swiperInstance.pagination.render();
        swiperInstance.pagination.update();

        const thumbSwiperContainer = this.element.querySelector('.pm__thumb-swiper');
        const swiper = thumbSwiperContainer.swiper;

      } else {
        this.carousel = new RevolutionSwiper(
          this.carouselElement
        );

        const swiperInstance = this.carousel.swiperElement;

        swiperInstance.on("slideChange", () => {
          this.dispatchSwiperImageChanged(swiperInstance);
        });
      }
    }

    this.swipers.forEach(carousel => {
      if(carousel.classList.contains("product-module__connected-items-inner-wrapper")) {
        if(responsive.currentBreakpoint == 'pocket' || responsive.currentBreakpoint == 'phone') {
          new RevolutionSwiper(carousel)
        }
      } else {
        new RevolutionSwiper(carousel)
      }
    });
    

    this.element.querySelectorAll('.pm__connected-swiper').forEach(swiperElement => {
      new RevolutionSwiper(swiperElement);
      if (activeSlide) swiperElement.swiper.slideTo(activeSlide, 0);
      swiperElement.swiper.on("slideChange", () => { 
        activeSlide = swiperElement.swiper.activeIndex; 
        this.dispatchSwiperImageChanged(swiperElement.swiper);
      });
      swiperElement.swiper.on("reachEnd", () => {
        setTimeout(() => {
          activeSlide = swiperElement.swiper.slides.length - 1;
        }, 200);
      });
      setTimeout(() => {
        swiperElement.classList.add("btn-transition");
      }, 100);
    });
    

    if (this.options.zoom) {
      new RevolutionImageZoom(this.carouselElement, this.carousel);
    }

    new AddToCart(this.element)


    // Update image based on variant if configured
    if (
      this.options["variant_image_id"] &&
      this.options["show_variant_image_on_load"]
    ) {
      this.updateImage();
    }

    this.bindEvents()
    this.onScroll();
  }

  bindEvents() {
    window.addEventListener("scroll", this.onScroll.bind(this), { passive: true });
    if (this.stickyAtc) window.addEventListener("DOMContentLoaded", this.setStickyContent.bind(this));
    if (this.productForm) {
      this.delegateElement.on('click', '[data-action="add-to-cart-og"]', (e, target) => {
        e.preventDefault();
        
        const mainButton = this.productForm.querySelector('.pm__atc-button--main');
        if (!mainButton) return;

        // Kreiramo custom event sa source sticky
        const customEvent = new CustomEvent('add-to-cart-with-source', {
            detail: { source: 'sticky_add_to_cart' },
            bubbles: true
        });

        mainButton.dispatchEvent(customEvent);
      });
    }

    //Notify me 
    this.delegateElement.on(
      "click",
      '[data-action="notify-me"]',
      this.openNotifyMe.bind(this)
    );

    this.delegateElement.on(
      "click",
      '.notify-me__close-btn[data-action="close-modal"]',
      this.closeNotifyMe.bind(this)
    );

    this.delegateBody.on(
      "click",
      '.notify-me__overlay.is-visible',
      this.closeNotifyMe.bind(this)
    );

    this.delegateElement.on('click', '[data-action="slide-to-thumb"]', this.selectSlideThumb.bind(this));

    // Important for the reload without refresh functionality
    window.addEventListener("popstate", this.reloadPage.bind(this));
    window.addEventListener("DOMContentLoaded", this.reloadWithoutRefresh.bind(this));
    this.delegateElement.on("click", '[data-action="handle-reload"]', this.updateContentWithoutReload.bind(this));
  }

  dispatchSwiperImageChanged(swiper) {
    if (!swiper) return;

    const slide = swiper.slides?.[swiper.activeIndex];
    this.element.dispatchEvent(
      new CustomEvent("swiper:image-changed", {
        bubbles: true,
        detail: {
          currentIndex: swiper.activeIndex,
          slide: slide,
          swiper: swiper
        }
      })
    );
  }


  reloadPage(e) {

    // Check if this is a back navigation (popstate triggered)
    window.location.reload();
  }

  async reloadWithoutRefresh() {
    let pdpUrls = this.element.querySelectorAll(
      ".product-module__selectbox-reload"
    );
    let urlsToFetch = Array.from(pdpUrls).map((link) => link.href);

    const fetchAndCacheContent = async (url) => {
      try {
        const response = await fetch(url);

        if (response.ok) {
          const htmlContent = await response.text();
          contentCache[url] = new DOMParser()
            .parseFromString(htmlContent, "text/html")
            .querySelector(".product__module");
        } else {
          console.error("Error fetching data. HTTP status:", response.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    
    await Promise.all(urlsToFetch.map(fetchAndCacheContent));

    const preloadImages = (container) => {
      const images = container.querySelectorAll(
        ".product-module__product-slider-image--load-first"
      );
      images.forEach((img) => {
        const preloadedImage = new Image();
        preloadedImage.src = img.getAttribute("src");
      });
    };

    Object.values(contentCache).forEach(preloadImages);
  }

  // Update the product image based on the selected variant
  updateImage(event) {
    let imageID = this.options["variant_image_id"];
    if (event) {
      imageID = event.detail.new_image;
    }
    const selector = "#Image--" + imageID;
    const imageEl = this.element.querySelector(selector);

    const slideElement = imageEl.closest(".swiper-slide");
    const realIndex = Array.from(slideElement.parentNode.children).indexOf(
      slideElement
    );

    if (imageEl) {
      this.carousel.selectCell(realIndex);
    }
  }

  updateContentWithoutReload(e, target) {
    e.preventDefault();

    const link = target || e.target.closest('a');
    const url = link?.href;

    if (!url) return;

    const htmlContent = contentCache[url];

    if (htmlContent) {
      document.title = htmlContent.querySelector('product-component')?.dataset?.title || document.title;
      document.body.querySelector('.product-module').innerHTML = htmlContent.innerHTML;

      const existingCartCount = document.body.querySelector('.header__cart-count');
      const existingFavoritesCount = document.body.querySelector('.header__favorites-count');

      if (existingCartCount) this.updateHeaderColors({ target: link }, existingCartCount);
      if (existingFavoritesCount) this.updateHeaderColors({ target: link }, existingFavoritesCount);

      window.scrollTo(0, 0);

      document.body.dispatchEvent(
          new CustomEvent('recommendations:reload', {
            bubbles: true,
            detail: htmlContent.querySelector('.product-module')?.dataset?.productId
          })
      );

      history.pushState(null, '', url);
    } else {
      window.location.assign(url);
    }
  }


  selectSlideThumb(e, target) {
    const currentlyActive = this.element.querySelector('.swiper-slide-thumb-active');
    if (currentlyActive) currentlyActive.classList.remove('swiper-slide-thumb-active');
    target.classList.add('swiper-slide-thumb-active')

    const goToIndex = parseInt(target.dataset.index);
    this.carousel.thumbSwiper.slideTo(goToIndex);
  }

  updateHeaderColors(e, element) {
    const defColor = e.target.dataset.defColor;
    const hoverColor = e.target.dataset.hoverColor;
    const textColor = e.target.dataset.textColor;
  
    if (element.classList.contains("colored")) {
      element.style.backgroundColor = defColor;
      element.style.color = textColor;
      element.style.setProperty('--hover-color', hoverColor);
      element.closest('li').classList.add('changed');
    }
  }

  
  toggleContainer(e) {
    if (!e.detail || !e.detail.identifier || e.detail.identifier !== "unit") return;
    const id = e.detail.selectedValue;

    this.allDimensions.forEach(container => {
      if (container.dataset.id === id) {
        container.setAttribute('aria-hidden', false);
      } else {
        container.setAttribute('aria-hidden', true);
      }
    })
  }

  setStickyContent() {
    if (!this.stickyAtc) return;
    this.setStickyHeight();

    const selectorLabels = document.querySelectorAll('variant-selects .pm__selector-label');
    if (selectorLabels.length > 1) {
      const stickyDetails = this.fixedInfo.querySelector('.pm__sticky-details');
      stickyDetails.querySelectorAll('.pm__selector-label').forEach(label => label.remove());
      selectorLabels.forEach(label => {
        const clonedLabel = label.cloneNode(true);
        stickyDetails.appendChild(clonedLabel);
      });
    }
  }

  openNotifyMe(e) {
    e.preventDefault();
    const notifyMePopUp = this.element.querySelector('.notify-me__popup-wrapper[aria-hidden="true"]');
    if (notifyMePopUp) {
      //add choosen variants
      let form = this.element.querySelector('.pm__atc-form--notify-me');
      let inputID = form.querySelector('input[name="id"]');
      let variantINFO = inputID.getAttribute('value');
      notifyMePopUp.setAttribute('variant-value', `${variantINFO}`);

      notifyMePopUp.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => {
        notifyMePopUp.setAttribute('aria-visible', 'true');
      });

      this.notifyMeOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);


    }
  }

  closeNotifyMe() {
    const notifyMePopUp = this.element.querySelector('.notify-me__popup-wrapper[aria-hidden="false"]');
    if (notifyMePopUp) {
      
      notifyMePopUp.setAttribute('aria-visible', 'false');
      notifyMePopUp.style.opacity = '';

    const handleTransitionEnd = (event) => {
  if (
    (responsive.matchesBreakpoint('lap_and_up') && event.propertyName === 'opacity') ||
    (!responsive.matchesBreakpoint('lap_and_up') && event.propertyName === 'transform')
  ) {
    notifyMePopUp.setAttribute('aria-hidden', 'true');

        notifyMePopUp.querySelector('.notify-me__heading--success').style.display = "none";
      notifyMePopUp.querySelector('.notify-me__success-msg').style.display = 'none';

      notifyMePopUp.querySelector('.notify-me__heading').style.display = "flex";
      notifyMePopUp.querySelector('.notify-me__popup-content').style.display = 'flex';

      notifyMePopUp.querySelector('.notify-me__input').value = "";
  }
};

      notifyMePopUp.addEventListener('transitionend', handleTransitionEnd, { once: true });

      this.notifyMeOverlayElement.classList.remove("is-visible");
      bodyScrollLock.clearAllBodyScrollLocks();


  
    }
  }

  setStickyHeight() {
    if (!this.fixedAtc) return;

    this.fixedAtc.style.visibility = 'hidden';
    this.fixedAtc.style.pointerEvents = 'none';

    const show = this.fixedAtc.classList.contains('show');
    if (!show) this.fixedAtc.classList.add('show');
    const attrValue = this.fixedAtc.getAttribute('aria-hidden');
    this.fixedAtc.setAttribute('aria-hidden', false);

    document.documentElement.style.setProperty(
      "--sticky-atc-height",
      `${this.fixedAtc.offsetHeight}px`
    );

    if (!show) this.fixedAtc.classList.remove('show');
    this.fixedAtc.setAttribute('aria-hidden', attrValue);

    this.fixedAtc.style.visibility = '';
    this.fixedAtc.style.pointerEvents = '';
  }

  onScroll() {
    if (!this.stickyAtc) return;
  
    const annBarHeight = this.annBar ? this.annBar.offsetHeight : 0;
    const offsetTop = this.header.offsetHeight + annBarHeight;
  
    const showFixed = this.stickyAtc.getBoundingClientRect().top <= offsetTop;
  
    const footerHeight = this.footer.offsetHeight;
    const hideFixed = window.innerHeight + window.scrollY >= document.body.offsetHeight - footerHeight;
  
    // Determine final visibility
    const shouldShow = showFixed && !hideFixed;
  
    // Handle visibility change
    if (shouldShow && !this.fixedAtc.classList.contains('show')) {
      this.fixedAtc.classList.add('show');
      this.fixedAtc.setAttribute('aria-hidden', 'false');
  
      if (responsive.matchesBreakpoint('lap_and_up')) {
        requestAnimationFrame(() => {
          this.fixedInfo.setAttribute('aria-hidden', 'false');
          this.fixedContainer.style.visibility = 'visible';
        });
      }
    } else if (!shouldShow && this.fixedAtc.classList.contains('show')) {
      if (responsive.matchesBreakpoint('lap_and_up')) {
        this.fixedContainer.style.visibility = 'hidden';
        this.fixedInfo.setAttribute('aria-hidden', 'true');
  
        this.fixedInfo.addEventListener('transitionend', () => {
          if (!shouldShow) {
            this.fixedAtc.classList.remove('show');
            this.fixedAtc.setAttribute('aria-hidden', 'true');
          }
        }, { once: true });
      } else {
        this.fixedAtc.classList.remove('show');
        this.fixedAtc.setAttribute('aria-hidden', 'true');
      }
    }
  }
  

  // Change image quality to high resolution
  changeImageQuality() {
    const imageToReveal = this.element.querySelector(".ProductSlider--ImageFirst");
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }
}
customElements.define("product-component", ProductElement);

class PDPDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

  }

  connectedCallback() {
    this.dropdownCarousel = this.element.querySelector(".dropdown-tabs__wrapper.swiper");


    // Initializes and setup info tab dropdown
    if(this.dropdownCarousel) this.dropdownCarouselInstance = new RevolutionSwiper(this.dropdownCarousel);
    this.setupUIComponents();
    this.bindEvents();
  }

  setupUIComponents() {
    this.setUpTabsContent();
    this.initDropdown();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='toggle-tab']",
      debounce(this.switchTab.bind(this), 200)
    );

    this.delegateElement.on(
      "click",
      "[data-action='handle-view-more']",
      this.handleViewMore.bind(this)
    );
  }

  // Initialize tabs for a given dropdown element
  setUpTabsContent() {
    const firstTab = this.element.querySelector(".product-info__dropdown-button");
    if (!firstTab) return;
  
    const firstTabId = firstTab.getAttribute("data-tab-id");
    if (!firstTabId) return;
  
    // Deactivate currently active tab and content
    const activeTab = this.element.querySelector(".product-info__dropdown-button.active");
    if (activeTab) activeTab.classList.remove("active");
  
    const activeContent = this.element.querySelector(".product-tab-content.active");
    if (activeContent) {
      activeContent.style.display = "none";
      activeContent.style.opacity = "0";
      activeContent.classList.remove("active");
    }
  
    // Activate first tab
    firstTab.classList.add("active");
  
    // Activate corresponding content
    const firstContent = this.element.querySelector(`.product-tab-content[data-id="${firstTabId}"]`);
    if (firstContent) {
      firstContent.style.display = "flex";
      requestAnimationFrame(() => {
        firstContent.classList.add("active");
        firstContent.style.opacity = "1";
      });
    }
  }
  
  
    // Handle tab switching for clicks within dropdowns
  switchTab(event) {
    const tabButton = event.target;
    const tabId = tabButton.getAttribute("data-tab-id");
    if (!tabId) return;
  
    // Get the closest dropdown wrapper (scope the logic)
    const dropdownElement = tabButton.closest(".dropdown-pdp");
    if (!dropdownElement) return;
  
    const dropdownTabWrapper = dropdownElement.querySelector(".dropdown-tabs__wrapper");
    const dropDownContentWrapper = dropdownElement.querySelector(".dropdown-contents__wrapper");
    if (!dropdownTabWrapper || !dropDownContentWrapper) return;
  
    const activeContent = dropDownContentWrapper.querySelector(".product-tab-content.active");
    const newContent = dropDownContentWrapper.querySelector(`[data-id="${tabId}"]`);
  
    if (!newContent || activeContent === newContent) return;
  
    // Remove active class from all tabs inside this dropdown
    dropdownTabWrapper.querySelectorAll("button.active").forEach(button =>
      button.classList.remove("active")
    );
  
    // Activate clicked tab
    tabButton.classList.add("active");
    const slides = Array.from(this.dropdownCarousel.querySelectorAll(".product-info__dropdown-button.swiper-slide"));
    const activeIndex = slides.indexOf(tabButton);
    this.dropdownCarouselInstance.swiperElement.slideTo(activeIndex)
  
      // Fade out old content and fade in new content
    if (activeContent) {
      activeContent.style.opacity = "0";
  
      activeContent.addEventListener("transitionend", function handleTransition(event) {
        if (event.propertyName === "opacity") {
          activeContent.style.display = "none";
          activeContent.classList.remove("active");
          activeContent.removeEventListener("transitionend", handleTransition);
  
          newContent.style.display = "flex";
          newContent.style.opacity = "0";
  
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              newContent.classList.add("active");
              newContent.style.opacity = "1";
            });
          });
        }
      });
    } else {
      newContent.style.display = "flex";
      newContent.style.opacity = "0";

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          newContent.classList.add("active");
          newContent.style.opacity = "1";
        });
      });
    }
  }
  
  initDropdown() {
    const dropdownContentNodeList = this.element.querySelectorAll(".product-tab-content");
  
    dropdownContentNodeList.forEach((dropdownInner) => {
      const dropdownContent = dropdownInner.querySelector(".product-tab-content__items");
      const viewMoreButton = dropdownInner.querySelector(".product-tab__view-more");
  
      let wasHidden = false;
  
      if (dropdownContent && viewMoreButton) {
        // If hidden, make it temporarily measurable
        if (getComputedStyle(dropdownInner).display === "none") {
          wasHidden = true;
          dropdownInner.style.display = "flex";
        }
  
        // Measure content height
        const contentHeight = dropdownContent.scrollHeight;
  
        // Remove after measuring
        if (wasHidden) {
          dropdownInner.style.display = "none";
          dropdownInner.style.opacity = "0";
        }
  
        // Apply view more logic
        if (contentHeight <= 100) {
          viewMoreButton.style.display = "none";
          dropdownContent.style.height = "";
          dropdownContent.style.overflow = "";
        } else {
          viewMoreButton.style.display = "block";
          dropdownContent.style.height = "84px";
          dropdownContent.style.overflow = "hidden";
        }
      }
    });
  }
  
  handleViewMore(e) {
    const viewMoreButton = e.target;

    const toggleId = viewMoreButton.getAttribute("data-toggle-id");
    const dropdown = viewMoreButton.closest(".dropdown-pdp");

    if (!dropdown) {
      console.error("Toggle failed: Missing dropdown.");
      return;
    }

    const dropdownContent = dropdown.querySelector(`.product-tab-content__items[data-id="${toggleId}"]`);
    if (!dropdownContent || !viewMoreButton) {
      console.error("Toggle failed: Missing dropdown content or view more button element.");
      return;
    }
    
    const isExpanded = dropdownContent.style.height === "100%";
    const moreText = viewMoreButton.querySelector(".view-more-text");
    const lessText = viewMoreButton.querySelector(".view-less-text");
    
    if (isExpanded) {
      dropdownContent.style.height = "84px";
      dropdownContent.style.overflow = "hidden";
      if (moreText) moreText.style.display = "block";
      if (lessText) lessText.style.display = "none";
    } else {
      dropdownContent.style.height = "100%";
      dropdownContent.style.overflow = "visible";
      if (moreText) moreText.style.display = "none";
      if (lessText) lessText.style.display = "block";
    }
    
  }
}
customElements.define("product-page-dropdown", PDPDropdown);

class ProductAtcUSPS extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
  }

  connectedCallback() {
    this.uspsBarWrapper = this.element.querySelector(".atc-usps-bar__wrapper");
    this.uspsBarItems = this.element.querySelectorAll('.atc-usps-bar__block');
    if (this.uspsBarItems.length > 1 && this.options["enableAnimation"]) {
      this.initialize();
    } else {
      this.uspsBarItems[0]?.classList.add('base');
    }

    if(this.uspsBarWrapper && this.uspsBarItems[0]) {
      this.uspsBarWrapper.style.height = `${this.uspsBarItems[0].offsetHeight}px`;
    }
  }

  initialize() {
    this.currentIndex = 0;
    this.uspsBarItems[this.currentIndex].classList.add('active');
    setInterval(this.showNextElement.bind(this), this.options["cycleSpeed"]);
  }

  showNextElement() {
    this.uspsBarItems[this.currentIndex].classList.remove('active');
    this.currentIndex = (this.currentIndex + 1) % this.uspsBarItems.length;
    setTimeout(() => {
      this.uspsBarItems[this.currentIndex].classList.add('active');
    }, this.options["transitionSpeed"])
  }
}
customElements.define("atc-usps-bar", ProductAtcUSPS);

class UspSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.swiper = this.element.querySelector(".swiper");

    if(
        this.swiper &&
        this.swiper.hasAttribute("data-swiper-settings") &&
        !responsive.matchesBreakpoint("lap_and_up"))
    {
      new RevolutionSwiper(this.swiper)
    }
  }
}


customElements.define("usp-section", UspSection);

class NotifyMePopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "submit",
      '.notify-me__popup-inputs',
      this.submitNotifyMe.bind(this));

  }

  submitNotifyMe(e) {
    e.preventDefault();
    const emailInput = this.element.querySelector('.notify-me__input');
    const emailTxt = emailInput.value.trim();
    const alertErr = this.element.querySelector('.notify-me__popup-content .AlertError');

    //validation for email
    if (emailTxt === "" || !emailTxt.includes("@")) {
      // Invalid email format
      alertErr.style.display = "block";
      setTimeout(() => {
        alertErr.style.display = "none";
      }, 3000);

      return;
    } else {
      alertErr.style.display = "none";
    }

    //Send request to API
    this.handleKlaviyoAPI(emailTxt);
  }

  async handleKlaviyoAPI(myEmail) {
    let elementWithId = this.element.querySelector('.notify-me__popup-wrapper');

    if (elementWithId) {

      let variantID = elementWithId.getAttribute('variant-value');

      //Klaviyo API data
      const data = {
        type: "back-in-stock-subscription",
        attributes: {
          channels: ["EMAIL"],
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: myEmail
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variantID}`
            }
          }
        }
      };


      const endpoint = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.element.dataset.key}`;

      const shopifyResponse = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json',
          "revision": "2024-06-15"
        },
        body: JSON.stringify({ data }),
      });

      if (!shopifyResponse.ok) {
        throw new Error(`Failed to capture email on Shopify: ${shopifyResponse.statusText}`);
      }
      // Handle success on Shopify (e.g., show a success message to the user)

      elementWithId.setAttribute('notify-me-success', 'true');
      elementWithId.style.opacity = 0;
      elementWithId.querySelector('.notify-me__popup-content').style.display = "none";
      elementWithId.querySelector('.notify-me__heading').style.display = "none";

      setTimeout(() => {
        elementWithId.style.opacity = 1;
        elementWithId.querySelector('.notify-me__success-msg').style.display = "flex";
        elementWithId.querySelector('.notify-me__heading--success').style.display = "flex";
      }, 500);


    } else {
      return;
    }

  }

}
customElements.define("notify-me-popup", NotifyMePopup);

class sizeGuide extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    new Drawer(this.element.querySelector('.Drawer--wrapper'));
  }

  connectedCallback() {
    this.bindEvents();
    this.initializeFirstBlock();
  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="toggle-unit"]', this.toggleUnit.bind(this));
    this.delegateElement.on('change', 'select, input:checked', this.onOptionChange.bind(this));
  }

  onOptionChange(e) {
    this.updateOptions();
  }

  updateLabel(value) {
    const label = this.element.querySelector(".size-guide__label-value");
    if (label) label.textContent = value;
  }
  
  toggleVisibility(oldEl, newEl) {
    if (oldEl) {
      oldEl.setAttribute('aria-visible', 'false');
      setTimeout(() => {
        oldEl.setAttribute('aria-hidden', 'true');
        this.showElement(newEl);
      }, 300);
    } else {
      this.showElement(newEl);
    }
  }
  
  showElement(el) {
    if (el) {
      el.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => el.setAttribute('aria-visible', 'true'));
    }
  }

  initializeFirstBlock() {
    const input = this.element.querySelector("input:checked");
    if (!input) return;
  
    const value = input.value;
    const block = this.element.querySelector(`.size-block[data-variant-option="${value}"]`);
    const image = this.element.querySelector(`.size-guide__image-wrapper[data-variant-option="${value}"]`);
  
    this.updateLabel(value);
    this.showElement(block);
    this.showElement(image);
  }
  
  updateOptions() {
    const optionEl = this.element.querySelector("select, input:checked");
    if (!optionEl) return;
  
    const value = optionEl.value;
    this.updateLabel(value);
  
    const oldBlock = this.element.querySelector(".size-block[aria-visible='true']");
    const newBlock = this.element.querySelector(`.size-block[data-variant-option="${value}"]`);
  
    const oldImage = this.element.querySelector(".size-guide__image-wrapper[aria-visible='true']");
    const newImage = this.element.querySelector(`.size-guide__image-wrapper[data-variant-option="${value}"]`);

    if (!newBlock && !newImage) return;
    if (oldBlock === newBlock && oldImage === newImage) return;
  
    this.toggleVisibility(oldBlock, newBlock);
    this.toggleVisibility(oldImage, newImage);
  }
  

  toggleUnit(e) {
    const unit = e.target.dataset.unit;
    e.target.classList.add('active');
  
    const other = e.target.nextElementSibling || e.target.previousElementSibling;
    other.classList.remove('active');
  
    const activeSizeBlock = this.element.querySelector('.size-block[aria-visible="true"]');
    
    // Get all measurement elements (both min and max)
    const measurementElements = activeSizeBlock.querySelectorAll('.size-guide__measurement-min, .size-guide__measurement-max');
  
    measurementElements.forEach(element => {
      const originalValue = parseFloat(element.dataset.value);
      
      if (isNaN(originalValue)) {
        console.warn('Invalid measurement value:', element.dataset.value);
        return;
      }
  
      if (unit === 'cm') {
        element.textContent = originalValue + " cm";
      } else {
        const inchValue = (originalValue * 0.393701).toFixed(1);
        element.textContent = inchValue + " in";
      }
    });
  }


}

customElements.define("size-guide", sizeGuide);

class headingTextLinks extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.linkList = this.element.querySelector('.key-topics__list');


  }

  connectedCallback() {
    if (!this.linkList) return;

    const links = this.linkList.querySelectorAll('a[href^="#"]');
    links.forEach(link => {
      const targetId = link.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      if (!targetElement) {
        link.style.pointerEvents = 'none';
      }
    });
  }

}

customElements.define("heading-text-anchor-links", headingTextLinks);

class SizeGuideTable extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.tableContent = this.element.querySelector(
      ".size-guide__table-content"
    );

    this.tableFonts();

    this.bindEvents();
  }

  tableFonts() {
    const table = this.element.querySelector(".size-guide__table-content");
    const rows = table.querySelectorAll("tr");

    rows.forEach((row) => {
      row.classList.add("table-row");

      const cells = row.querySelectorAll("td");

      cells.forEach((cell, index) => {
        cell.classList.add("table__item");
        if (index === 0) {
          cell.classList.add("u-s3");
          cell.classList.add("rte");
        } else {
          cell.classList.add("rte");
        }
      });
    });
  }

  bindEvents() {
    let isDragging = false;
    let startX, startScrollLeft;
    const slider = this.element.querySelector(".size-guide__table-content");

    const startDragging = (e) => {
      isDragging = true;
      startX = e.type === "touchstart" ? e.touches[0].pageX : e.pageX;
      startScrollLeft = slider.scrollLeft;
    };

    const stopDragging = () => {
      isDragging = false;
    };

    const move = (e) => {
      e.preventDefault();
      if (!isDragging) {
        return;
      }
      const currentX = e.type === "touchmove" ? e.touches[0].pageX : e.pageX;
      const scroll = currentX - startX;
      slider.scrollLeft = startScrollLeft - scroll;

      this.syncScroll();
    };

    slider.addEventListener("mousedown", startDragging, false);
    slider.addEventListener("touchstart", startDragging, false);

    slider.addEventListener("mouseup", stopDragging, false);
    slider.addEventListener("touchend", stopDragging, false);

    slider.addEventListener("mousemove", move, false);
    slider.addEventListener("touchmove", move, false);

    this.tableContent.addEventListener(
      "scroll",
      () => this.syncScroll(),
      false
    );
  }
}
customElements.define("size-guide-table", SizeGuideTable);

var selectedVariant = null;
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });

    this.element.querySelectorAll(".VariantSelect").forEach((container) => {
      this.updateOptionName(container);
    });
  }


  onQuantityChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
  }


  onVariantChange(event) {
    const input = event.target;
    const container = input.closest(".VariantSelect");

    this.updateOptions();
    this.updateOptionName(container);
    this.updateMasterId();
    this.toggleAddButton();
    this.sendVariantGTMEvent();
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, input:checked"),
      (select) => select.value
    );
  }

  updateOptionName(container) {
    if (!container) return;
  
    const selectedInput = container.querySelector(".inputSelectboxCheckbox:checked");
    const selectedOptionSpan = container.querySelector(".variant-select__selected-option");

    const lowInStockContainer = container.querySelector(".variant-select__label__low-in-stock");
    const isLowInStock = selectedInput.getAttribute("data-low-in-stock");

    const outOfStockContainer = container.querySelector(".variant-select__label__out-of-stock");
    const isOutOfStock = selectedInput.getAttribute("data-out-of-stock");
  
    if (selectedInput && selectedOptionSpan) {
      selectedOptionSpan.textContent = selectedInput.value;
    }

    if(isLowInStock) {
      lowInStockContainer.style.display = "flex";
    } else {
      lowInStockContainer.style.display = "none";
    }

    if(isOutOfStock) {
      outOfStockContainer.style.display = "flex";
    } else {
      outOfStockContainer.style.display = "none";
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    selectedVariant = this.currentVariant;
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  async renderProductInfo(...selectors) {
    // 1) default to the old two if none passed
    if (selectors.length === 0) {
      selectors = [
        '.pm__price-container',
        '.pm__price-container .priceCompare',
        '.pm__quantity ',
        '.pm__sticky-variants',
        '.pm__sticky-price',
        '.pm__sticky-info',
        '.pm__product-atc-wrapper',
        '.pm__sticky-atc-wrapper',
        '.pm__main-swiper .product-card__label--percentage'
      ];
    }

    // 2) build the URL
    const url = new URL(this.dataset.url, window.location.origin);
    url.searchParams.set('variant', this.currentVariant.id);
    url.searchParams.set('section_id', this.dataset.section);

    try {
      // 3) fetch & parse
      const res = await fetch(url);
      if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      // 4) update each selector in turn
      selectors.forEach((sel) => {
        const src = html.querySelector(sel);
        const dests = document.querySelectorAll(sel);

        dests.forEach(dest => {
          if (src) {
            if (sel === '.pm__sticky-info') {    //copy el because wrapper element is needed
              const newEl = src.cloneNode(true);
              dest.replaceWith(newEl);
            } else {
              dest.innerHTML = src.innerHTML;  // reset any previous hiding
              dest.style.opacity = '';
            }
          } else {
            dest.style.opacity = '0';        // hide if missing in fetched HTML
          }
        });
      });

      // 5) finally trigger any follow‑up logic
      this.toggleAddButton();
    }
    catch (err) {
      console.error('Error updating product info:', err);
    }
  }



  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".pm__atc-button--main"),
      quantityEl = document.querySelector('.pm__quantity-input');
    if (quantityEl) {
      quantity = quantityEl.value;
    }

    if (!addButton) return;
    if (!quantity) { quantity = 1; }

    if (this.currentVariant.available == false) {
      if (!document.querySelector('notify-me-popup')) {
        addButton.setAttribute("disabled", "disabled");
        addButton.classList.add("ProductCard--Sold__Out");
      }
    } else {
      addButton.removeAttribute("disabled");
      addButton.classList.remove("ProductCard--Sold__Out");
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

    sendVariantGTMEvent() {
    document.dispatchEvent(
      new CustomEvent("variant:changed:gtm", {
        bubbles: true,
        detail: {
          title: selectedVariant.title,
          sku: selectedVariant.sku,
          price: selectedVariant.price,
        }
      })
    );
  }

}
customElements.define("variant-selects", VariantSelects);
class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');

    this.searchResultsElement = this.element.querySelector(".search-wrapper");
    this.searchHeader = this.element.querySelector(".search-header");
    this.pageOverlayElement = this.element.querySelector(".sectionOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.clearSearchButton = this.element.querySelector('.search-input__clear');
    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    this.headerTransparent = false;
    
    this.carouselElement = this.element.querySelector(".search__initial-view");
    if (this.carouselElement) this.carousel = new RevolutionSwiper(this.carouselElement);

    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchHeader.offsetHeight}px`
    );

    this.searchDrawer = new Drawer(this.element, {
      onClose: () => {
        this.open = false;
      },
      onOpen: () => {
        this.open = true;
      },
    });


    this.bindEvents();
  }

  connectedCallback(){
    new AddToCart(this.element);
  }


  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);
    this._boundSwitchDrawerSide = this.debounce(this.switchDrawerSide.bind(this), 150);

    window.addEventListener("scroll", this._boundSwitchDrawerSide);
    window.addEventListener("resize", this._boundSwitchDrawerSide);
  
    scrollListener.addScrollListener(this, this._boundSwitchDrawerSide);
    responsive.addResizeListener(this, this._boundSwitchDrawerSide);
  
    // Initial drawer position (left or right)
    this.switchDrawerSide();

    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );

    this.searchInputElement.addEventListener(
      "input", 
      this._onInputListener
    );

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );
  }

  switchDrawerSide() {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth <= 1024;
  
    if (isMobile && this.element.classList.contains("Drawer--Right")) {
      this.element.classList.remove("Drawer--Right");
      this.element.classList.add("Drawer--Left");
    } else if (!isMobile && this.element.classList.contains("Drawer--Left")) {
      this.element.classList.remove("Drawer--Left");
      this.element.classList.add("Drawer--Right");
    }
  }  

  initCarousel() {
      const carousel = this.searchResultsElement.querySelector("[data-swiper-settings]");
      if (carousel) this.newCarousel = new RevolutionSwiper(carousel);
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  async onInput(event) {
    this.allPredictiveSearchInstances = [];
    this.lastInputValue = event.target.value;
    this.searchResultsElement = this.element.querySelector(".search-wrapper");
    this.searchResultsElement.style.opacity = 0;
    this.clearSearchButton.setAttribute('aria-hidden', 'false');
    if (event.target.getAttribute("data-value") && this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = this.element.querySelector(".searchInput");

      el.setAttribute("value", this.lastInputValue);
      el.value = this.lastInputValue;
    } else {
      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    try {
      const response = await fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(this.lastInputValue)}&resources[limit_scope]=each&section_id=search-predictive`);

      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      const text = await response.text();
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-predictive').innerHTML;

      // Save bandwidth keeping the cache in all instances synced
      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
      });
      const div = document.createElement('div');
      div.innerHTML = resultsMarkup;

      const suggestedQueries = div.querySelector('template');
      const currentSuggestedQueries = this.element.querySelector('.predictive-search__queries');
      const currentRecentQueris = this.element.querySelector('#predictive-search__recent-searches');


      this.searchResultsElement.innerHTML = resultsMarkup;
      this.initCarousel();

      if (suggestedQueries) {
        if (currentRecentQueris) {
          currentRecentQueris.remove();
        }

        if (currentSuggestedQueries) {
          currentSuggestedQueries.remove();
        }
        const node = suggestedQueries
          .content.firstElementChild.cloneNode(true);
        this.searchResultsElement.prepend(node);
      }

      this.searchResultsElement.style.opacity = 1;

      if (window.theme.showRecentSearches) {
        this.recentSearches();
      }
    } catch (error) {
      if (error?.code === 20) {
        // Code 20 means the call was aborted
        return;
      }

      throw error;
    }

  }

  resetSearch() {
    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
    const currentSuggestedQueries = this.element.querySelector('.predictive-search__queries');
    if (currentSuggestedQueries) currentSuggestedQueries.remove();
    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");
    this.searchInputElement.focus();

    if (window.theme.showRecentSearches) { this.getRecentSearches(); }
    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;
    this.clearSearchButton.setAttribute('aria-hidden', 'true');

    
  }

  recentSearches() {
    if (this.lastInputValue.length > 2) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }
      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) { }
    }
  }

  getRecentSearches() {
    let appendString = "";
    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    let elementToAdd = this.element.querySelector("#recent-search-list");
    if (items.length > 0) {
      items.forEach((id) => {
        appendString =
          appendString +
          "<li role='option' tabIndex='0' class='hoverLinks' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      if(elementToAdd) elementToAdd.innerHTML = appendString;
    } else {
      const recentSearches = this.querySelector('#predictive-search__recent-searches');
      if(recentSearches) recentSearches.style.display = "none";
    }
  }

}
customElements.define("search-bar", SearchBar);

class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.searchTypes = [
      { id: "collection__main-grid", type: "product" },
      { id: "collection__main-grid-articles", type: "article" },
    ];
  }

     

  connectedCallback() {
    this.filterBar = this.element.querySelector(".collection__header");
    this.loadType = this.element.dataset.load;
    new AddToCart(this.element);
    this.delegateElement = new Delegate(this.element);

    //remove filter button if filters are disabled, on mobile
       this.filterMobileButton = document.querySelector('.collection__filter-bar-button.not_desktop');
        this.filtersEnabledEl = document.querySelector('.collection__nav-filter-bar');
        this.scrollBound = false;
        if(this.filtersEnabledEl) {
            this.filtersEnabled = this.filtersEnabledEl.getAttribute('data-filter-enabled');
        
            if(this.filtersEnabled === 'true') {
               this.checkGridHeigth()           
            } else {
                this.filterMobileButton.style.display = 'none';
            }    
       }

    this.bindEvents();
    this.initialize();
  }

  initialize() {
    if (this.loadType === "scroll") {
      this.bindObservers();
    } else {
      this.delegateElement.on("click", '[data-action="load-initial"]', this.handleClick.bind(this));
    }
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="toggle-collection"]', this.toggleGrid.bind(this));
    window.addEventListener("popstate", this.toggleGridBasedOnUrl.bind(this));

    if (this.scrollBound) return;

    this.onScrollListener = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollListener);
    this.scrollBound = true;
  }

  bindObservers() {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.25,
    };

    this.searchTypes.forEach((searchType) => {
      const container = document.getElementById(searchType.id);
      if (!container) return;
      const paginationElement = container.querySelector(".infinite-scroll");
      if (!paginationElement) return;

      // Select the second-to-last child
      const children = container.children;
      const target = children[children.length - 2];

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paginationElement.remove();
            observer.unobserve(target);

            this.fetchSearchType(searchType.id, searchType.type);
          }
        });
      }, observerOptions);

      observer.observe(target);
    });
  }

       checkGridHeigth() {
      const resultsGrid = this.element.querySelector('#collection__main-grid');
       if (!resultsGrid) return;
  
      const gridHeight = resultsGrid.offsetHeight;
      const viewportHeight = window.innerHeight;
    
      if (gridHeight < viewportHeight) {
        this.filterMobileButton.classList.add('visible');
      }
    }

      onScroll() {
         if(this.filtersEnabled === 'true') { 
           this.handleFilterMobileButton();
         }

        if(this.filtersEnabled === 'true' || this.sortEnabled === 'true') { 
           this.handleFilterBarShrink();
         }
      }

      handleFilterBarShrink() {
        const filtersIconsEl = document.querySelector('.filters-bar__products-info');
        if (!filtersIconsEl) return;
      
        if (!responsive.matchesBreakpoint("lap_and_up")) return;
      
        const rect = this.element.getBoundingClientRect();
        const headerHeight = getComputedStyle(document.documentElement)
          .getPropertyValue("--header-height-fixed")
          .trim();
        const headerHeightValue = parseInt(headerHeight, 10);
      
        if (rect.top <= headerHeightValue) {
          filtersIconsEl.classList.add('shrink');
        } else {
          filtersIconsEl.classList.remove('shrink');
        }
      }

      handleFilterMobileButton() {
       if (!this.filterMobileButton) return;
     
       const rect = this.element.getBoundingClientRect();
       const containerRect = document.querySelector('#collection__grid-wrapper')?.getBoundingClientRect();
       if (!containerRect) return;
     
       const headerHeight = getComputedStyle(document.documentElement)
         .getPropertyValue("--header-height-fixed")
         .trim();
       const headerHeightValue = parseInt(headerHeight, 10);
     
       const filterButtonRect = this.filterMobileButton.getBoundingClientRect();
       const hasReachedBottom = filterButtonRect.bottom >= containerRect.bottom;
     
       if (rect.top <= headerHeightValue + 30 && !hasReachedBottom) {
         this.filterMobileButton.classList.add('visible');
       } else {
         this.filterMobileButton.classList.remove('visible');
       }
     }

      removeScrollListener() {
       if (this.onScrollListener) {
         window.removeEventListener('scroll', this.onScrollListener);
         this.scrollBound = false;
       }
     }


  async handleClick(e) {
    e.preventDefault();
    e.target.querySelector(".itemLoader").classList.add("is-visible");
    const paginationElement = e.target.parentElement;
    const matchingObject = this.searchTypes.find(
      (item) => item.type === paginationElement.dataset.type
    );
    await this.fetchSearchType(matchingObject.id, matchingObject.type);

    paginationElement.remove();
  }

  async fetchSearchType(gridContainerId, type) {
    const section = document.getElementById(gridContainerId);
    if (!section) return;

    let path = window.location.pathname;
    for (const type of this.searchTypes) {
      const pattern = `/view/${type.type}s`;
      if (path.includes(pattern)) {
        path = path.replace(pattern, "");
        break;
      }
    }

    const sectionId = section.dataset.id;
    const searchTerms = this.element.dataset.searchTerms;
    const url = `${path}?section_id=${sectionId}&${searchTerms}&type=${type}&page=2`;
    await this.renderSectionFromFetch(url, gridContainerId, section);
  }

   async renderSectionFromFetch(url, gridContainerId) {
    try {
      const response = await fetch(url);
      const html = await response.text();

      this.renderGrid(html, gridContainerId);
    } catch (error) {
      console.error("Error fetching section on main search:", error);
    }
  }

    renderGrid(html, gridContainerId) {
    const newGridContent = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById(gridContainerId);
    if (!newGridContent) return;

    const gridContainer = document.getElementById(gridContainerId);
    gridContainer.insertAdjacentHTML("beforeend", newGridContent.innerHTML);

    const newPaginationElement =
    newGridContent.querySelector(".infinite-scroll");
    new RevolutionAnimation(gridContainer);
    document.dispatchEvent(new CustomEvent('update-favorites'));
    if (!newPaginationElement) return;
    new InfiniteScroll(`#${gridContainerId}`, `#${newPaginationElement.id}`);


  }

  toggleGrid(e) {
    const target = e.target.closest('[data-action="toggle-collection"]');
    const id = target.getAttribute("aria-controls");

    const gridsToHide = this.element.querySelectorAll(
      '.collection__grid[aria-hidden="false"]'
    );
    const gridToShow = this.element.querySelector(`#${id}`);

    gridsToHide.forEach((grid) => grid.setAttribute("aria-hidden", "true"));
    gridToShow.setAttribute("aria-hidden", "false");

      //remove filter button if filters are disabled, on mobile
      this.filterMobileButton = document.querySelector('.collection__filter-bar-button.not_desktop');
      if(id === 'collection-article') {
        this.filterMobileButton.style.display = 'none';
      } else {
        this.filterMobileButton.style.display = 'block';
      }
  }

  toggleGridBasedOnUrl() {
      this.element.querySelector('[aria-controls="collection-product"]')?.click();
  }


}
customElements.define("search-component", MainSearch);

class TermsAndConditions extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.stickyLinksTopPadding = this.stickyLinksTopPadding.bind(this);
    this.bindEvents();
  }

  bindEvents() {
    const isMobile = responsive.matchesBreakpoint("pocket");
    if(!isMobile) document.addEventListener("scroll", this.stickyLinksTopPadding);
  }

  stickyLinksTopPadding() {
    const linkList = this.element.querySelector(".tc-layout-wrapper__linklist");
    if (linkList) {
      const isSticky = linkList.getBoundingClientRect().top === 0;

      if (isSticky) {
        linkList.style.paddingTop = "1.5rem";
      } else {
        linkList.style.paddingTop = "0rem";
      }
    }
  }
}

customElements.define("terms-and-conditions", TermsAndConditions);

class LocalizationModal extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.selectContainer = this.element.querySelector('.RevolutionSelectbox--Content');
    this.pendingRedirectUrl = null; // Store pending redirect URL
    // Static fallback mapping (use only if embedded + localization.json fail)
    this.marketLanguageFallback = {
      // Populate with real per-market language codes (lowercase) as needed
      // Example assumptions (adjust to your actual configuration):
      'FR': ['en','sv','fr'], // If Shopify doesn't expose FR languages pre-submit
      'DE': ['en','de'],
      'HR': ['en'],
      'US': ['en'],
      'GB': ['en'],
      // Add others...
    };
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.element.querySelectorAll('.RevolutionSelectbox').forEach(box => new RevolutionSelectbox(box));
    this.bindEvents();
    // Cache original language icon templates (solid / outline) for rebuilds
    const langContainer = this.element.querySelector('.language-options');
    if (langContainer) {
      const solid = langContainer.querySelector('.Svg--checkbox-square-solid');
      const outline = langContainer.querySelector('.Svg--checkbox-square');
      this._langIconSolidTemplate = solid ? solid.innerHTML : '';
      this._langIconOutlineTemplate = outline ? outline.innerHTML : '';
    }
  // Preload localization data for faster subsequent market clicks
  this.ensureLocalizationData();
    
    // Reset pending redirects when modal opens
    this.resetPendingRedirect();
  if (this.ensureLanguageSelection) this.ensureLanguageSelection();
  }

  bindEvents() {
    document.addEventListener(
      "dropdown:opened",
      this.checkFadeVisibility.bind(this)
    );
  // Listen for market (country) change events bubbled from RevolutionSelectbox
  document.addEventListener('change:countrySelector', this.updateLanguageOptions.bind(this));
    this.delegateElement.on(
      "keydown",
      '[data-action="select-language"]',
      this.selectLanguage.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="custom-country-redirect"]',
      this.redirectToCustomUrl.bind(this)
    );
    this.delegateElement.on(
      "click",
      "[data-action=check-location-submit]",
      this.checkLocationSubmit.bind(this)
    );
    // Handle regular market selection (reset pending redirect)
    this.delegateElement.on(
      "click",
      '.RevolutionSelectbox--Item:not([data-action="custom-country-redirect"])',
      this.handleRegularMarketSelection.bind(this)
    );
    this.selectContainer.addEventListener(
      "scroll",
      this.checkFadeVisibility.bind(this)
    );
    window.addEventListener("resize", this.checkFadeVisibility.bind(this));
  }

  checkFadeVisibility() {
    const fade = this.element.querySelector('.container__fade--bottom');

    const isScrollable = this.selectContainer.scrollHeight > this.selectContainer.clientHeight;
    const isAtBottom = this.selectContainer.scrollTop + this.selectContainer.clientHeight >= this.selectContainer.scrollHeight - 1;
    fade.classList.toggle('hidden', !isScrollable || isAtBottom);
  }

  async checkLocationSubmit(event) {
    event.preventDefault();
    try {
      // 1. If a linked store redirect was selected, redirect immediately
      if (this.pendingRedirectUrl) {
        window.location.href = this.pendingRedirectUrl;
        return;
      }

      // 2. Locate the selected market item (regular items use selected="selected"; redirect items may have .selected)
      const selectedItem = this.element.querySelector('.RevolutionSelectbox--Item[selected="selected"]') ||
                           this.element.querySelector('.RevolutionSelectbox--Item.selected');
      if (!selectedItem) {
        console.warn('[Localization] No selected market item found.');
        return;
      }

      const chosenCountryCode = (selectedItem.getAttribute('data-value') || '').trim();
      if (!chosenCountryCode) {
        console.warn('[Localization] Selected market has empty data-value.');
        return;
      }

      // 3. Update hidden inputs (country + language) before submit
      const countryInput = document.querySelector('#country-selector__country-code');
      if (countryInput) countryInput.value = chosenCountryCode;
      // Ensure a language radio is checked and sync hidden language input
      if (this.ensureLanguageSelection) this.ensureLanguageSelection();
      const hiddenLang = this.element.querySelector('#selected-language');
      if (hiddenLang) {
        // If no radio selected yet, select first visible one
        if (!hiddenLang.value) {
          const firstRadio = this.element.querySelector('.language-selector__radio');
            if (firstRadio) { firstRadio.checked = true; hiddenLang.value = firstRadio.value; }
        }
      }

      const form = document.getElementById('localization-form');
      if (form) {
        form.submit();
      } else {
        console.error('[Localization] localization-form not found');
      }
    } catch (error) {
      console.error('Localization submit error:', error);
    }
  }

   redirectToCustomUrl(e, target) {
    const url = target.getAttribute('data-url');
    if (url) {
      // Instead of immediate redirect, store the URL for later use
      this.pendingRedirectUrl = url;
      
      // Remove all previous selections (both selected="selected" and .selected class)
      // Remove selected attribute from all items
      this.element.querySelectorAll('.RevolutionSelectbox--Item[selected="selected"]').forEach(item => {
        item.removeAttribute('selected');
      });
      
      // Remove selected class from all custom redirect items
      this.element.querySelectorAll('[data-action="custom-country-redirect"]').forEach(item => {
        item.classList.remove('selected');
      });
      
      // Add selected class to the clicked item
      target.classList.add('selected');
      
      // Optional: Update the display to show the selected market
      this.updateSelectedMarketDisplay(target);
      
      // Close the dropdown with animation like regular selections do
      const selectbox = target.closest('.RevolutionSelectbox');
      if (selectbox) {
        // Find the RevolutionSelectbox instance and call its closeDropdown method
        const selectboxInstance = Array.from(RevolutionSelectbox.instances).find(instance => 
          instance.wrapper === selectbox
        );
        
        if (selectboxInstance) {
          selectboxInstance.closeDropdown();
        } else {
          // Fallback: manual close without animation if instance not found
          const button = selectbox.querySelector('.RevolutionSelectbox--Button');
          const content = selectbox.querySelector('.RevolutionSelectbox--Content');
          
          if (button && content) {
            button.setAttribute('aria-expanded', 'false');
            content.setAttribute('aria-hidden', 'true');
            content.style.display = 'none';
          }
        }
      }
    }
  }

  updateSelectedMarketDisplay(selectedItem) {
    // Update the main selectbox button to show the selected market
    const selectboxButton = this.element.querySelector('.RevolutionSelectbox--Button');
    const selectedTitle = selectedItem.querySelector('.RevolutionSelectbox--Title--country');
    const selectedCurrency = selectedItem.querySelector('.RevolutionSelectbox--Title--currency');
    const selectedFlag = selectedItem.querySelector('.revolution-selectbox__flag img');
    
    if (selectboxButton && selectedTitle && selectedCurrency && selectedFlag) {
      const buttonTitle = selectboxButton.querySelector('.RevolutionSelectbox--Title--country');
      const buttonCurrency = selectboxButton.querySelector('.RevolutionSelectbox--Title--currency');
      const buttonFlag = selectboxButton.querySelector('.revolution-selectbox__flag img');
      
      if (buttonTitle) buttonTitle.textContent = selectedTitle.textContent;
      if (buttonCurrency) buttonCurrency.textContent = selectedCurrency.textContent;
      if (buttonFlag) {
        buttonFlag.src = selectedFlag.src;
        buttonFlag.srcset = selectedFlag.srcset;
      }
    }
  }

  handleRegularMarketSelection(e, target) {
  // Revert to simple selection only (no immediate language rebuild)
  this.pendingRedirectUrl = null;
  // Deselect any custom redirect items
  this.element.querySelectorAll('[data-action="custom-country-redirect"].selected').forEach(i=>i.classList.remove('selected'));
  // Maintain single selected attribute among regular items
  this.element.querySelectorAll('.RevolutionSelectbox--Item[selected="selected"]').forEach(item => { if (item !== target) item.removeAttribute('selected'); });
  if (!target.hasAttribute('selected')) target.setAttribute('selected','selected');
  if (this.ensureLanguageSelection) this.ensureLanguageSelection();

  }

  ensureLanguageSelection() {
    const hidden = this.element.querySelector('#selected-language');
    const radios = Array.from(this.element.querySelectorAll('.language-selector__radio'));
    if (!radios.length) return;
    let checked = radios.find(r => r.checked);
    if (!checked && hidden && hidden.value) {
      checked = radios.find(r => r.value.toLowerCase() === hidden.value.toLowerCase());
    }
    if (!checked) checked = radios[0];
    if (checked && !checked.checked) checked.checked = true;
    if (hidden && checked && hidden.value !== checked.value) hidden.value = checked.value;
  }


  async ensureLocalizationData() {
    if (this._localizationData) return this._localizationData;
    if (!this._localizationDataPromise) {
      this._localizationDataPromise = fetch('/localization.json')
        .then(r => r.ok ? r.json() : Promise.reject('Failed localization.json'))
        .then(data => { this._localizationData = data; return data; })
        .catch(err => { console.warn('[Localization] fetch /localization.json failed', err); return null; });
    }
    return this._localizationDataPromise;
  }



  resetPendingRedirect() {
    // Clear any pending redirect URL
    this.pendingRedirectUrl = null;
    
    // Remove selected class from any linked store items
    this.element.querySelectorAll('[data-action="custom-country-redirect"].selected').forEach(item => {
      item.classList.remove('selected');
    });
    
    // Restore the original market selection based on the user's current location
    // This will be handled by the template's logic for showing the correct selected market
  }

  selectLanguage(e, target) {
    if (e.key === 'Enter') {
      target.previousElementSibling.checked = true;
    }
  }

  updateLanguageOptions(e) {
    if (!e || !e.detail) return;
    const raw = e.detail.languages || '';
    const rawNames = e.detail.languageNames || '';
  const countryIso = (e.detail.country || '').trim().toUpperCase();

    // Determine list of ISO codes
    let isoList = [];
    if (!raw) {
      isoList = [];
    } else if (raw.trim().startsWith('[')) {
      // JSON array provided
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          // Accept either ["EN","FR"] or [{iso:"EN",name:"English"}]
          if (parsed.length && typeof parsed[0] === 'string') {
            isoList = parsed.map(s => String(s).trim());
          } else if (parsed.length && typeof parsed[0] === 'object') {
            isoList = parsed.map(o => o.iso || o.code).filter(Boolean);
          }
        }
      } catch(err) {
        console.warn('[Localization] Failed to parse languages JSON', err);
      }
    } else {
      isoList = raw.split(',').map(s => s.trim()).filter(Boolean);
    }

    // Build names mapping
    let nameList = [];
    if (rawNames) {
      nameList = rawNames.split(',').map(s => s.trim()).filter(Boolean);
    }

    // Pair iso + name
    const languages = isoList.map((iso, idx) => {
      let name = nameList[idx] || iso.toUpperCase();
      name = name.replace(/\b([a-z])/g, m => m.toUpperCase());
      return { iso: iso, name: name };
    });

    // Fallback: if no languages provided via data-languages, try localization.json
    const buildFromLocalizationJson = async () => {
      try {
        const data = await this.ensureLocalizationData();
        if (!data || !countryIso) return [];
        const match = (data.available_countries || []).find(c => c.iso_code?.toUpperCase() === countryIso);
        if (!match) return [];
        return (match.available_languages || []).map(l => ({ iso: l.iso_code, name: (l.endonym_name || l.name || l.iso_code).replace(/\b\w/g, c => c.toUpperCase()) }));
      } catch(err) {
        console.warn('[Localization] Fallback localization.json failed', err);
        return [];
      }
    };

    const proceed = (finalLangs) => {
      const languageOptionsContainer = this.element.querySelector('.language-options');
      const selectedLanguageInput = this.element.querySelector('#selected-language');
      if (!languageOptionsContainer || !selectedLanguageInput) return;

      const languageWrapper = this.element.querySelector('.language-selector__container');
      if (finalLangs.length <= 1) {
        if (languageWrapper) languageWrapper.style.display = 'none';
        if (finalLangs[0]) selectedLanguageInput.value = finalLangs[0].iso;
        return;
      } else if (languageWrapper) {
        languageWrapper.style.display = '';
      }

      const prevValue = selectedLanguageInput.value;
      languageOptionsContainer.innerHTML = '';
      languageOptionsContainer.appendChild(selectedLanguageInput);

      finalLangs.forEach(lang => {
        const label = document.createElement('label');
        label.className = 'language-option u-p2';
        label.setAttribute('tabindex','0');
        const input = document.createElement('input');
        input.type = 'radio';
        input.className = 'language-selector__radio';
        input.name = 'language_code';
        input.value = lang.iso;
        input.style.display = 'none';
        if (prevValue && prevValue.toLowerCase() === lang.iso.toLowerCase()) {
          input.checked = true;
          selectedLanguageInput.value = lang.iso;
        }

        const parentSpan = document.createElement('span');
        parentSpan.className = 'language-option__label';
        const solid = document.createElement('span');
        solid.className = 'checkmark Svg--checkbox-square-solid';
        const outline = document.createElement('span');
        outline.className = 'checkmark Svg--checkbox-square';
        if (this._langIconSolidTemplate) solid.innerHTML = this._langIconSolidTemplate;
        if (this._langIconOutlineTemplate) outline.innerHTML = this._langIconOutlineTemplate;
        parentSpan.appendChild(solid); parentSpan.appendChild(outline);

        label.appendChild(input);
        label.appendChild(parentSpan);
        label.appendChild(document.createTextNode(lang.name));
        languageOptionsContainer.appendChild(label);
      });

      this.ensureLanguageSelection && this.ensureLanguageSelection();
    };

    if (languages.length === 0) {
      buildFromLocalizationJson().then(fallbackLangs => proceed(fallbackLangs));
    } else {
      proceed(languages);
    }
  }
}
customElements.define("localization-modal", LocalizationModal);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() { }

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector('.pageOverlay');
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
    this.responsive = new Responsive();
    this.breakpoint = this.responsive.getCurrentBreakpoint();

    // Initial open logic
    this.initializePopupSettings();
  }

  initializePopupSettings() {
    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }

    // Shopify “thank you” fallback (you can leave or remove this)
    if (window.location.href.indexOf('customer_posted=true#popupForm') > -1) {
      this.options.delay = 0;
      this.openNewsletter();
      sessionStorage.setItem('newsletter-success', 'true');
    }
  }

  connectedCallback() {
    this.newsletterPopup = this.element.querySelector(".newsletter-popup");
    this.newsletterPopupTab = this.element.querySelector(".newsletter-popup__tab");
  this.newsletterPopup.style.display = 'none';
    this.newsletterPopupTab.style.display = 'none';

      this.setPopupHeight();
      this.toggleButton();
      this.bindEvents();
  }

  smoothHeightTransition(container, showElement, hideElements) {
    const startHeight = container.offsetHeight;

    // 2. Temporarily show the target element to measure its height
    // Keep it invisible while measuring
    showElement.style.display = 'block';
    showElement.style.visibility = 'hidden'; 
      
    // Hide other elements
    hideElements.forEach(el => el.style.display = 'none');
      
    // 3. Measure the new height
    const endHeight = container.offsetHeight;
      
    // 4. Set the container to the start height and make content visible
    container.style.height = startHeight + 'px';
    showElement.style.visibility = 'visible';
      
    // 5. Trigger the transition to the new height
    requestAnimationFrame(() => {
        container.style.height = endHeight + 'px';
    });
      
    // 6. Clean up after transition completes
    setTimeout(() => {
        container.style.height = 'auto';
    }, 350); // Match your transition duration
  }

  bindEvents() {
    this._debouncedSetPopupHeight = debounce(this.setPopupHeight.bind(this), 150);

    window.addEventListener("scroll", this._debouncedSetPopupHeight);
    window.addEventListener("resize", this._debouncedSetPopupHeight);
  
    scrollListener.addScrollListener(this, this._debouncedSetPopupHeight);
    responsive.addResizeListener(this, this._debouncedSetPopupHeight);

    // Bind Klaviyo form submit handler
    const formEl = this.element.querySelector('#popupForm');
    if (formEl) {
      formEl.addEventListener('submit', this.onSubmit.bind(this));
    }

    this.delegateElement.on(
      'click', 
      '[data-action="close-modal-tab"]', 
      this.closeNewsletterTab
    );

    this.delegateElement.on(
      'click', 
      '[data-action="open-newsletter-popup"]', 
      () => this.openNewsletter(true)
    );


    this.delegateElement.on(
      'click', 
      '[data-action="close-modal"]', 
      this.closeNewsletter
    );

    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

    this.delegateBody.on(
      "keydown",
      this.handleEsc.bind(this)
    )
  }

  handleEsc(e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      this.closeNewsletter();
    }
  }

  setPopupHeight() {
    document.documentElement.style.setProperty(
      "--newsletter-popup-height",
      this.element.offsetHeight + "px"
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allRequiredFields = this.element.querySelectorAll("[data-state='required']");

    allRequiredFields.forEach((item) => {
      if (item.type === "checkbox" && !item.checked) {
        this.buttonState = false;
      } else if (item.type !== "checkbox" && item.value.trim() === "") {
        this.buttonState = false;
      }
    });

    if (this.buttonState === true) {
      this.element.querySelector(".newsletter-popup-submit").removeAttribute("disabled");
    } else {
      this.element.querySelector(".newsletter-popup-submit").setAttribute("disabled", true);
    }
  }

  onSubmit(e) {
    e.preventDefault();

    // Grab & validate email
    const emailEl = this.element.querySelector('#klaviyoEmail');
    const email   = emailEl.value.trim();

    const emailEmptyError = this.element.querySelector(".newsletter-popup__email-empty-error");
    const emailAuthError = this.element.querySelector(".newsletter-popup__email-auth-error");
    const serverError = this.element.querySelector(".newsletter-popup__server-error");

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValidEmail = email => emailRegex.test(email);

    if (!email) {
      emailEmptyError.style.display = "block";
      emailAuthError.style.display = "none";
      serverError.style.display = "none";
      return;
    }

    if (!isValidEmail(email)) {
      emailEmptyError.style.display = "none";
      emailAuthError.style.display = "block";
      serverError.style.display = "none";
      return;
    }

    // You exposed this in Liquid already:
    const listId = window.klaviyoListId;

    // Build x-www-form-urlencoded body
    const body = new URLSearchParams({
      g: listId,                     // list ID param
      email: email,                  // subscriber email
      '$fields': '$source',          // any extra fields you want
      '$source': 'Popup_Subscribe'   // tag the source
    }).toString();

    // Submit to the same AJAX endpoint
    fetch(
      'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Cache-Control': 'no-cache'
        },
        body: body
      }
    )
    .then(r => r.json())
    .then(json => {
      if (json.success) {
        if(emailEmptyError) emailEmptyError.style.display = "none";
        if(emailAuthError) emailAuthError.style.display = "none";
        if(serverError) serverError.style.display = "none";
        
        sessionStorage.setItem('newsletter-success', 'true');
        this.showSuccessState();
      } else {
        // Server returned success=false
        if(emailEmptyError) emailEmptyError.style.display = "none";
        if(serverError) serverError.style.display = "none";
        emailAuthError.style.display = "block";
      }
    })
    .catch(err => {
      // Network or JSON parse error
      if(emailEmptyError) emailEmptyError.style.display = "none";
      if(emailAuthError) emailAuthError.style.display = "none";
      serverError.style.display = "block";
    });
  }

  showSuccessState() {
    if(this.breakpoint === 'phone' || this.breakpoint === 'pocket') {
        // Animate height transition on mobile
        const container = this.element.querySelector('.newsletter-popup__content');
        const successState = this.element.querySelector('.success-state');
        const hideElements = [
            this.element.querySelector('.newsletter-popup--default-text'),
            this.element.querySelector('.newsletter-popup--actions')
        ];

        this.smoothHeightTransition(container, successState, hideElements);
    } else {
        // Instant transition on desktop
        this.element.querySelector('.newsletter-popup--default-text').style.display = 'none';
        this.element.querySelector('.newsletter-popup--actions').style.display = 'none';
        this.element.querySelector('.success-state').style.display = 'block';
    }
  }


  handleOpenOptions() {
    const seen = localStorage.getItem('popup-seen');
    if (seen === 'true') return;

    if (this.options.scroll_amount > 0) {
      this.myScrollListener = scrollListener.addScrollListener(this, this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(
      body.scrollHeight, body.offsetHeight,
      html.clientHeight, html.scrollHeight, html.offsetHeight
    );
    const percScrolled = (window.scrollY / docHeight) * 100;
    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter(manualOpening = false) {
    if (sessionStorage.getItem('newsletter-success') === 'true' && !this.options.edit_mode) return;
    if (this.myScrollListener) this.myScrollListener.removeScrollListener();
    
    let delay = this.options.delay;

    if(manualOpening) {
      delay = 0;
      this.closeNewsletterTab();
    }

    setTimeout(() => {
        this.newsletterPopup.style.display = 'block';
        this.newsletterPopupTab.style.display = 'block';
      this.newsletterPopup.classList.remove('is-hidden');
      requestAnimationFrame(() => {
        this.newsletterPopup.setAttribute('aria-hidden', false);
      });
      this.pageOverlayElement.classList.add('is-visible');
      bodyScrollLock.disableBodyScroll(this.newsletterPopup, bodyScrollLockOptions);
      document.body.classList.add('scrollLock');
      this.pageOverlayElement.addEventListener('click', this.closeNewsletter);
      localStorage.setItem('popup-seen', 'true');

    }, 1000 * delay);
  }

  closeNewsletter = () => {
    this.newsletterPopup.setAttribute('aria-hidden', true);
    this.pageOverlayElement.classList.remove('is-visible');
    bodyScrollLock.clearAllBodyScrollLocks();
    document.body.classList.remove('scrollLock');
    this.transitionEndListener = this.transitionEnd.bind(this);
    this.newsletterPopup.addEventListener('transitionend', this.transitionEndListener);
    this.pageOverlayElement.removeEventListener('click', this.closeNewsletter);
    if (this.myScrollListener) this.myScrollListener.removeScrollListener();
  };

transitionEnd(event) {
  if (event && event.propertyName === 'transform') {
    this.newsletterPopup.classList.add('is-hidden');
    this.newsletterPopup.removeEventListener('transitionend', this.transitionEndListener);
    
    // Open the small tab after the modal is fully closed
    this.openNewsletterTab();
  }
}

  openNewsletterTab() {
    const isSubmittedSucessfully = sessionStorage.getItem('newsletter-success') === 'true';
    if (isSubmittedSucessfully) return;

    this.newsletterPopupTab.classList.remove('is-hidden');
    requestAnimationFrame(() => {
      this.newsletterPopupTab.setAttribute('aria-hidden', false);
    });
    
    localStorage.setItem('popup-small-seen', 'true');
  }

  closeNewsletterTab = () => {
    this.newsletterPopupTab.setAttribute('aria-hidden', true);

    this.transitionEndListenerSmall = this.transitionEndSmallPopup.bind(this);
    this.element.addEventListener('transitionend', this.transitionEndListenerSmall);
  };

  transitionEndSmallPopup() {
    if (event && event.propertyName === 'opacity') {
      this.newsletterPopupTab.classList.add('is-hidden');
      this.newsletterPopupTab.removeEventListener('transitionend', this.transitionEndListenerSmall);
    }
  }
}

customElements.define('newsletter-popup', NewsletterPopup);


class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);


  }

  connectedCallback() {
    
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on("click", '[data-action="submit-login"]', this.submitLogin.bind(this));
    this.delegateElement.on("click", '[data-action="submit-register"]', this.submitRegistration.bind(this));
    this.delegateElement.on("click", '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
    this.delegateElement.on("click", '[data-action="submit-recovery"]', this.accountRecover.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-login"]', this.accountInputSubmit.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-reg"]', this.accountInputSubmitReg.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-forgot-pass"]', this.accountInputSubmitForgot.bind(this));
  }

  accountInputSubmit(e) {
    if (e.key === "Enter") this.submitLogin(e);
  }

  accountInputSubmitReg(e) {
    if (e.key === "Enter") this.submitRegistration(e);
  }

  accountInputSubmitForgot(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      this.accountRecover(e);
    }
  }

  async accountRecover(event) {
    event.preventDefault();
    const recoverEndpoint = `${window.routes.localeRootUrl}/account/recover`;
    const requestBody = {
      email: this.element.querySelector("#RecoverEmail").value,
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }


    const loader = event.target.closest("form").querySelector(".itemLoader");
    loader.classList.add("is-visible");

    try {
      const response = await fetch(recoverEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = responseText;
      const recoverError = this.element.querySelector("#recover_form .drawer__errors");
      const recoverSuccess = this.element.querySelector("#recover_form .account__form-success-msg");
      if (responseText.includes("account__recover-email-error")) {

        recoverSuccess.classList.remove("is-visible");
        recoverError.innerHTML = "";
        recoverError.innerHTML = tempDiv.querySelector("#account__recover-email-error").innerHTML;
        recoverError.classList.add("is-visible");
      } else if (responseText.includes("account__form-success-msg")) {

        recoverError.classList.remove("is-visible");
        recoverSuccess.innerHTML = "";
        recoverSuccess.innerHTML = tempDiv.querySelector("#account__form-success-msg").innerHTML;
        recoverSuccess.classList.add("is-visible");


      }

      loader.classList.remove("is-visible");
    } catch (error) {
      console.error("An error occurred during the recovery request:", error);
    }
  }

  async submitRegistration(event) {
    event.preventDefault();
    const registrationEndpoint = `${window.routes.localeRootUrl}/account`;
    const requestBody = {
      customer: {
        first_name: this.element.querySelector("#RegisterForm-FirstName").value,
        last_name: this.element.querySelector("#RegisterForm-LastName").value,
        email: this.element.querySelector("#RegisterForm-email").value,
        password: this.element.querySelector("#RegisterForm-password").value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const loader = event.target.closest("form").querySelector(".itemLoader");

    loader.classList.add("is-visible");

    try {
      const response = await fetch(registrationEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();
      const registerEmailError = this.element.querySelector("#RegisterForm-email-error");
      const registerPasswordError = this.element.querySelector("#RegisterForm-password-error");
      const generalError = this.element.querySelector('#register .drawer__errors');

      if (responseText.indexOf("registerErrors") !== -1) {
        console.error("Error occurred during registration.");
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;

        const emailErrorElement = tempDiv.querySelector("#RegisterForm-email-error");

        if (emailErrorElement) {

          registerEmailError.setAttribute("aria-hidden", "false");
          registerEmailError.innerHTML = "";

          registerEmailError.innerHTML = emailErrorElement.innerHTML;
          this.element.querySelector("#RegisterForm-email").setAttribute("aria-invalid", "true");
        } else {
          this.element.querySelector("#RegisterForm-email").setAttribute("aria-invalid", "false");
          registerEmailError.setAttribute("aria-hidden", "true");
        }

        const passwordErrorElement = tempDiv.querySelector("#RegisterForm-password-error");
        if (passwordErrorElement) {
          registerPasswordError.setAttribute("aria-hidden", "false");
          registerPasswordError.style.display = "block";
          registerPasswordError.innerHTML = "";
          registerPasswordError.innerHTML = tempDiv.querySelector("#RegisterForm-password-error").innerHTML;
          this.element.querySelector("#RegisterForm-password").setAttribute("aria-invalid", "true");
        } else {
          registerPasswordError.setAttribute("aria-hidden", "true");
          this.element.querySelector("#RegisterForm-password").setAttribute("aria-invalid", "false");
        }

        const generalErrorNew = tempDiv.querySelector("#account__register-email-error");
        if (generalErrorNew) {

          generalError.setAttribute("aria-hidden", "false");
          generalError.style.display = "block";
          generalError.innerHTML = "";
          generalError.innerHTML = generalErrorNew.innerHTML;
        }

      } else {
        registerPasswordError.setAttribute("aria-hidden", "true");
        this.element.querySelector("#RegisterForm-email").setAttribute("aria-invalid", "false");
        this.element.querySelector("#RegisterForm-password").setAttribute("aria-invalid", "false");
        registerEmailError.setAttribute("aria-hidden", "true");
        location.href = window.routes.account_url;
      }

      loader.classList.remove("is-visible");

    } catch (error) {
      console.error("An error occurred during the registration request:", error);
    }
  }

  async submitLogin(event) {
    event.preventDefault();
    const loginEndpoint = `${window.routes.localeRootUrl}/account/login`;
    const requestBody = {
      customer: {
        email: this.element.querySelector("#CustomerEmail").value,
        password: this.element.querySelector("#CustomerPassword").value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const loader = event.target.closest("form").querySelector(".itemLoader");

    loader.classList.add("is-visible");

    try {
      const response = await fetch(loginEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();

      if (responseText.includes("loginError")) {
        const loginError = this.element.querySelector("#login .drawer__errors");
        loginError.innerHTML = "";
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;
        loginError.innerHTML =
          tempDiv.querySelector(".AlertError").innerHTML;
        loginError.classList.add("is-visible");
      } else {
        location.href = window.routes.account_url;
      }

      loader.classList.remove("is-visible");
    } catch (error) {
      console.error("An error occurred during the login request:", error);
    }
  }

  toggleTab(event) {
    event.preventDefault();
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll(".accountDrawer--Tab");
    const allContent = this.element.querySelectorAll(".drawer__account-content");

    allTabs.forEach((tab) => tab.setAttribute("aria-expanded", "false"));
    allContent.forEach((content) => content.setAttribute("aria-visible", "false"));

    event.target.setAttribute("aria-expanded", "true");
    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute("aria-visible", "true");
    }
  }

  toggleRecovery(event) {
    event.preventDefault();

   
    const id = event.target.dataset.id;
     console.log('gde je',id );
    if (id === "recover_form") {
      this.element.querySelector("#recover_form").setAttribute("aria-visible", "true");
      this.element.querySelector("#login").setAttribute("aria-visible", "false");
      trapFocus(this.element.querySelector("#recover_form"));
    } else {
      this.element.querySelector("#recover_form").setAttribute("aria-visible", "false");
      this.element.querySelector("#login").setAttribute("aria-visible", "true");
      trapFocus(this.element.querySelector("#login"));
    }
  }
}

customElements.define("account-handler", AccountHandler);


let alreadyExits = false;
class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
  
    if (alreadyExits) return;
    new Popup();
    alreadyExits = true;
  }
}
customElements.define("localization-selectors", LocalizationSelectors);

class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.updateVisibleHeight();
    this.bindEvents();
  }

  connectedCallback() {
    this.announcementBar = document.querySelector(".announcement-bar");
    document.documentElement.style.setProperty(
      "--announcement-height-fixed",
      this.element.clientHeight + "px"
    );

    this.carousel = this.element.querySelector(".announcement-bar__swiper.swiper");
    if(this.carousel) this.carouselInstance = new RevolutionSwiper(this.carousel);

    this.transitionSpeed = this.element.getAttribute('data-settings');
  }

  bindEvents() {
    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));

    if (this.element.dataset.main == 'true') {
      scrollListener.addScrollListener(this, this.updateVisibleHeight.bind(this));
      responsive.addResizeListener(this, this.updateVisibleHeight.bind(this));
    }
  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);

    // Update the height of .announcementBar with the visible height
    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `${visibleHeight}px`
    );
  }
}
customElements.define("announcement-bar", AnimatedAnnouncementBar);


class ScrollScaleHelper {
  constructor(images = []) {
    this.images = images;
    this.responsive = new Responsive();
    this.boundOnScroll = this.onScroll.bind(this);
     this.isEnabled = this.responsive.matchesBreakpoint("lap_and_up");
  }

  init() {
    if (!this.isEnabled || !this.images || this.images.length === 0) return;
    window.addEventListener("scroll", this.boundOnScroll);
    this.boundOnScroll();
  }

  destroy() {
       if (this.isEnabled) {
      window.removeEventListener("scroll", this.boundOnScroll);
    }
  }

  onScroll() {
    const windowHeight = window.innerHeight;
    this.images.forEach((img) => {
      const rect = img.getBoundingClientRect();
      const visible = 1 - Math.abs((rect.top + rect.height / 2 - windowHeight / 2) / windowHeight);
      const scale = 1 + Math.max(0, Math.min(visible, 1)) * 0.1;
      img.style.transform = `scale(${scale})`;
    });
  }

  updateImages(newImages) {
    this.images = newImages;
  }
}

class ImageElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.settings = JSON.parse(this.element.getAttribute("data-image-settings"));
  }

  connectedCallback() {
    if(!this.settings.enableAnimation) return;
    const images = Array.from(this.element.querySelectorAll(".image__element"));
    if (images.length === 0) return;
    this.scrollHelper = new ScrollScaleHelper(images);
    this.scrollHelper.init();
  }

  disconnectedCallback() {
    if(!this.settings.enableAnimation) return;
    if (this.scrollHelper) {
      this.scrollHelper.destroy();
    }
  }
}

customElements.define("image-element", ImageElement);

class QuoteSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.responsive = new Responsive();
    this.isMobileEnabled = this.element.getAttribute('data-mobile-swiper');
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);

    requestAnimationFrame(() => {
      setTimeout(() => {
        const swipers = this.element.querySelectorAll(".swiper");

        //Return early if less than 2 swiper elements found and add class
        if (swipers.length < 2) {
          if (swipers.length === 1) {
            swipers[0].classList.add('only');
          }
          return;
        }

        this.quotesSwiperEl = this.element.querySelector('.quotes-group__block');
        this.iconsSwiperEl = this.element.querySelector('.icons-group__block');

        //Check if icon slide has a matching quote slide and set cursors
        const quoteSlides = this.quotesSwiperEl.querySelectorAll('.swiper-slide');
        const validToggleIds = Array.from(quoteSlides).map(slide => slide.getAttribute('data-toggle-id'));
        
        const iconSlides = this.iconsSwiperEl.querySelectorAll('.swiper-slide');
        iconSlides.forEach(slide => {
          const toggleId = slide.getAttribute('data-toggle-id');
          slide.style.cursor = validToggleIds.includes(toggleId) ? 'pointer' : 'default';
        });

        if (!responsive.matchesBreakpoint('lap_and_up') && this.isMobileEnabled === 'true') {
          this.iconsSwiper = new RevolutionSwiper(this.iconsSwiperEl);
        }
       
        this.quotesSwiper = new RevolutionSwiper(this.quotesSwiperEl);

        // Add autoplay sync functionality
        this.setupAutoplaySync();

        this.bindEvents();
      }, 0);
    });
  }

  setupAutoplaySync() {
    // Listen for slide changes (including autoplay)
    if (this.quotesSwiper && this.quotesSwiper.swiperElement) {
      this.quotesSwiper.swiperElement.on('slideChange', () => {
        this.syncIconWithQuote();
      });
    }
  }

  syncIconWithQuote() {
    if (!this.quotesSwiper || !this.quotesSwiper.swiperElement) return;

    const s = this.quotesSwiper.swiperElement;
    const idx = typeof s.activeIndex === 'number' ? s.activeIndex : 0;

    const quoteSlides = this.quotesSwiperEl.querySelectorAll('.swiper-slide');
    const activeQuoteSlide = quoteSlides[idx];
    if (!activeQuoteSlide) return;

    const activeToggleId = activeQuoteSlide.getAttribute('data-toggle-id');
    if (!activeToggleId) return;

    // Remove active class from all icon slides
    const iconSlidesActive = this.iconsSwiperEl.querySelectorAll('.swiper-slide.active');
    iconSlidesActive.forEach(slide => slide.classList.remove('active'));

    // Add active class to matching icon slide
    const matchingIconSlide = this.iconsSwiperEl.querySelector(`[data-toggle-id="${activeToggleId}"]`);
    if (matchingIconSlide) {
      matchingIconSlide.classList.add('active');

      // If icons swiper exists (mobile), sync it too
      if (this.iconsSwiper && this.iconsSwiper.swiperElement) {
        const iconSlides = this.iconsSwiperEl.querySelectorAll('.swiper-slide');
        const iconIndex = Array.from(iconSlides).findIndex(slide => 
          slide.getAttribute('data-toggle-id') === activeToggleId
        );
        
        if (iconIndex !== -1) {
          this.iconsSwiper.swiperElement.slideTo(iconIndex);
        }
      }
    }
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="toggle-slide"]', this.toggleSlide.bind(this));
  }

  toggleSlide(event) {
    const iconSlide = event.target; // clicked element
    const targetId = iconSlide.getAttribute('data-toggle-id');
    if (!targetId) return;
  
    const quoteSlides = this.quotesSwiperEl.querySelectorAll('.swiper-slide');
    const targetIndex = Array.from(quoteSlides).findIndex(slide => {
      return slide.getAttribute('data-toggle-id') === targetId;
    });
    if (targetIndex !== -1) {
      this.quotesSwiper.selectCell(targetIndex);
      const iconSlides = this.iconsSwiperEl.querySelectorAll('.swiper-slide.active');
      iconSlides.forEach(slide => slide.classList.remove('active'));
    
      // Add active to the clicked slide
      iconSlide.classList.add('active');
    }
  }
}

customElements.define("quote-slider", QuoteSlider);

class ImageTextTabs extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this._tabRunId = 0;

    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.settings = JSON.parse(this.element.getAttribute("data-section-settings"));
  }

  connectedCallback() {
    this.carousel = this.element.querySelector(".image-text__vertical-swiper");
    this.carouselInstance = new RevolutionSwiper(this.carousel);

    setTimeout(() => {
     requestAnimationFrame(() => {
     requestAnimationFrame(() => {
      this.carouselInstance.swiperElement.update();
      this.carouselInstance.swiperElement.updateAutoHeight();
      this.forceSwiperHeightFix(this.carouselInstance.swiperElement);
      });
     });
}, 100);

    this.bindEvents();
    this.transferContentText();
    this.initializeTabsAndContent();
  }

  bindEvents() {

    this.delegateElement.on(
      "click",
      "[data-action='toggle-tab']",
      this.onTabClick.bind(this)
    );

    this.delegateElement.on(
      "mouseover",
      "[data-action='toggle-tab']",
      this.onTabHover.bind(this)
    );
  }

  initializeTabsAndContent() {
    let activeTab = this.element.querySelector('.image-text__tab-button[aria-expanded="true"]');
    if (!activeTab) {
      activeTab = this.element.querySelector('.image-text__tab-button');
    }

    let activeContent = this.element.querySelector('.image-text-content-wrapper[aria-expanded="true"]');
    if (!activeContent) {
      activeContent = this.element.querySelector('.image-text-content-wrapper');
    }

    let activeText = this.element.querySelector('.group-text-button__block-wrapper[aria-expanded="true"]');
    if (!activeText) {
      activeText = this.element.querySelector('.group-text-button__block-wrapper[aria-expanded="false"]');
    }

    // Exit early if all are missing
    if (!activeTab && !activeContent && !activeText) return;

    if (activeContent) {
      activeContent.setAttribute("aria-expanded", true);
    }

    if (activeText) {
      activeText.setAttribute("aria-expanded", true);
    }

    if (activeTab) {
      activeTab.setAttribute("aria-expanded", true);
    }
  }

  transferContentText() {
    const textToTransfer = this.element.querySelectorAll(
      `.image-text-content-wrapper .group-text-button__block-wrapper`
    );
    if(textToTransfer < 1) return;
    const destinationDiv = this.element.querySelector(".image-text__content-wrapper");

    // For each block, find its closest image-text-content-wrapper parent and get its data-content-tab-id
    textToTransfer.forEach((text) => {
      if (!text.classList.contains("group-text-button__block-wrapper")) return;
      text.setAttribute("aria-expanded", "false");
      const parentContentWrapper = text.closest(".image-text-content-wrapper");
      if (!parentContentWrapper) return;

      const tabId = parentContentWrapper.getAttribute("data-content-tab-id");
      if (tabId) {
        text.setAttribute("data-content-tab-id", tabId);
      }

      destinationDiv.appendChild(text);
    });
  }

  onTabHover(e) {

    const target = e.target.closest(".image-text__tab-button");
    if (!target || !this.element.contains(target)) return;

    // ne reaguj ako se miš pomera unutar istog taba
    if (target.contains(e.relatedTarget)) return;

    const tabId = target.getAttribute("data-tab-id");
    if (!tabId) return;

    clearTimeout(this._hoverTimer);

    this._hoverTimer = setTimeout(() => {
      this.runTabChange(target, tabId);
    }, 120);
  }


  async animateText(tabId, runId) {
    if (runId !== this._tabRunId) return;

    const activeText = this.element.querySelector(
      `.group-text-button__block-wrapper[data-content-tab-id="${tabId}"]`
    );
    if (!activeText) return;

    let oldActiveText = this.element.querySelector(
      ".group-text-button__block-wrapper[aria-expanded='true']"
    );

    if (oldActiveText && oldActiveText === activeText) return;

    // Cancel any ongoing transition
    if (oldActiveText && oldActiveText._transitionResolve) {
      oldActiveText.removeEventListener(
        "transitionend",
        oldActiveText._transitionHandler
      );

      oldActiveText.setAttribute("aria-expanded", "false");
      oldActiveText.setAttribute("aria-visible", "false");

      oldActiveText._transitionResolve();

      oldActiveText._transitionResolve = null;
      oldActiveText._transitionHandler = null;
    }

    if (this.settings.disable_delay == false) {

      if (oldActiveText) {

        oldActiveText.setAttribute("aria-visible", "false");

        await new Promise((resolve) => {

          let done = false;

          const finish = () => {
            if (done) return;
            done = true;

            oldActiveText.removeEventListener(
              "transitionend",
              onTransitionEnd
            );

            oldActiveText._transitionResolve = null;
            oldActiveText._transitionHandler = null;

            oldActiveText.setAttribute("aria-expanded", "false");
            resolve();
          };

          const onTransitionEnd = (event) => {
            if (event.target !== oldActiveText) return;
            if (event.propertyName !== "opacity") return;
            finish();
          };

          oldActiveText._transitionResolve = finish;
          oldActiveText._transitionHandler = onTransitionEnd;

          oldActiveText.addEventListener(
            "transitionend",
            onTransitionEnd
          );

          // fallback – ako transition nikad ne stigne
          setTimeout(finish, 250);
        });

        // ako je u međuvremenu došao novi hover/click
        if (runId !== this._tabRunId) return;
      }

      activeText.setAttribute("aria-expanded", "true");

      // force reflow
      activeText.offsetHeight;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          activeText.setAttribute("aria-visible", "true");
        });
      });

    } else {

      if (oldActiveText) {
        oldActiveText.setAttribute("aria-expanded", "false");
        oldActiveText.setAttribute("aria-visible", "false");
      }

      activeText.setAttribute("aria-expanded", "true");
      activeText.setAttribute("aria-visible", "true");
    }
  }



  animateImages(tabId) {
    const slides = this.element.querySelectorAll(".image-text-content-wrapper.swiper-slide");
    const targetIndex = Array.from(slides).findIndex(
      (slide) => slide.dataset.contentTabId === tabId
    );

    if (targetIndex === -1 || !this.carouselInstance) return;
    this.carouselInstance.swiperElement.slideTo(targetIndex);

  }

  async onTabClick(e) {
    e.preventDefault();

    const target = e.target.closest(".image-text__tab-button");
    if (!target || !this.element.contains(target)) return;

    const tabId = target.getAttribute("data-tab-id");
    if (!tabId) return;

    clearTimeout(this._hoverTimer);

    this.runTabChange(target, tabId);
  }
  
  runTabChange(target, tabId) {

  // ✅ svaki poziv povećava run id
  const runId = ++this._tabRunId;

  const activeTab = this.element.querySelector(
    '.image-text__tab-button[aria-expanded="true"]'
  );

  if (activeTab === target) return;

  if (activeTab) activeTab.setAttribute("aria-expanded", false);
  target.setAttribute("aria-expanded", true);

  this.animateImages(tabId);
  this.animateText(tabId, runId);

  const animatedContainer =
    this.element.querySelector('.image-text-tabs-content__content');

  if (!animatedContainer) return;

  const oldHeight = animatedContainer.offsetHeight;

  // ✅ ubij prethodni layout timeout
  clearTimeout(this._tabLayoutTimer);

  this._tabLayoutTimer = setTimeout(() => {

    // ✅ ako je u međuvremenu došao nov hover – preskoči
    if (runId !== this._tabRunId) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {

        // opet proverimo – jer rAF može kasniti
        if (runId !== this._tabRunId) return;

        this.carouselInstance.swiperElement.update();
        this.carouselInstance.swiperElement.updateAutoHeight();
        this.forceSwiperHeightFix(this.carouselInstance.swiperElement);

        const newHeight = animatedContainer.offsetHeight;

        animatedContainer.style.height = `${oldHeight}px`;
        animatedContainer.offsetHeight;
        animatedContainer.style.height = `${newHeight}px`;

        animatedContainer.addEventListener(
          'transitionend',
          () => {
            // očisti samo ako je i dalje poslednji run
            if (runId === this._tabRunId) {
              animatedContainer.style.height = '';
            }
          },
          { once: true }
        );

      });
    });

  }, 100);
}


  
  forceSwiperHeightFix(swiperInstance) {
  const swiperEl = swiperInstance.el;
  const activeSlide = swiperEl.querySelector(".swiper-slide-active");

  if (!activeSlide) return;

  const newHeight = activeSlide.scrollHeight;

  // Apply height directly to Swiper container and wrapper
  swiperEl.style.height = `${newHeight}px`;
  if (swiperInstance.wrapperEl) {
    swiperInstance.wrapperEl.style.height = `${newHeight}px`;
  }
}
}

customElements.define("image-text-tabs", ImageTextTabs);

class HotspotSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.responsive = new Responsive();
    this.breakpoint = this.responsive.getCurrentBreakpoint();
    this.settings = JSON.parse(this.element.getAttribute("data-image-settings"));
    this.observer = null;
    this.hasAnimated = false; // Prevent multiple animations
  }

  connectedCallback() {
    if(this.breakpoint === "phone" || this.breakpoint === 'pocket') {
      this.transferHotspotCardsMobile();
    }

    this.bindEvents();
    requestAnimationFrame(() => {
      this.updateHeightVariables();
    });
    this.handleActivateHotspot();
    this.setupIntersectionObserver();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.1
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.hasAnimated) {
          this.handleHotspotShowOnLoad();
          this.hasAnimated = true;

          this.observer.disconnect();
        }
      });
    }, options);

    this.observer.observe(this.element);
  }

  updateHeightVariables() {
    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        document.documentElement.style.setProperty(
          "--hotspots-text-wrapper-height",
          entry.contentRect.height + "px"
        );
      }
    });

    this.hotspotsTextWrapper = this.element.querySelector(".hotspots__text-wrapper");
    if (this.hotspotsTextWrapper) {
      observer.observe(this.hotspotsTextWrapper);
    }
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='toggle-hotspot']",
      this.toggleHotSpot.bind(this)
    );

    this.delegateElement.on(
      "click",
      this.handleOutsideClick.bind(this)
    );

    this.delegateBody.on(
      "keydown",
      this.handleEsc.bind(this)
    )

    responsive.addResizeListener(this, this.updateHeightVariables.bind(this));
  }

  transferHotspotCardsMobile() {
    const hotspotCards = this.element.querySelectorAll(".hotspot-card-wrapper");
    
    hotspotCards.forEach((card) => {
      const dotWrapper = this.element.querySelector(`.mobile-hotspots-placeholder`);
      if (dotWrapper) {
        dotWrapper.appendChild(card);
      }
    });
  }

  hideHotspotItems() {
    const hotspotItems = this.element.querySelectorAll(".hotspot-item-wrapper");
    hotspotItems.forEach((item) => {
      item.classList.remove("shown");
      item.style.opacity = "0";
      item.style.visibility = "hidden";
    });
  }

  handleHotspotShowOnLoad() {
    const hotspotItems = this.element.querySelectorAll(".hotspot-item-wrapper");
    if (hotspotItems.length === 0) return;
  
    hotspotItems.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add("shown");
      }, (index + 1) * 800);
    });
  }

  handleActivateHotspot() {
    const activeHotspotItem = this.element.querySelector('.hotspot-item-wrapper[data-active="true"]');
    if(!activeHotspotItem) return;

    const activeHotspotButtonWrapper = activeHotspotItem.querySelector(".hotspot-dot-wrapper");
    const activeHotspotButton = activeHotspotButtonWrapper.querySelector(".hotspot-dot");
    const hotspotId = activeHotspotButtonWrapper.getAttribute("data-toggle-id");
    const hotspotText = activeHotspotButtonWrapper.querySelector(".hotspot-dot-text");

    this.openHotspot(hotspotId, activeHotspotButton, hotspotText);
  }

  closeHotspot() {
    const activeCard = this.element.querySelector(".hotspot-card-wrapper[aria-expanded='true']");
    if (activeCard) {
      activeCard.setAttribute("aria-expanded", "false");
    }
    
    const activeDot = this.element.querySelector(".hotspot-dot.active");
    if (activeDot) {
      activeDot.classList.remove("active");
    }

    const hotspotText = this.element.querySelector(".hotspot-dot-text.hidden");
    if(hotspotText) {
      hotspotText.classList.remove("hidden");
    }
  }
  
  openHotspot(hotspotId, dotElement, hotspotText) {

    const hotspotCard = this.element.querySelector(`.hotspot-card-wrapper[data-id="${hotspotId}"]`);
    
    if (!hotspotCard) {
      console.error(`Hotspot card with id ${hotspotId} not found.`);
      return false;
    }
    this.closeHotspot();
  
    hotspotCard.setAttribute("aria-expanded", "true");
    if (dotElement) {
      dotElement.classList.add("active");
    }
    if (hotspotText) {
      hotspotText.classList.add("hidden");
    }
    
    return true;
  }
  
  handleEsc(e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      this.closeHotspot();
    }
  }
  
  handleOutsideClick(e) {
    const hotspotItem = this.element.querySelector(".hotspot-item-wrapper:has(.hotspot-card-wrapper[aria-expanded='true'])");
    
    if (hotspotItem && !hotspotItem.contains(e.target)) {
      this.closeHotspot();
    }
  }
  
  toggleHotSpot(e) {
    e.preventDefault();
  
    const target = e.target;
    if(!target.classList.contains("hotspot-dot")) return;
  
    const activeDot = this.element.querySelector(".hotspot-dot.active");
    const parentEl = target.closest(".hotspot-dot-wrapper");
    if (!parentEl) return;
  
    const hotspotId = parentEl.getAttribute("data-toggle-id");
    const hotspotText = parentEl.querySelector(".hotspot-dot-text");
  
    if (activeDot === target) {
      this.closeHotspot(hotspotText);
      return;
    }
  
    this.openHotspot(hotspotId, target, hotspotText);
  }
}

customElements.define("section-hotspots", HotspotSection);

class ProductShowcaseCustom extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.settings = JSON.parse(this.element.getAttribute("data-image-settings"));
    this.responsive = new Responsive();
    this.breakpoint = this.responsive.getCurrentBreakpoint();
  }

  connectedCallback() {
    this.imgCarousel = this.element.querySelector(".product-carousel__image__wrapper.swiper");
    this.productCarousel = this.element.querySelector(".product-carousel__product__wrapper.swiper");
  
    if(!this.imgCarousel || !this.productCarousel) {
      console.error("Product Showcase Custom: Required elements not found.");
      return;
    }
  
    this.imgCarouselInstance = new RevolutionSwiper(this.imgCarousel);
    this.productCarouselInstance = new RevolutionSwiper(this.productCarousel);
  
    const imgSwiper = this.imgCarouselInstance.swiperElement;
    const productSwiper = this.productCarouselInstance.swiperElement;

    this.renderCustomSwiperBullets(imgSwiper);
    this.handleConnectedSwipers(imgSwiper, productSwiper);

    if(this.breakpoint === 'phone' || this.breakpoint === 'pocket') {
      this.transferFeaturedInfoMobile();
    }
  }

  renderCustomSwiperBullets(imgSwiper) {
    // Define custom bullet render logic
    imgSwiper.params.pagination.renderBullet = function (index, className) {
      const slide = imgSwiper.slides[index];
      const mediaType = slide.querySelector('.VideoRatio') ? 'video' : 'image';

      if (mediaType === 'video') {
        return `<span class="swiper-video-bullet ${className}"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                  <path d="M0.647461 0.508789L7.44238 3.90234L7.45605 3.90918C7.48299 3.92897 7.49993 3.95944 7.5 3.99316C7.5 4.02304 7.4874 4.05146 7.46582 4.07129L7.44141 4.08789L0.655273 7.48633L0.651367 7.48828C0.635202 7.49656 0.617185 7.50068 0.599609 7.5L0.548828 7.48438C0.533388 7.47481 0.521094 7.4616 0.512695 7.44629L0.5 7.39648V0.604492C0.500246 0.586753 0.505237 0.569792 0.513672 0.554688L0.549805 0.516602C0.579249 0.498123 0.615467 0.49546 0.647461 0.508789Z" stroke="#43494B"/>
                </svg></span>`;
      }

      return `<span class="${className}"></span>`;
    };
            
    // Rerender the pagination with the custom video bullet.
    imgSwiper.pagination.destroy();
    imgSwiper.pagination.init();
    imgSwiper.pagination.render();
    imgSwiper.pagination.update();
  }

  handleConnectedSwipers(imgSwiper, productSwiper) {
    // Connect the two swipers
    if (imgSwiper && productSwiper) {
      imgSwiper.controller.control = productSwiper;
      productSwiper.controller.control = imgSwiper;
    } else {
      console.warn("Could not connect swipers: missing internal swiper instances.");
    }
  }

  transferFeaturedInfoMobile() {
    const destinationDiv = this.element.querySelector(".product-carousel__image__wrapper .product-carousel__image__featured-info");
    const featuredInfo = this.element.querySelector(".product-carousel__featured-info");

    if(!destinationDiv || !featuredInfo) return;

    const clonedInfo = featuredInfo.cloneNode(true);
    destinationDiv.appendChild(featuredInfo);
  }
  
}

customElements.define("section-product-showcase-custom", ProductShowcaseCustom);

class ArticleComments extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.articleWrapper = this.element.querySelector(".article-comments__main-container");
    this.showLessButton = this.element.querySelector(".article-comments__show-less-button");
    this.commentForm = this.element.querySelector("#comment_form");



    if (this.commentForm) {
      this.commentForm.addEventListener("submit", (event) => {
        this.customSubmit(event);
      });
    }

    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="load-more"]',
      this.loadMore.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="scroll-to-comment-form"]',
      this.scrollToCommentForm.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="open-comment-form"]',
      this.openCommentForm.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="show-less"]',
      this.showLess.bind(this)
    );

    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allRequiredFields = this.element.querySelectorAll("[data-state='required']");

    allRequiredFields.forEach((item) => {
      if (item.type === "checkbox" && !item.checked) {
        this.buttonState = false;
      } else if (item.type !== "checkbox" && item.value.trim() === "") {
        this.buttonState = false;
      }
    });

    if (this.buttonState === true) {
      this.element.querySelector(".article-comments__submit-button").removeAttribute("disabled");
    } else {
      this.element.querySelector(".article-comments__submit-button").setAttribute("disabled", true);
    }
  }

  //Escaping first digit for valid querySelector
  escapeSelector(id) {
    // If id starts with a digit, escape it properly
    if (/^\d/.test(id)) {
      return `\\3${id[0]} ${id.slice(1)}`;
    }
    return id.replace(/([!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g, '\\$1');
  }


  async loadMore(event, target) {
    event.preventDefault();
    const dataHref = target.getAttribute("data-next-href");
  
    if (!dataHref) {
      console.error("Data next-href attribute is missing.");
      return;
    }
  
    const loader = this.element.querySelector(".article-comments__load-more-button .itemLoader");
  
    try {
      loader?.classList.add("is-visible");
  
      // Add small artificial delay because Shopify takes time 
      // validating and approving new comments
      await new Promise(resolve => setTimeout(resolve, 500));
  
      const response = await fetch(`${window.routes.localeRootUrl}${dataHref}`, {
        credentials: "same-origin",
        method: "GET",
      });
  
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
  
      const htmlData = await response.text();
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(htmlData, "text/html");
  
      const newComments = htmlDocument.querySelectorAll(".article-comments__comment");
      const commentsContainer = this.element.querySelector(".article-comments__main-container");
  
      newComments.forEach((comment) => {
        const commentId = comment.getAttribute('id');
        if (!commentId) return;
  
        const escapedId = this.escapeSelector(commentId);
        if (!commentsContainer.querySelector(`#${escapedId}`)) {
          commentsContainer.appendChild(comment);
        }
      });
  
      new RevolutionAnimation(this.element);
  
      const newLoadMoreElement = htmlDocument.querySelector("[data-next-href]");
      const currentLoadMoreElement = this.element.querySelector(".article-comments__load-more-button");
  
      if (newLoadMoreElement) {
        const newHref = newLoadMoreElement.dataset.nextHref;
        if (currentLoadMoreElement) {
          currentLoadMoreElement.dataset.nextHref = newHref;
          commentsContainer.appendChild(currentLoadMoreElement);
          commentsContainer.appendChild(this.showLessButton);
        }
      } else {
        currentLoadMoreElement?.remove();
        commentsContainer.appendChild(this.showLessButton);
        this.showLessButton.classList.remove('hidden');
      }
  
    } catch (error) {
      console.error("Failed to load more comments:", error);
    } finally {
      loader?.classList.remove("is-visible");
    }
  }
  

  scrollToCommentForm(event) {
    event.preventDefault();
    const formRect = this.commentForm.getBoundingClientRect();
    const scrollOffset = 50;

    window.scrollTo({
      top: formRect.top + window.scrollY - scrollOffset,
      behavior: 'smooth'
    });
  }

  openCommentForm(event) {
    event.preventDefault();
    const target = event.target;
    const commentForm = this.element.querySelector(".comment-form-wrapper");

    if (!commentForm) return;

    // Open form and scroll to it.
    target.setAttribute("data-action", "scroll-to-comment-form");
    setTimeout(() => {
      this.scrollToCommentForm(event);
    }, 300);

    commentForm.setAttribute("aria-expanded", true);
    requestAnimationFrame(() => {
      commentForm.setAttribute("aria-visible", true);
    });
  }

  customSubmit(event) {
    event.preventDefault();
    const titleInput = this.commentForm.querySelector('[name="comment[title]"]');
    const textarea = this.commentForm.querySelector('textarea');
    textarea.style.color = 'transparent';

    if (titleInput && textarea) {
      const titleValue = titleInput.value.trim();
      const existingText = textarea.value;

      textarea.value = `[title] ${titleValue} [title]\n\n${existingText}`;
    }
  }

  async showLess(event, target) {
    event.preventDefault();
    const firstPageUrl = target.dataset.firstPageUrl;
    const loader = this.element.querySelector(".article-comments__show-less-button .itemLoader");

    try {
      loader?.classList.add("is-visible");

      const response = await fetch(`${window.routes.localeRootUrl}${firstPageUrl}`, {
        credentials: "same-origin",
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const htmlData = await response.text();
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(htmlData, "text/html");

      const firstPageComments = htmlDocument.querySelectorAll(".article-comments__comment");
      const commentsContainer = this.element.querySelector(".article-comments__main-container");

      commentsContainer.querySelectorAll(".article-comments__comment").forEach(comment => comment.remove());
      commentsContainer.prepend(...firstPageComments);

      new RevolutionAnimation(this.element);

      this.showLessButton.classList.add('hidden');

      const loadMoreButton = htmlDocument.querySelector(".article-comments__load-more-button");
      if (loadMoreButton) {
        commentsContainer.appendChild(loadMoreButton);
      }

      const containerRect = this.element.getBoundingClientRect();
      const scrollOffset = 150;

      window.scrollTo({
        top: containerRect.top + window.scrollY - scrollOffset,
        behavior: 'smooth',
      });
    } catch (error) {
      console.error("Failed to load first page comments:", error);
    } finally {
        loader?.classList.remove("is-visible");
    }
  }
}

customElements.define("article-comments", ArticleComments);

class BlogSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.breakpoint = new Responsive().getCurrentBreakpoint();
  }

  connectedCallback() {
    new InfiniteScroll('#blog-article--wrapper', '#infinite-scroll', true);
  }
}

customElements.define("blog-section", BlogSection);

class BlogShowcaseSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelectorAll(".swiper");
    if (this.carouselElement.length > 0) {
      this.carouselElement.forEach((el) => {

        this.carousel = new RevolutionSwiper(el);
      });
    }


  }
}

customElements.define("blog-showcase", BlogShowcaseSlider);

class FAQSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
  }

  connectedCallback() {
    this.searchInput = this.element.querySelector(".faq--search");
    this.searchBar = this.element.querySelector('.faq__search-bar--wrapper');
    this.termsBlocks = document.querySelectorAll(".faq__block--heading");
    this.noResultsElement = document.querySelector("#faq__results--none");
    this.firstTag = this.element.querySelector('.faq__tab--link');
    if (this.firstTag) {
      this.firstTag.classList.add("is-active");
    }
    this.bindEvents();
    this.disableUnlinkedTabs();
    this.validateTabs();
    this.initializeFaqDropdowns();
  }

  bindEvents() {
    this.onInputListener = debounce(this.handleSearch.bind(this), 350);
    this.debouncedHandleClick = debounce(this.handleTabClick.bind(this), 200);
    this.delegateElement.on("click", '[data-action="handle-tab-click"]', this.debouncedHandleClick);
    this.delegateElement.on("click", '[data-action="clear-search"]', this.clearSearch.bind(this));

    this.delegateElement.on(
      "keyup",
      '[data-action="search-string"]',
      this.onInputListener
    );

    this.handleScrollListener = this.handleScroll.bind(this);
    scrollListener.addScrollListener(this, this.handleScrollListener);
  }

  // Helper method to reset FAQ to initial state
  resetFaqToInitialState() {
    const tabsWrapper = this.element.querySelector(".faq-tabs");
    const dropdownList = this.element.querySelectorAll(".dropdown-wrapper");
    const noResultsElement = this.element.querySelector('.faq__results--none');

    // Show tabs wrapper
    tabsWrapper.classList.remove("is-hidden");

    // Reset all dropdowns
    dropdownList.forEach((dropdown, index) => {
      const isFirstDropdown = index === 0;
      
      // Show only first dropdown, hide others
      dropdown.setAttribute("aria-hidden", !isFirstDropdown);
      dropdown.setAttribute("aria-visible", isFirstDropdown);

      // Show all content within each dropdown
      const termsBlocks = dropdown.querySelectorAll('.dropdown-tabs__wrapper');
      termsBlocks.forEach((block) => {
        block.classList.remove("is-hidden");
        const questions = block.querySelectorAll(".Dropdown.dropdown-border");
        questions.forEach((content) => content.classList.remove("is-hidden"));
      });
    });

    // Hide no results message
    if (noResultsElement) noResultsElement.classList.add("is-hidden");
  }

  // Helper method to toggle clear button visibility
  toggleClearButton(show) {
    const clearBtn = this.element.querySelector(".supportFaq--mobileClearBtn");
    if (clearBtn) clearBtn.style.display = show ? "flex" : "none";
  }

  // Remove cursor from unlinked tabs
  disableUnlinkedTabs() {
  const tabs = this.element.querySelectorAll('.faq__tab');

  tabs.forEach(tab => {
    const toggleId = tab.getAttribute('data-toggle-id');
    const targetDropdown = this.element.querySelector(`.dropdown-wrapper[id="${toggleId}"]`);

    if (!targetDropdown) {
      tab.style.cursor = 'default';
    }
  });
  }

  // Helper method to toggle no results message
  toggleNoResults(show) {
    const noResultsElement = this.element.querySelector('.faq__results--none');
    if (noResultsElement) {
      noResultsElement.classList.toggle("is-hidden", !show);
      if (show) console.log("Showing no results element:", noResultsElement);
    }
  }

  // Helper method to check if content matches search term
  contentMatches(element, searchTerm) {
    return element?.textContent.toLowerCase().includes(searchTerm) || false;
  }

  handleSearch() {
    const searchTerm = this.searchInput.value.toLowerCase().trim();
    
    // Toggle clear button based on input value
    this.toggleClearButton(!!this.searchInput.value);

    // If search is empty, reset to initial state
    if (searchTerm === "") {
      this.resetFaqToInitialState();
      return;
    }

    // Hide tabs when searching
    const tabsWrapper = this.element.querySelector(".faq-tabs");
    tabsWrapper.classList.add("is-hidden");

    let hasGlobalMatch = false;

    // Search through all tabs
    this.element.querySelectorAll('.dropdown-wrapper').forEach(dropdown => {
      const termsBlocks = dropdown.querySelectorAll('.dropdown-tabs__wrapper');
      let hasTabMatch = false;

      termsBlocks.forEach((block) => {
        const questions = block.querySelectorAll(".Dropdown.dropdown-border");
        let blockMatch = false;

        // Check if tab title matches
        const tabTitle = dropdown.querySelector('.dropdown-tabs__text-group .u-h3');
        const titleMatch = this.contentMatches(tabTitle, searchTerm);

        if (titleMatch) {
          // Show all questions in this block if title matches
          block.classList.remove("is-hidden");
          questions.forEach((content) => content.classList.remove("is-hidden"));
          blockMatch = true;
        } else {
          // Search individual questions
          questions.forEach((questionWrapper) => {
            const questionTitle = questionWrapper.querySelector('.info__dropdown-button--text');
            const answerContent = questionWrapper.querySelector('.Dropdown--Content');
            
            const questionMatches = this.contentMatches(questionTitle, searchTerm);
            const answerMatches = this.contentMatches(answerContent, searchTerm);

            if (questionMatches || answerMatches) {
              questionWrapper.classList.remove("is-hidden");
              blockMatch = true;
            } else {
              questionWrapper.classList.add("is-hidden");
            }
          });

          // Show/hide block based on whether it has matches
          block.classList.toggle("is-hidden", !blockMatch);
        }

        if (blockMatch) hasTabMatch = true;
      });

      // Show/hide dropdown based on matches
      dropdown.setAttribute("aria-hidden", !hasTabMatch);
      dropdown.setAttribute("aria-visible", hasTabMatch);
      
      if (hasTabMatch) hasGlobalMatch = true;
    });

    // Show no results message if no matches found
    this.toggleNoResults(!hasGlobalMatch);
  }

  clearSearch() {
    const inputValue = this.element.querySelector(".faq--search.mobile");

    // Reset search input
    if (inputValue) {
      inputValue.value = "";
      inputValue.focus();
    }

    // Hide clear button
    this.toggleClearButton(false);

    // Reset FAQ to initial state
    this.resetFaqToInitialState();
  }

  initializeFaqDropdowns() {
    const oldTab = this.element.querySelector('.faq__tab');
    const firstDropdown = this.element.querySelector('.dropdown-wrapper');

    if (firstDropdown) {
      firstDropdown.setAttribute('aria-hidden', 'false');
      firstDropdown.setAttribute('aria-visible', 'true');
    }

    if (oldTab) oldTab.setAttribute('aria-expanded', 'true');
  }

  handleTabClick(event) {
    event.preventDefault();
 
    const target = event.target;
    const targetId = target.getAttribute('data-toggle-id');

    const targetDropdown = this.element.querySelector(`.dropdown-wrapper[id="${targetId}"]`);
    const oldDropdown = this.element.querySelector('.dropdown-wrapper[aria-visible="true"]');

    const oldTab = this.element.querySelector('.faq__tab[aria-expanded="true"]');
    // if(oldTab && oldTab.dataset.toggleId === targetId) return; 



    oldTab.setAttribute("aria-expanded", false);
    target.setAttribute("aria-expanded", true);

    if (targetDropdown && oldDropdown) {
      if ((targetDropdown.id || "") === (oldDropdown.id || "")) return;

      // Step 1: Start the fade-out transition by changing aria-hidden
      oldDropdown.setAttribute("aria-hidden", "true");
      // Step 2: Wait for the transition to finish
      const handleTransitionEnd = (e) => {
        oldDropdown.removeEventListener("transitionend", handleTransitionEnd);
        // Step 3: Hide the old dropdown completely
        oldDropdown.setAttribute("aria-visible", "false");
        // Step 4: Show the new dropdown
        targetDropdown.setAttribute("aria-visible", "true");
        // Trigger reflow to ensure the transition kicks in properly (sometimes needed)
        void targetDropdown.offsetWidth;
        // Step 5: Start the fade-in transition
        targetDropdown.setAttribute("aria-hidden", "false");

        this.scrollToSection(targetDropdown);
      };

      oldDropdown.addEventListener("transitionend", handleTransitionEnd);

  
    
    }
  }

  validateTabs() {
    const tabSlides = this.element.querySelectorAll('.faq__swiper--slide');

    tabSlides.forEach(slide => {
      const link = slide.querySelector('a[href^="#"]');
      if (!link) return;

      const targetId = link.getAttribute('href').substring(1);
      const targetElement = this.element.querySelector(`#${targetId}`);
      if (!targetElement) {
        slide.remove();
      }
    });
  }

  scrollToSection(targetElement, offset = 96) {
    if (!targetElement) return;

    const targetPosition = targetElement.offsetTop - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });
  }


  slideToActiveTab(delay = 0) {
    clearTimeout(this.slideToActiveTabTimeout);

    this.slideToActiveTabTimeout = setTimeout(() => {
      const activeLink = this.element.querySelector('.faq__tab--link.is-active');
      if (!activeLink) return;

      const slideElement = activeLink.closest('.swiper-slide');
      if (!slideElement) return;

      const swiperEl = this.element.querySelector('.faq__swiper');
      if (!swiperEl || !swiperEl.swiper) return;

      const slides = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
      const activeIndex = slides.indexOf(slideElement);

      if (activeIndex !== -1) {
        swiperEl.swiper.slideTo(activeIndex);
      }
    }, delay);
  }

  handleScroll() {
    if (this.element.dataset.clicked == "true") return;
    const faqSubheaders = this.element.querySelectorAll(".faq__block--heading");
    let threshold = 260;

    if (responsive.matchesBreakpoint("lap_and_up")) {
      threshold = 200;
    }

    faqSubheaders.forEach((faqSubheader) => {
      const distanceFromTop = Math.max(
        0,
        faqSubheader.getBoundingClientRect().top
      );
      if (distanceFromTop <= threshold && distanceFromTop > 0) {
        this.removeAllLinks();
        const faqSection = faqSubheader.closest(".faq__block--heading").id;
        const anchorElements = this.element.querySelectorAll(
          `a[href="#${faqSection}"]`
        );

        anchorElements.forEach((item) => {
          item.classList.add("is-active");

        });

        this.slideToActiveTab();
      }
    });
  }

  removeAllLinks() {
    const linkedItems = this.element.querySelectorAll(".is-active");
    linkedItems.forEach((item) => {
      item.classList.remove("is-active");
    });
  }
}

customElements.define("faq-section", FAQSection);

class NewsletterSection extends HTMLElement {
  constructor(){
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.toggleButton();
  }

  connectedCallback(){
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allRequiredFields = this.element.querySelectorAll("[data-state='required']");

    allRequiredFields.forEach((item) => {
      if (item.type === "checkbox" && !item.checked) {
        this.buttonState = false;
      } else if (item.type !== "checkbox" && item.value.trim() === "") {
        this.buttonState = false;
      }
    });

    if (this.buttonState === true) {
      this.element.querySelector(".section__newsletter-submit").removeAttribute("disabled");
    } else {
      this.element.querySelector(".section__newsletter-submit").setAttribute("disabled", true);
    }
  }
}
customElements.define('newsletter-section', NewsletterSection)
